// source: account-manager.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.accountmanager.AccountBalance', null, global);
goog.exportSymbol('proto.accountmanager.AccountCurrency', null, global);
goog.exportSymbol('proto.accountmanager.AccountDetails', null, global);
goog.exportSymbol('proto.accountmanager.AccountInfoLite', null, global);
goog.exportSymbol('proto.accountmanager.AccountLimit', null, global);
goog.exportSymbol('proto.accountmanager.AccountListReply', null, global);
goog.exportSymbol('proto.accountmanager.AccountListReq', null, global);
goog.exportSymbol('proto.accountmanager.AccountReconnect', null, global);
goog.exportSymbol('proto.accountmanager.AccountSymbol', null, global);
goog.exportSymbol('proto.accountmanager.AccountSymbolInfo', null, global);
goog.exportSymbol('proto.accountmanager.ActivateAnalyzerReply', null, global);
goog.exportSymbol('proto.accountmanager.ActivateAnalyzerReq', null, global);
goog.exportSymbol('proto.accountmanager.ActivateBetaConnectionReply', null, global);
goog.exportSymbol('proto.accountmanager.ActivateBetaConnectionReq', null, global);
goog.exportSymbol('proto.accountmanager.AddAccountReply', null, global);
goog.exportSymbol('proto.accountmanager.AddAccountReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminActivateBetaConnectionReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminActivateBetaConnectionReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddAccountReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddAccountReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddDedicatedPodReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddDedicatedPodReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddIpPoolReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddIpPoolReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddPoolReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddPoolReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddSymbolOverrideReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddSymbolOverrideReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddSymbolPoolReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminAddSymbolPoolReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminAutoMapSymbolsReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminAutoMapSymbolsReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminBlockAccountListReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminBlockAccountListReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminBlockAccountReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminBlockAccountReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminChangeAccountConnectionTypeReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminChangeAccountConnectionTypeReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminChangeAccountEnvReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminChangeAccountEnvReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminCloseAccountsTradesReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminCloseAccountsTradesReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminCompareSymbolsReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminCompareSymbolsReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminCopierLogsReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminCopierLogsReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteAccountReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteAccountReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteDedicatedPodReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteDedicatedPodReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteIpPoolReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteIpPoolReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeletePoolReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeletePoolReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteSymbolLotOverrideReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteSymbolLotOverrideReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteSymbolOverrideReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteSymbolOverrideReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteSymbolPoolReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminDeleteSymbolPoolReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminEnableAccountReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminEnableAccountReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminEnableAccountSymbolReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminEnableAccountSymbolReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminEnableAllAccountSymbolsReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminEnableAllAccountSymbolsReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetAccountInfoReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetAccountInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetAccountStatusReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetAccountStatusReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetClusterListReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetClusterListReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetEPSettingsReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetEPSettingsReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetMatchTraderUsersAccountListReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetMatchTraderUsersAccountListReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetTradeLockerUsersAccountListReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetTradeLockerUsersAccountListReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetUserAccountsReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetUserAccountsReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetUsersDedicatedEnvListReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminGetUsersDedicatedEnvListReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminGroupListReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminGroupListReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminListAccountSymbolsReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminListAccountSymbolsReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminListAccountsReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminListAccountsReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminListPoolsReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminListPoolsReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminListSymbolOverridesReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminListSymbolOverridesReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminMappedSymbolListReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminMappedSymbolListReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminSwitchConnectionClusterReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminSwitchConnectionClusterReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminSymbolLotOverrideReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminSymbolLotOverrideReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminSymbolStatsReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminSymbolStatsReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminSyncSymbolsReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminSyncSymbolsReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminUnmappedSymbolListReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminUnmappedSymbolListReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminUpdateDedicatedPodReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminUpdateDedicatedPodReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminUpdateIpPoolReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminUpdateIpPoolReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminUpdatePoolReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminUpdatePoolReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminUpdateSymbolOverrideReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminUpdateSymbolOverrideReq', null, global);
goog.exportSymbol('proto.accountmanager.AdminUpdateSymbolPoolReply', null, global);
goog.exportSymbol('proto.accountmanager.AdminUpdateSymbolPoolReq', null, global);
goog.exportSymbol('proto.accountmanager.AutoMapSymbolsReply', null, global);
goog.exportSymbol('proto.accountmanager.AutoMapSymbolsReq', null, global);
goog.exportSymbol('proto.accountmanager.BlockedAccount', null, global);
goog.exportSymbol('proto.accountmanager.CTraderAccountInfo', null, global);
goog.exportSymbol('proto.accountmanager.CTraderInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.CTraderProfile', null, global);
goog.exportSymbol('proto.accountmanager.ChangeAccountEnvReply', null, global);
goog.exportSymbol('proto.accountmanager.ChangeAccountEnvReq', null, global);
goog.exportSymbol('proto.accountmanager.CheckAvailableEnvReply', null, global);
goog.exportSymbol('proto.accountmanager.CheckAvailableEnvReq', null, global);
goog.exportSymbol('proto.accountmanager.CloseAccountsTradesReply', null, global);
goog.exportSymbol('proto.accountmanager.CloseAccountsTradesReq', null, global);
goog.exportSymbol('proto.accountmanager.CompareSymbolsReply', null, global);
goog.exportSymbol('proto.accountmanager.CompareSymbolsReq', null, global);
goog.exportSymbol('proto.accountmanager.ConnectionType', null, global);
goog.exportSymbol('proto.accountmanager.DedicatedEnv', null, global);
goog.exportSymbol('proto.accountmanager.DeleteAccountReply', null, global);
goog.exportSymbol('proto.accountmanager.DeleteAccountReq', null, global);
goog.exportSymbol('proto.accountmanager.DeleteCTraderAuthInfoReply', null, global);
goog.exportSymbol('proto.accountmanager.DeleteCTraderAuthInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.DeleteSymbolLotOverrideReply', null, global);
goog.exportSymbol('proto.accountmanager.DeleteSymbolLotOverrideReq', null, global);
goog.exportSymbol('proto.accountmanager.DeleteTradovateAuthInfoReply', null, global);
goog.exportSymbol('proto.accountmanager.DeleteTradovateAuthInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.DxtAccount', null, global);
goog.exportSymbol('proto.accountmanager.DxtInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.EnableAccountReply', null, global);
goog.exportSymbol('proto.accountmanager.EnableAccountReq', null, global);
goog.exportSymbol('proto.accountmanager.EnableAccountSymbolReply', null, global);
goog.exportSymbol('proto.accountmanager.EnableAccountSymbolReq', null, global);
goog.exportSymbol('proto.accountmanager.EnableAllAccountSymbolsReply', null, global);
goog.exportSymbol('proto.accountmanager.EnableAllAccountSymbolsReq', null, global);
goog.exportSymbol('proto.accountmanager.GetAccountInfoReply', null, global);
goog.exportSymbol('proto.accountmanager.GetAccountInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.GetAllowedCTraderAccountsReply', null, global);
goog.exportSymbol('proto.accountmanager.GetAllowedCTraderAccountsReq', null, global);
goog.exportSymbol('proto.accountmanager.GetAvailableDedicatedEnvVersionReply', null, global);
goog.exportSymbol('proto.accountmanager.GetAvailableDedicatedEnvVersionReq', null, global);
goog.exportSymbol('proto.accountmanager.GetCTraderAuthenticatedProfileListReply', null, global);
goog.exportSymbol('proto.accountmanager.GetCTraderAuthenticatedProfileListReq', null, global);
goog.exportSymbol('proto.accountmanager.GetDxtUsersAccountListReply', null, global);
goog.exportSymbol('proto.accountmanager.GetDxtUsersAccountListReq', null, global);
goog.exportSymbol('proto.accountmanager.GetEPSettingsReply', null, global);
goog.exportSymbol('proto.accountmanager.GetEPSettingsReq', null, global);
goog.exportSymbol('proto.accountmanager.GetMatchTraderUsersAccountListReply', null, global);
goog.exportSymbol('proto.accountmanager.GetMatchTraderUsersAccountListReq', null, global);
goog.exportSymbol('proto.accountmanager.GetTradeLockerUsersAccountListReply', null, global);
goog.exportSymbol('proto.accountmanager.GetTradeLockerUsersAccountListReq', null, global);
goog.exportSymbol('proto.accountmanager.GetTradovateProfileListReply', null, global);
goog.exportSymbol('proto.accountmanager.GetTradovateProfileListReq', null, global);
goog.exportSymbol('proto.accountmanager.GetTradovateUserAccountListReply', null, global);
goog.exportSymbol('proto.accountmanager.GetTradovateUserAccountListReq', null, global);
goog.exportSymbol('proto.accountmanager.GetUsersDedicatedEnvListReply', null, global);
goog.exportSymbol('proto.accountmanager.GetUsersDedicatedEnvListReq', null, global);
goog.exportSymbol('proto.accountmanager.GetUsersTradingPlatformsReply', null, global);
goog.exportSymbol('proto.accountmanager.GetUsersTradingPlatformsReq', null, global);
goog.exportSymbol('proto.accountmanager.GroupListReply', null, global);
goog.exportSymbol('proto.accountmanager.GroupListReq', null, global);
goog.exportSymbol('proto.accountmanager.IntAdjustActiveAccountsReply', null, global);
goog.exportSymbol('proto.accountmanager.IntAdjustActiveAccountsReq', null, global);
goog.exportSymbol('proto.accountmanager.IntAdjustDedicatedEnvReply', null, global);
goog.exportSymbol('proto.accountmanager.IntAdjustDedicatedEnvReq', null, global);
goog.exportSymbol('proto.accountmanager.IntChangeConnectionTypeBulkReply', null, global);
goog.exportSymbol('proto.accountmanager.IntChangeConnectionTypeBulkReq', null, global);
goog.exportSymbol('proto.accountmanager.IntCheckAllSymbolMappedReply', null, global);
goog.exportSymbol('proto.accountmanager.IntCheckAllSymbolMappedReq', null, global);
goog.exportSymbol('proto.accountmanager.IntConnectAccountBulkReply', null, global);
goog.exportSymbol('proto.accountmanager.IntConnectAccountBulkReq', null, global);
goog.exportSymbol('proto.accountmanager.IntEnableAccountsReply', null, global);
goog.exportSymbol('proto.accountmanager.IntEnableAccountsReq', null, global);
goog.exportSymbol('proto.accountmanager.IntFilterSymbolReply', null, global);
goog.exportSymbol('proto.accountmanager.IntFilterSymbolReq', null, global);
goog.exportSymbol('proto.accountmanager.IntGetAccountCurrenciesReply', null, global);
goog.exportSymbol('proto.accountmanager.IntGetAccountCurrenciesReq', null, global);
goog.exportSymbol('proto.accountmanager.IntGetAccountDetailsReply', null, global);
goog.exportSymbol('proto.accountmanager.IntGetAccountDetailsReq', null, global);
goog.exportSymbol('proto.accountmanager.IntGetAccountsInfoReply', null, global);
goog.exportSymbol('proto.accountmanager.IntGetAccountsInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.IntGetAccountsWithIDsReply', null, global);
goog.exportSymbol('proto.accountmanager.IntGetAccountsWithIDsReq', null, global);
goog.exportSymbol('proto.accountmanager.IntGetTotalAndTodaysAccountCountReply', null, global);
goog.exportSymbol('proto.accountmanager.IntGetTotalAndTodaysAccountCountReq', null, global);
goog.exportSymbol('proto.accountmanager.IntGetUserAccountCountReply', null, global);
goog.exportSymbol('proto.accountmanager.IntGetUserAccountCountReq', null, global);
goog.exportSymbol('proto.accountmanager.IntGetUsersAccountCountReply', null, global);
goog.exportSymbol('proto.accountmanager.IntGetUsersAccountCountReq', null, global);
goog.exportSymbol('proto.accountmanager.IntInternalAccountsInfoReply', null, global);
goog.exportSymbol('proto.accountmanager.IntInternalAccountsInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.IntReactivateAccountsReply', null, global);
goog.exportSymbol('proto.accountmanager.IntReactivateAccountsReq', null, global);
goog.exportSymbol('proto.accountmanager.IntSymbolExistsInAccountReply', null, global);
goog.exportSymbol('proto.accountmanager.IntSymbolExistsInAccountReq', null, global);
goog.exportSymbol('proto.accountmanager.IntSyncCurrencyReply', null, global);
goog.exportSymbol('proto.accountmanager.IntSyncCurrencyReq', null, global);
goog.exportSymbol('proto.accountmanager.IntSyncProxyConnectionsReply', null, global);
goog.exportSymbol('proto.accountmanager.IntSyncProxyConnectionsReq', null, global);
goog.exportSymbol('proto.accountmanager.IntSyncSymbolsReply', null, global);
goog.exportSymbol('proto.accountmanager.IntSyncSymbolsReq', null, global);
goog.exportSymbol('proto.accountmanager.IntUpdateAccountServerTimeZoneReply', null, global);
goog.exportSymbol('proto.accountmanager.IntUpdateAccountServerTimeZoneReq', null, global);
goog.exportSymbol('proto.accountmanager.IntUpdateSymbolInfoReply', null, global);
goog.exportSymbol('proto.accountmanager.IntUpdateSymbolInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.IntUserActiveAccountsReply', null, global);
goog.exportSymbol('proto.accountmanager.IntUserActiveAccountsReq', null, global);
goog.exportSymbol('proto.accountmanager.InternalAccountDetails', null, global);
goog.exportSymbol('proto.accountmanager.ListAccountSymbolsReply', null, global);
goog.exportSymbol('proto.accountmanager.ListAccountSymbolsReq', null, global);
goog.exportSymbol('proto.accountmanager.ListCopiedTradesReply', null, global);
goog.exportSymbol('proto.accountmanager.ListCopiedTradesReq', null, global);
goog.exportSymbol('proto.accountmanager.Log', null, global);
goog.exportSymbol('proto.accountmanager.MappedSymbol', null, global);
goog.exportSymbol('proto.accountmanager.MappedSymbolListReply', null, global);
goog.exportSymbol('proto.accountmanager.MappedSymbolListReq', null, global);
goog.exportSymbol('proto.accountmanager.MasterTrade', null, global);
goog.exportSymbol('proto.accountmanager.MatchTraderAccount', null, global);
goog.exportSymbol('proto.accountmanager.MatchTreaderInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.OpenTradeWarningReply', null, global);
goog.exportSymbol('proto.accountmanager.OpenTradeWarningReq', null, global);
goog.exportSymbol('proto.accountmanager.Pool', null, global);
goog.exportSymbol('proto.accountmanager.SaveCTraderAuthInfoReply', null, global);
goog.exportSymbol('proto.accountmanager.SaveCTraderAuthInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.SaveTradovateAuthInfoReply', null, global);
goog.exportSymbol('proto.accountmanager.SaveTradovateAuthInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.Symbol', null, global);
goog.exportSymbol('proto.accountmanager.SymbolInfo', null, global);
goog.exportSymbol('proto.accountmanager.SymbolLotOverrideReply', null, global);
goog.exportSymbol('proto.accountmanager.SymbolLotOverrideReq', null, global);
goog.exportSymbol('proto.accountmanager.SymbolOverride', null, global);
goog.exportSymbol('proto.accountmanager.SymbolPool', null, global);
goog.exportSymbol('proto.accountmanager.SymbolStatsReply', null, global);
goog.exportSymbol('proto.accountmanager.SymbolStatsReq', null, global);
goog.exportSymbol('proto.accountmanager.TimelyReset', null, global);
goog.exportSymbol('proto.accountmanager.Trade', null, global);
goog.exportSymbol('proto.accountmanager.TradeLockerAccount', null, global);
goog.exportSymbol('proto.accountmanager.TradeLockerInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.TradovateInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.TradovateProfile', null, global);
goog.exportSymbol('proto.accountmanager.TradovateUserAccount', null, global);
goog.exportSymbol('proto.accountmanager.UnmappedSymbol', null, global);
goog.exportSymbol('proto.accountmanager.UnmappedSymbolListReply', null, global);
goog.exportSymbol('proto.accountmanager.UnmappedSymbolListReq', null, global);
goog.exportSymbol('proto.accountmanager.UpdateAccountReply', null, global);
goog.exportSymbol('proto.accountmanager.UpdateAccountReq', null, global);
goog.exportSymbol('proto.accountmanager.UpdateCTraderAuthInfoReply', null, global);
goog.exportSymbol('proto.accountmanager.UpdateCTraderAuthInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.UpdateDedicatedEnvReply', null, global);
goog.exportSymbol('proto.accountmanager.UpdateDedicatedEnvReq', null, global);
goog.exportSymbol('proto.accountmanager.UpdateTradovateAuthInfoReply', null, global);
goog.exportSymbol('proto.accountmanager.UpdateTradovateAuthInfoReq', null, global);
goog.exportSymbol('proto.accountmanager.UpsertEPSettingsReply', null, global);
goog.exportSymbol('proto.accountmanager.UpsertEPSettingsReq', null, global);
goog.exportSymbol('proto.accountmanager.UserAccount', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminBlockAccountListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminBlockAccountListReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminBlockAccountListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminBlockAccountListReq.displayName = 'proto.accountmanager.AdminBlockAccountListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.BlockedAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.BlockedAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.BlockedAccount.displayName = 'proto.accountmanager.BlockedAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminBlockAccountListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminBlockAccountListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminBlockAccountListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminBlockAccountListReply.displayName = 'proto.accountmanager.AdminBlockAccountListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminBlockAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminBlockAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminBlockAccountReq.displayName = 'proto.accountmanager.AdminBlockAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminBlockAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminBlockAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminBlockAccountReply.displayName = 'proto.accountmanager.AdminBlockAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetUsersTradingPlatformsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetUsersTradingPlatformsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetUsersTradingPlatformsReq.displayName = 'proto.accountmanager.GetUsersTradingPlatformsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetUsersTradingPlatformsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GetUsersTradingPlatformsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GetUsersTradingPlatformsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetUsersTradingPlatformsReply.displayName = 'proto.accountmanager.GetUsersTradingPlatformsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetTradovateUserAccountListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetTradovateUserAccountListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetTradovateUserAccountListReq.displayName = 'proto.accountmanager.GetTradovateUserAccountListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.TradovateUserAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.TradovateUserAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.TradovateUserAccount.displayName = 'proto.accountmanager.TradovateUserAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetTradovateUserAccountListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GetTradovateUserAccountListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GetTradovateUserAccountListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetTradovateUserAccountListReply.displayName = 'proto.accountmanager.GetTradovateUserAccountListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.SaveTradovateAuthInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.SaveTradovateAuthInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.SaveTradovateAuthInfoReq.displayName = 'proto.accountmanager.SaveTradovateAuthInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.SaveTradovateAuthInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.SaveTradovateAuthInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.SaveTradovateAuthInfoReply.displayName = 'proto.accountmanager.SaveTradovateAuthInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UpdateTradovateAuthInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UpdateTradovateAuthInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UpdateTradovateAuthInfoReq.displayName = 'proto.accountmanager.UpdateTradovateAuthInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UpdateTradovateAuthInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UpdateTradovateAuthInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UpdateTradovateAuthInfoReply.displayName = 'proto.accountmanager.UpdateTradovateAuthInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.DeleteTradovateAuthInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.DeleteTradovateAuthInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.DeleteTradovateAuthInfoReq.displayName = 'proto.accountmanager.DeleteTradovateAuthInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.DeleteTradovateAuthInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.DeleteTradovateAuthInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.DeleteTradovateAuthInfoReply.displayName = 'proto.accountmanager.DeleteTradovateAuthInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetTradovateProfileListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetTradovateProfileListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetTradovateProfileListReq.displayName = 'proto.accountmanager.GetTradovateProfileListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetTradovateProfileListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GetTradovateProfileListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GetTradovateProfileListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetTradovateProfileListReply.displayName = 'proto.accountmanager.GetTradovateProfileListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.TradovateProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.TradovateProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.TradovateProfile.displayName = 'proto.accountmanager.TradovateProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminChangeAccountConnectionTypeReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminChangeAccountConnectionTypeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminChangeAccountConnectionTypeReq.displayName = 'proto.accountmanager.AdminChangeAccountConnectionTypeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminChangeAccountConnectionTypeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminChangeAccountConnectionTypeReply.displayName = 'proto.accountmanager.AdminChangeAccountConnectionTypeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntChangeConnectionTypeBulkReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntChangeConnectionTypeBulkReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntChangeConnectionTypeBulkReq.displayName = 'proto.accountmanager.IntChangeConnectionTypeBulkReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntChangeConnectionTypeBulkReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntChangeConnectionTypeBulkReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntChangeConnectionTypeBulkReply.displayName = 'proto.accountmanager.IntChangeConnectionTypeBulkReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.TradeLockerAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.TradeLockerAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.TradeLockerAccount.displayName = 'proto.accountmanager.TradeLockerAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminGetTradeLockerUsersAccountListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.displayName = 'proto.accountmanager.AdminGetTradeLockerUsersAccountListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminGetTradeLockerUsersAccountListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.displayName = 'proto.accountmanager.AdminGetTradeLockerUsersAccountListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetTradeLockerUsersAccountListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetTradeLockerUsersAccountListReq.displayName = 'proto.accountmanager.GetTradeLockerUsersAccountListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetTradeLockerUsersAccountListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GetTradeLockerUsersAccountListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GetTradeLockerUsersAccountListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetTradeLockerUsersAccountListReply.displayName = 'proto.accountmanager.GetTradeLockerUsersAccountListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.MatchTraderAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.MatchTraderAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.MatchTraderAccount.displayName = 'proto.accountmanager.MatchTraderAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminGetMatchTraderUsersAccountListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.displayName = 'proto.accountmanager.AdminGetMatchTraderUsersAccountListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminGetMatchTraderUsersAccountListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.displayName = 'proto.accountmanager.AdminGetMatchTraderUsersAccountListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetMatchTraderUsersAccountListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetMatchTraderUsersAccountListReq.displayName = 'proto.accountmanager.GetMatchTraderUsersAccountListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetMatchTraderUsersAccountListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GetMatchTraderUsersAccountListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GetMatchTraderUsersAccountListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetMatchTraderUsersAccountListReply.displayName = 'proto.accountmanager.GetMatchTraderUsersAccountListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetDxtUsersAccountListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetDxtUsersAccountListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetDxtUsersAccountListReq.displayName = 'proto.accountmanager.GetDxtUsersAccountListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.DxtAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.DxtAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.DxtAccount.displayName = 'proto.accountmanager.DxtAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetDxtUsersAccountListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GetDxtUsersAccountListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GetDxtUsersAccountListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetDxtUsersAccountListReply.displayName = 'proto.accountmanager.GetDxtUsersAccountListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntUpdateAccountServerTimeZoneReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntUpdateAccountServerTimeZoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntUpdateAccountServerTimeZoneReq.displayName = 'proto.accountmanager.IntUpdateAccountServerTimeZoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntUpdateAccountServerTimeZoneReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntUpdateAccountServerTimeZoneReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntUpdateAccountServerTimeZoneReply.displayName = 'proto.accountmanager.IntUpdateAccountServerTimeZoneReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.ChangeAccountEnvReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.ChangeAccountEnvReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.ChangeAccountEnvReq.displayName = 'proto.accountmanager.ChangeAccountEnvReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetAvailableDedicatedEnvVersionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetAvailableDedicatedEnvVersionReq.displayName = 'proto.accountmanager.GetAvailableDedicatedEnvVersionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GetAvailableDedicatedEnvVersionReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GetAvailableDedicatedEnvVersionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetAvailableDedicatedEnvVersionReply.displayName = 'proto.accountmanager.GetAvailableDedicatedEnvVersionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.ChangeAccountEnvReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.ChangeAccountEnvReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.ChangeAccountEnvReply.displayName = 'proto.accountmanager.ChangeAccountEnvReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.CheckAvailableEnvReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.CheckAvailableEnvReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.CheckAvailableEnvReq.displayName = 'proto.accountmanager.CheckAvailableEnvReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.CheckAvailableEnvReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.CheckAvailableEnvReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.CheckAvailableEnvReply.displayName = 'proto.accountmanager.CheckAvailableEnvReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntAdjustDedicatedEnvReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntAdjustDedicatedEnvReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntAdjustDedicatedEnvReq.displayName = 'proto.accountmanager.IntAdjustDedicatedEnvReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntAdjustDedicatedEnvReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntAdjustDedicatedEnvReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntAdjustDedicatedEnvReply.displayName = 'proto.accountmanager.IntAdjustDedicatedEnvReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddIpPoolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddIpPoolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddIpPoolReq.displayName = 'proto.accountmanager.AdminAddIpPoolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddIpPoolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddIpPoolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddIpPoolReply.displayName = 'proto.accountmanager.AdminAddIpPoolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddDedicatedPodReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddDedicatedPodReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddDedicatedPodReq.displayName = 'proto.accountmanager.AdminAddDedicatedPodReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddDedicatedPodReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddDedicatedPodReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddDedicatedPodReply.displayName = 'proto.accountmanager.AdminAddDedicatedPodReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUpdateIpPoolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminUpdateIpPoolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUpdateIpPoolReq.displayName = 'proto.accountmanager.AdminUpdateIpPoolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUpdateIpPoolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminUpdateIpPoolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUpdateIpPoolReply.displayName = 'proto.accountmanager.AdminUpdateIpPoolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUpdateDedicatedPodReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminUpdateDedicatedPodReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUpdateDedicatedPodReq.displayName = 'proto.accountmanager.AdminUpdateDedicatedPodReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUpdateDedicatedPodReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminUpdateDedicatedPodReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUpdateDedicatedPodReply.displayName = 'proto.accountmanager.AdminUpdateDedicatedPodReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteIpPoolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeleteIpPoolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteIpPoolReq.displayName = 'proto.accountmanager.AdminDeleteIpPoolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteIpPoolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeleteIpPoolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteIpPoolReply.displayName = 'proto.accountmanager.AdminDeleteIpPoolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteDedicatedPodReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeleteDedicatedPodReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteDedicatedPodReq.displayName = 'proto.accountmanager.AdminDeleteDedicatedPodReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteDedicatedPodReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeleteDedicatedPodReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteDedicatedPodReply.displayName = 'proto.accountmanager.AdminDeleteDedicatedPodReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UpdateDedicatedEnvReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UpdateDedicatedEnvReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UpdateDedicatedEnvReq.displayName = 'proto.accountmanager.UpdateDedicatedEnvReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UpdateDedicatedEnvReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UpdateDedicatedEnvReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UpdateDedicatedEnvReply.displayName = 'proto.accountmanager.UpdateDedicatedEnvReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetUsersDedicatedEnvListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetUsersDedicatedEnvListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetUsersDedicatedEnvListReq.displayName = 'proto.accountmanager.GetUsersDedicatedEnvListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.DedicatedEnv = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.DedicatedEnv, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.DedicatedEnv.displayName = 'proto.accountmanager.DedicatedEnv';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetUsersDedicatedEnvListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GetUsersDedicatedEnvListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GetUsersDedicatedEnvListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetUsersDedicatedEnvListReply.displayName = 'proto.accountmanager.GetUsersDedicatedEnvListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminCloseAccountsTradesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminCloseAccountsTradesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminCloseAccountsTradesReq.displayName = 'proto.accountmanager.AdminCloseAccountsTradesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminCloseAccountsTradesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminCloseAccountsTradesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminCloseAccountsTradesReply.displayName = 'proto.accountmanager.AdminCloseAccountsTradesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetEPSettingsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminGetEPSettingsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetEPSettingsReq.displayName = 'proto.accountmanager.AdminGetEPSettingsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetEPSettingsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminGetEPSettingsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetEPSettingsReply.displayName = 'proto.accountmanager.AdminGetEPSettingsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeleteAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteAccountReq.displayName = 'proto.accountmanager.AdminDeleteAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeleteAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteAccountReply.displayName = 'proto.accountmanager.AdminDeleteAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.CloseAccountsTradesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.CloseAccountsTradesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.CloseAccountsTradesReq.displayName = 'proto.accountmanager.CloseAccountsTradesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.CloseAccountsTradesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.CloseAccountsTradesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.CloseAccountsTradesReply.displayName = 'proto.accountmanager.CloseAccountsTradesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetEPSettingsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetEPSettingsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetEPSettingsReq.displayName = 'proto.accountmanager.GetEPSettingsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetEPSettingsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetEPSettingsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetEPSettingsReply.displayName = 'proto.accountmanager.GetEPSettingsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UpsertEPSettingsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UpsertEPSettingsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UpsertEPSettingsReq.displayName = 'proto.accountmanager.UpsertEPSettingsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UpsertEPSettingsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UpsertEPSettingsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UpsertEPSettingsReply.displayName = 'proto.accountmanager.UpsertEPSettingsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminSyncSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminSyncSymbolsReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminSyncSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminSyncSymbolsReq.displayName = 'proto.accountmanager.AdminSyncSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminSyncSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminSyncSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminSyncSymbolsReply.displayName = 'proto.accountmanager.AdminSyncSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminEnableAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminEnableAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminEnableAccountReq.displayName = 'proto.accountmanager.AdminEnableAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminEnableAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminEnableAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminEnableAccountReply.displayName = 'proto.accountmanager.AdminEnableAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminListAccountSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminListAccountSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminListAccountSymbolsReq.displayName = 'proto.accountmanager.AdminListAccountSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminListAccountSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminListAccountSymbolsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminListAccountSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminListAccountSymbolsReply.displayName = 'proto.accountmanager.AdminListAccountSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminCopierLogsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminCopierLogsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminCopierLogsReq.displayName = 'proto.accountmanager.AdminCopierLogsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminCopierLogsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminCopierLogsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminCopierLogsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminCopierLogsReply.displayName = 'proto.accountmanager.AdminCopierLogsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetAccountStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminGetAccountStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetAccountStatusReq.displayName = 'proto.accountmanager.AdminGetAccountStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetAccountStatusReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminGetAccountStatusReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetAccountStatusReply.displayName = 'proto.accountmanager.AdminGetAccountStatusReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminListAccountsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminListAccountsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminListAccountsReq.displayName = 'proto.accountmanager.AdminListAccountsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminListAccountsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminListAccountsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminListAccountsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminListAccountsReply.displayName = 'proto.accountmanager.AdminListAccountsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntGetTotalAndTodaysAccountCountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetTotalAndTodaysAccountCountReq.displayName = 'proto.accountmanager.IntGetTotalAndTodaysAccountCountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntGetTotalAndTodaysAccountCountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.displayName = 'proto.accountmanager.IntGetTotalAndTodaysAccountCountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetUserAccountsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminGetUserAccountsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetUserAccountsReq.displayName = 'proto.accountmanager.AdminGetUserAccountsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetUserAccountsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminGetUserAccountsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminGetUserAccountsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetUserAccountsReply.displayName = 'proto.accountmanager.AdminGetUserAccountsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UserAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UserAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UserAccount.displayName = 'proto.accountmanager.UserAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetUsersAccountCountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntGetUsersAccountCountReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntGetUsersAccountCountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetUsersAccountCountReq.displayName = 'proto.accountmanager.IntGetUsersAccountCountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetUsersAccountCountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntGetUsersAccountCountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetUsersAccountCountReply.displayName = 'proto.accountmanager.IntGetUsersAccountCountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetUserAccountCountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntGetUserAccountCountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetUserAccountCountReq.displayName = 'proto.accountmanager.IntGetUserAccountCountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetUserAccountCountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntGetUserAccountCountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetUserAccountCountReply.displayName = 'proto.accountmanager.IntGetUserAccountCountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddAccountReq.displayName = 'proto.accountmanager.AdminAddAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddAccountReply.displayName = 'proto.accountmanager.AdminAddAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AddAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AddAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AddAccountReq.displayName = 'proto.accountmanager.AddAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.TradeLockerInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.TradeLockerInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.TradeLockerInfoReq.displayName = 'proto.accountmanager.TradeLockerInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.MatchTreaderInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.MatchTreaderInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.MatchTreaderInfoReq.displayName = 'proto.accountmanager.MatchTreaderInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.DxtInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.DxtInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.DxtInfoReq.displayName = 'proto.accountmanager.DxtInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.CTraderInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.CTraderInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.CTraderInfoReq.displayName = 'proto.accountmanager.CTraderInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.TradovateInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.TradovateInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.TradovateInfoReq.displayName = 'proto.accountmanager.TradovateInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AddAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AddAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AddAccountReply.displayName = 'proto.accountmanager.AddAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetAccountInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminGetAccountInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetAccountInfoReq.displayName = 'proto.accountmanager.AdminGetAccountInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetAccountInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminGetAccountInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetAccountInfoReply.displayName = 'proto.accountmanager.AdminGetAccountInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetAccountInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetAccountInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetAccountInfoReq.displayName = 'proto.accountmanager.GetAccountInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetAccountInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetAccountInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetAccountInfoReply.displayName = 'proto.accountmanager.GetAccountInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.DeleteAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.DeleteAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.DeleteAccountReq.displayName = 'proto.accountmanager.DeleteAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.DeleteAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.DeleteAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.DeleteAccountReply.displayName = 'proto.accountmanager.DeleteAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AccountListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AccountListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AccountListReq.displayName = 'proto.accountmanager.AccountListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AccountListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AccountListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AccountListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AccountListReply.displayName = 'proto.accountmanager.AccountListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AccountInfoLite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AccountInfoLite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AccountInfoLite.displayName = 'proto.accountmanager.AccountInfoLite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UpdateAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UpdateAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UpdateAccountReq.displayName = 'proto.accountmanager.UpdateAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UpdateAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UpdateAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UpdateAccountReply.displayName = 'proto.accountmanager.UpdateAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.EnableAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.EnableAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.EnableAccountReq.displayName = 'proto.accountmanager.EnableAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.EnableAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.EnableAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.EnableAccountReply.displayName = 'proto.accountmanager.EnableAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.ActivateBetaConnectionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.ActivateBetaConnectionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.ActivateBetaConnectionReq.displayName = 'proto.accountmanager.ActivateBetaConnectionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.ActivateBetaConnectionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.ActivateBetaConnectionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.ActivateBetaConnectionReply.displayName = 'proto.accountmanager.ActivateBetaConnectionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminActivateBetaConnectionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminActivateBetaConnectionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminActivateBetaConnectionReq.displayName = 'proto.accountmanager.AdminActivateBetaConnectionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminActivateBetaConnectionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminActivateBetaConnectionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminActivateBetaConnectionReply.displayName = 'proto.accountmanager.AdminActivateBetaConnectionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.ListAccountSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.ListAccountSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.ListAccountSymbolsReq.displayName = 'proto.accountmanager.ListAccountSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.ListAccountSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.ListAccountSymbolsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.ListAccountSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.ListAccountSymbolsReply.displayName = 'proto.accountmanager.ListAccountSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.Symbol = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.Symbol, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.Symbol.displayName = 'proto.accountmanager.Symbol';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.SymbolInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.SymbolInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.SymbolInfo.displayName = 'proto.accountmanager.SymbolInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.EnableAccountSymbolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.EnableAccountSymbolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.EnableAccountSymbolReq.displayName = 'proto.accountmanager.EnableAccountSymbolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.EnableAccountSymbolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.EnableAccountSymbolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.EnableAccountSymbolReply.displayName = 'proto.accountmanager.EnableAccountSymbolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.EnableAllAccountSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.EnableAllAccountSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.EnableAllAccountSymbolsReq.displayName = 'proto.accountmanager.EnableAllAccountSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.EnableAllAccountSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.EnableAllAccountSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.EnableAllAccountSymbolsReply.displayName = 'proto.accountmanager.EnableAllAccountSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.ListCopiedTradesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.ListCopiedTradesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.ListCopiedTradesReq.displayName = 'proto.accountmanager.ListCopiedTradesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.ListCopiedTradesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.ListCopiedTradesReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.ListCopiedTradesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.ListCopiedTradesReply.displayName = 'proto.accountmanager.ListCopiedTradesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.Trade = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.Trade.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.Trade, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.Trade.displayName = 'proto.accountmanager.Trade';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.Log = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.Log, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.Log.displayName = 'proto.accountmanager.Log';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.MasterTrade = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.MasterTrade, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.MasterTrade.displayName = 'proto.accountmanager.MasterTrade';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.CompareSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.CompareSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.CompareSymbolsReq.displayName = 'proto.accountmanager.CompareSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.CompareSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.CompareSymbolsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.CompareSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.CompareSymbolsReply.displayName = 'proto.accountmanager.CompareSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetAccountsWithIDsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntGetAccountsWithIDsReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntGetAccountsWithIDsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetAccountsWithIDsReq.displayName = 'proto.accountmanager.IntGetAccountsWithIDsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetAccountsWithIDsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntGetAccountsWithIDsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntGetAccountsWithIDsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetAccountsWithIDsReply.displayName = 'proto.accountmanager.IntGetAccountsWithIDsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AccountBalance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AccountBalance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AccountBalance.displayName = 'proto.accountmanager.AccountBalance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetAccountsInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntGetAccountsInfoReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntGetAccountsInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetAccountsInfoReq.displayName = 'proto.accountmanager.IntGetAccountsInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetAccountsInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntGetAccountsInfoReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntGetAccountsInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetAccountsInfoReply.displayName = 'proto.accountmanager.IntGetAccountsInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntAdjustActiveAccountsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntAdjustActiveAccountsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntAdjustActiveAccountsReq.displayName = 'proto.accountmanager.IntAdjustActiveAccountsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntReactivateAccountsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntReactivateAccountsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntReactivateAccountsReq.displayName = 'proto.accountmanager.IntReactivateAccountsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntReactivateAccountsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntReactivateAccountsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntReactivateAccountsReply.displayName = 'proto.accountmanager.IntReactivateAccountsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AccountLimit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AccountLimit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AccountLimit.displayName = 'proto.accountmanager.AccountLimit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntAdjustActiveAccountsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntAdjustActiveAccountsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntAdjustActiveAccountsReply.displayName = 'proto.accountmanager.IntAdjustActiveAccountsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntConnectAccountBulkReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntConnectAccountBulkReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntConnectAccountBulkReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntConnectAccountBulkReq.displayName = 'proto.accountmanager.IntConnectAccountBulkReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntConnectAccountBulkReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntConnectAccountBulkReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntConnectAccountBulkReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntConnectAccountBulkReply.displayName = 'proto.accountmanager.IntConnectAccountBulkReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntFilterSymbolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntFilterSymbolReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntFilterSymbolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntFilterSymbolReq.displayName = 'proto.accountmanager.IntFilterSymbolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AccountSymbol = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AccountSymbol, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AccountSymbol.displayName = 'proto.accountmanager.AccountSymbol';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntFilterSymbolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntFilterSymbolReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntFilterSymbolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntFilterSymbolReply.displayName = 'proto.accountmanager.IntFilterSymbolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AccountSymbolInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AccountSymbolInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AccountSymbolInfo.displayName = 'proto.accountmanager.AccountSymbolInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntSyncSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntSyncSymbolsReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntSyncSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntSyncSymbolsReq.displayName = 'proto.accountmanager.IntSyncSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntSyncSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntSyncSymbolsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntSyncSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntSyncSymbolsReply.displayName = 'proto.accountmanager.IntSyncSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntSyncProxyConnectionsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntSyncProxyConnectionsReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntSyncProxyConnectionsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntSyncProxyConnectionsReq.displayName = 'proto.accountmanager.IntSyncProxyConnectionsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntSyncProxyConnectionsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntSyncProxyConnectionsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntSyncProxyConnectionsReply.displayName = 'proto.accountmanager.IntSyncProxyConnectionsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetAccountCurrenciesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntGetAccountCurrenciesReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntGetAccountCurrenciesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetAccountCurrenciesReq.displayName = 'proto.accountmanager.IntGetAccountCurrenciesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetAccountCurrenciesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntGetAccountCurrenciesReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntGetAccountCurrenciesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetAccountCurrenciesReply.displayName = 'proto.accountmanager.IntGetAccountCurrenciesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AccountCurrency = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AccountCurrency, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AccountCurrency.displayName = 'proto.accountmanager.AccountCurrency';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntSyncCurrencyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntSyncCurrencyReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntSyncCurrencyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntSyncCurrencyReq.displayName = 'proto.accountmanager.IntSyncCurrencyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntSyncCurrencyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntSyncCurrencyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntSyncCurrencyReply.displayName = 'proto.accountmanager.IntSyncCurrencyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntCheckAllSymbolMappedReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntCheckAllSymbolMappedReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntCheckAllSymbolMappedReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntCheckAllSymbolMappedReq.displayName = 'proto.accountmanager.IntCheckAllSymbolMappedReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntCheckAllSymbolMappedReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntCheckAllSymbolMappedReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntCheckAllSymbolMappedReply.displayName = 'proto.accountmanager.IntCheckAllSymbolMappedReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntEnableAccountsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntEnableAccountsReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntEnableAccountsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntEnableAccountsReq.displayName = 'proto.accountmanager.IntEnableAccountsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntEnableAccountsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntEnableAccountsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntEnableAccountsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntEnableAccountsReply.displayName = 'proto.accountmanager.IntEnableAccountsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntUserActiveAccountsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntUserActiveAccountsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntUserActiveAccountsReq.displayName = 'proto.accountmanager.IntUserActiveAccountsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntUserActiveAccountsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntUserActiveAccountsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntUserActiveAccountsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntUserActiveAccountsReply.displayName = 'proto.accountmanager.IntUserActiveAccountsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetAccountDetailsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntGetAccountDetailsReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntGetAccountDetailsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetAccountDetailsReq.displayName = 'proto.accountmanager.IntGetAccountDetailsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntGetAccountDetailsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntGetAccountDetailsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntGetAccountDetailsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntGetAccountDetailsReply.displayName = 'proto.accountmanager.IntGetAccountDetailsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AccountDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AccountDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AccountDetails.displayName = 'proto.accountmanager.AccountDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.SymbolStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.SymbolStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.SymbolStatsReq.displayName = 'proto.accountmanager.SymbolStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.SymbolStatsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.SymbolStatsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.SymbolStatsReply.displayName = 'proto.accountmanager.SymbolStatsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UnmappedSymbolListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UnmappedSymbolListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UnmappedSymbolListReq.displayName = 'proto.accountmanager.UnmappedSymbolListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UnmappedSymbolListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.UnmappedSymbolListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.UnmappedSymbolListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UnmappedSymbolListReply.displayName = 'proto.accountmanager.UnmappedSymbolListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UnmappedSymbol = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UnmappedSymbol, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UnmappedSymbol.displayName = 'proto.accountmanager.UnmappedSymbol';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AutoMapSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AutoMapSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AutoMapSymbolsReq.displayName = 'proto.accountmanager.AutoMapSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AutoMapSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AutoMapSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AutoMapSymbolsReply.displayName = 'proto.accountmanager.AutoMapSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.MappedSymbolListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.MappedSymbolListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.MappedSymbolListReq.displayName = 'proto.accountmanager.MappedSymbolListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.MappedSymbolListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.MappedSymbolListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.MappedSymbolListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.MappedSymbolListReply.displayName = 'proto.accountmanager.MappedSymbolListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.MappedSymbol = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.MappedSymbol, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.MappedSymbol.displayName = 'proto.accountmanager.MappedSymbol';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GroupListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GroupListReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GroupListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GroupListReq.displayName = 'proto.accountmanager.GroupListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GroupListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GroupListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GroupListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GroupListReply.displayName = 'proto.accountmanager.GroupListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntUpdateSymbolInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntUpdateSymbolInfoReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntUpdateSymbolInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntUpdateSymbolInfoReq.displayName = 'proto.accountmanager.IntUpdateSymbolInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntUpdateSymbolInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntUpdateSymbolInfoReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntUpdateSymbolInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntUpdateSymbolInfoReply.displayName = 'proto.accountmanager.IntUpdateSymbolInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddSymbolOverrideReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddSymbolOverrideReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddSymbolOverrideReq.displayName = 'proto.accountmanager.AdminAddSymbolOverrideReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddSymbolOverrideReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddSymbolOverrideReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddSymbolOverrideReply.displayName = 'proto.accountmanager.AdminAddSymbolOverrideReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminListSymbolOverridesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminListSymbolOverridesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminListSymbolOverridesReq.displayName = 'proto.accountmanager.AdminListSymbolOverridesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminListSymbolOverridesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminListSymbolOverridesReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminListSymbolOverridesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminListSymbolOverridesReply.displayName = 'proto.accountmanager.AdminListSymbolOverridesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.SymbolOverride = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.SymbolOverride, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.SymbolOverride.displayName = 'proto.accountmanager.SymbolOverride';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteSymbolOverrideReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeleteSymbolOverrideReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteSymbolOverrideReq.displayName = 'proto.accountmanager.AdminDeleteSymbolOverrideReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteSymbolOverrideReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeleteSymbolOverrideReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteSymbolOverrideReply.displayName = 'proto.accountmanager.AdminDeleteSymbolOverrideReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminUpdateSymbolOverrideReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUpdateSymbolOverrideReq.displayName = 'proto.accountmanager.AdminUpdateSymbolOverrideReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUpdateSymbolOverrideReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminUpdateSymbolOverrideReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUpdateSymbolOverrideReply.displayName = 'proto.accountmanager.AdminUpdateSymbolOverrideReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminCompareSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminCompareSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminCompareSymbolsReq.displayName = 'proto.accountmanager.AdminCompareSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminCompareSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminCompareSymbolsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminCompareSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminCompareSymbolsReply.displayName = 'proto.accountmanager.AdminCompareSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminSymbolStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminSymbolStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminSymbolStatsReq.displayName = 'proto.accountmanager.AdminSymbolStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminSymbolStatsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminSymbolStatsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminSymbolStatsReply.displayName = 'proto.accountmanager.AdminSymbolStatsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUnmappedSymbolListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminUnmappedSymbolListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUnmappedSymbolListReq.displayName = 'proto.accountmanager.AdminUnmappedSymbolListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUnmappedSymbolListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminUnmappedSymbolListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminUnmappedSymbolListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUnmappedSymbolListReply.displayName = 'proto.accountmanager.AdminUnmappedSymbolListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAutoMapSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAutoMapSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAutoMapSymbolsReq.displayName = 'proto.accountmanager.AdminAutoMapSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAutoMapSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAutoMapSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAutoMapSymbolsReply.displayName = 'proto.accountmanager.AdminAutoMapSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminMappedSymbolListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminMappedSymbolListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminMappedSymbolListReq.displayName = 'proto.accountmanager.AdminMappedSymbolListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminMappedSymbolListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminMappedSymbolListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminMappedSymbolListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminMappedSymbolListReply.displayName = 'proto.accountmanager.AdminMappedSymbolListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGroupListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminGroupListReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminGroupListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGroupListReq.displayName = 'proto.accountmanager.AdminGroupListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGroupListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminGroupListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminGroupListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGroupListReply.displayName = 'proto.accountmanager.AdminGroupListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminGetUsersDedicatedEnvListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetUsersDedicatedEnvListReq.displayName = 'proto.accountmanager.AdminGetUsersDedicatedEnvListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminGetUsersDedicatedEnvListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminGetUsersDedicatedEnvListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetUsersDedicatedEnvListReply.displayName = 'proto.accountmanager.AdminGetUsersDedicatedEnvListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminChangeAccountEnvReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminChangeAccountEnvReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminChangeAccountEnvReq.displayName = 'proto.accountmanager.AdminChangeAccountEnvReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminChangeAccountEnvReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminChangeAccountEnvReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminChangeAccountEnvReply.displayName = 'proto.accountmanager.AdminChangeAccountEnvReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminEnableAccountSymbolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminEnableAccountSymbolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminEnableAccountSymbolReq.displayName = 'proto.accountmanager.AdminEnableAccountSymbolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminEnableAccountSymbolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminEnableAccountSymbolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminEnableAccountSymbolReply.displayName = 'proto.accountmanager.AdminEnableAccountSymbolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminEnableAllAccountSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminEnableAllAccountSymbolsReq.displayName = 'proto.accountmanager.AdminEnableAllAccountSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminEnableAllAccountSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminEnableAllAccountSymbolsReply.displayName = 'proto.accountmanager.AdminEnableAllAccountSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetAllowedCTraderAccountsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetAllowedCTraderAccountsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetAllowedCTraderAccountsReq.displayName = 'proto.accountmanager.GetAllowedCTraderAccountsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.CTraderAccountInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.CTraderAccountInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.CTraderAccountInfo.displayName = 'proto.accountmanager.CTraderAccountInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetAllowedCTraderAccountsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GetAllowedCTraderAccountsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GetAllowedCTraderAccountsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetAllowedCTraderAccountsReply.displayName = 'proto.accountmanager.GetAllowedCTraderAccountsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.SaveCTraderAuthInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.SaveCTraderAuthInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.SaveCTraderAuthInfoReq.displayName = 'proto.accountmanager.SaveCTraderAuthInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.SaveCTraderAuthInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.SaveCTraderAuthInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.SaveCTraderAuthInfoReply.displayName = 'proto.accountmanager.SaveCTraderAuthInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UpdateCTraderAuthInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UpdateCTraderAuthInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UpdateCTraderAuthInfoReq.displayName = 'proto.accountmanager.UpdateCTraderAuthInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.UpdateCTraderAuthInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.UpdateCTraderAuthInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.UpdateCTraderAuthInfoReply.displayName = 'proto.accountmanager.UpdateCTraderAuthInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.DeleteCTraderAuthInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.DeleteCTraderAuthInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.DeleteCTraderAuthInfoReq.displayName = 'proto.accountmanager.DeleteCTraderAuthInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.DeleteCTraderAuthInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.DeleteCTraderAuthInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.DeleteCTraderAuthInfoReply.displayName = 'proto.accountmanager.DeleteCTraderAuthInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.GetCTraderAuthenticatedProfileListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetCTraderAuthenticatedProfileListReq.displayName = 'proto.accountmanager.GetCTraderAuthenticatedProfileListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.GetCTraderAuthenticatedProfileListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.GetCTraderAuthenticatedProfileListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.GetCTraderAuthenticatedProfileListReply.displayName = 'proto.accountmanager.GetCTraderAuthenticatedProfileListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.CTraderProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.CTraderProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.CTraderProfile.displayName = 'proto.accountmanager.CTraderProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AccountReconnect = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AccountReconnect, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AccountReconnect.displayName = 'proto.accountmanager.AccountReconnect';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddPoolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddPoolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddPoolReq.displayName = 'proto.accountmanager.AdminAddPoolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddPoolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddPoolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddPoolReply.displayName = 'proto.accountmanager.AdminAddPoolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUpdatePoolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminUpdatePoolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUpdatePoolReq.displayName = 'proto.accountmanager.AdminUpdatePoolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUpdatePoolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminUpdatePoolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUpdatePoolReply.displayName = 'proto.accountmanager.AdminUpdatePoolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeletePoolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeletePoolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeletePoolReq.displayName = 'proto.accountmanager.AdminDeletePoolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeletePoolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeletePoolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeletePoolReply.displayName = 'proto.accountmanager.AdminDeletePoolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminListPoolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminListPoolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminListPoolsReq.displayName = 'proto.accountmanager.AdminListPoolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminListPoolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminListPoolsReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminListPoolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminListPoolsReply.displayName = 'proto.accountmanager.AdminListPoolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddSymbolPoolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddSymbolPoolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddSymbolPoolReq.displayName = 'proto.accountmanager.AdminAddSymbolPoolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminAddSymbolPoolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminAddSymbolPoolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminAddSymbolPoolReply.displayName = 'proto.accountmanager.AdminAddSymbolPoolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUpdateSymbolPoolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminUpdateSymbolPoolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUpdateSymbolPoolReq.displayName = 'proto.accountmanager.AdminUpdateSymbolPoolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminUpdateSymbolPoolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminUpdateSymbolPoolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminUpdateSymbolPoolReply.displayName = 'proto.accountmanager.AdminUpdateSymbolPoolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteSymbolPoolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeleteSymbolPoolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteSymbolPoolReq.displayName = 'proto.accountmanager.AdminDeleteSymbolPoolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteSymbolPoolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeleteSymbolPoolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteSymbolPoolReply.displayName = 'proto.accountmanager.AdminDeleteSymbolPoolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.Pool = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.Pool.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.Pool, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.Pool.displayName = 'proto.accountmanager.Pool';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.SymbolPool = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.SymbolPool, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.SymbolPool.displayName = 'proto.accountmanager.SymbolPool';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntInternalAccountsInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntInternalAccountsInfoReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntInternalAccountsInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntInternalAccountsInfoReq.displayName = 'proto.accountmanager.IntInternalAccountsInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntInternalAccountsInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.IntInternalAccountsInfoReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.IntInternalAccountsInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntInternalAccountsInfoReply.displayName = 'proto.accountmanager.IntInternalAccountsInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.InternalAccountDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.InternalAccountDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.InternalAccountDetails.displayName = 'proto.accountmanager.InternalAccountDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.TimelyReset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.TimelyReset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.TimelyReset.displayName = 'proto.accountmanager.TimelyReset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetClusterListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminGetClusterListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetClusterListReq.displayName = 'proto.accountmanager.AdminGetClusterListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminGetClusterListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminGetClusterListReply.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminGetClusterListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminGetClusterListReply.displayName = 'proto.accountmanager.AdminGetClusterListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminSwitchConnectionClusterReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminSwitchConnectionClusterReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminSwitchConnectionClusterReq.displayName = 'proto.accountmanager.AdminSwitchConnectionClusterReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminSwitchConnectionClusterReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminSwitchConnectionClusterReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminSwitchConnectionClusterReply.displayName = 'proto.accountmanager.AdminSwitchConnectionClusterReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.OpenTradeWarningReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.OpenTradeWarningReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.OpenTradeWarningReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.OpenTradeWarningReq.displayName = 'proto.accountmanager.OpenTradeWarningReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.OpenTradeWarningReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.OpenTradeWarningReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.OpenTradeWarningReply.displayName = 'proto.accountmanager.OpenTradeWarningReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.SymbolLotOverrideReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.SymbolLotOverrideReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.SymbolLotOverrideReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.SymbolLotOverrideReq.displayName = 'proto.accountmanager.SymbolLotOverrideReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.SymbolLotOverrideReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.SymbolLotOverrideReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.SymbolLotOverrideReply.displayName = 'proto.accountmanager.SymbolLotOverrideReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminSymbolLotOverrideReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminSymbolLotOverrideReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminSymbolLotOverrideReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminSymbolLotOverrideReq.displayName = 'proto.accountmanager.AdminSymbolLotOverrideReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminSymbolLotOverrideReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminSymbolLotOverrideReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminSymbolLotOverrideReply.displayName = 'proto.accountmanager.AdminSymbolLotOverrideReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.DeleteSymbolLotOverrideReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.DeleteSymbolLotOverrideReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.DeleteSymbolLotOverrideReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.DeleteSymbolLotOverrideReq.displayName = 'proto.accountmanager.DeleteSymbolLotOverrideReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.DeleteSymbolLotOverrideReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.DeleteSymbolLotOverrideReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.DeleteSymbolLotOverrideReply.displayName = 'proto.accountmanager.DeleteSymbolLotOverrideReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountmanager.AdminDeleteSymbolLotOverrideReq.repeatedFields_, null);
};
goog.inherits(proto.accountmanager.AdminDeleteSymbolLotOverrideReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteSymbolLotOverrideReq.displayName = 'proto.accountmanager.AdminDeleteSymbolLotOverrideReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.AdminDeleteSymbolLotOverrideReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.AdminDeleteSymbolLotOverrideReply.displayName = 'proto.accountmanager.AdminDeleteSymbolLotOverrideReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntSymbolExistsInAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntSymbolExistsInAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntSymbolExistsInAccountReq.displayName = 'proto.accountmanager.IntSymbolExistsInAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.IntSymbolExistsInAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.IntSymbolExistsInAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.IntSymbolExistsInAccountReply.displayName = 'proto.accountmanager.IntSymbolExistsInAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.ActivateAnalyzerReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.ActivateAnalyzerReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.ActivateAnalyzerReq.displayName = 'proto.accountmanager.ActivateAnalyzerReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountmanager.ActivateAnalyzerReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountmanager.ActivateAnalyzerReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountmanager.ActivateAnalyzerReply.displayName = 'proto.accountmanager.ActivateAnalyzerReply';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminBlockAccountListReq.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminBlockAccountListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminBlockAccountListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminBlockAccountListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
searchAccountsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminBlockAccountListReq}
 */
proto.accountmanager.AdminBlockAccountListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminBlockAccountListReq;
  return proto.accountmanager.AdminBlockAccountListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminBlockAccountListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminBlockAccountListReq}
 */
proto.accountmanager.AdminBlockAccountListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addSearchAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminBlockAccountListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminBlockAccountListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminBlockAccountListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSearchAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminBlockAccountListReq} returns this
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 page = 2;
 * @return {number}
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminBlockAccountListReq} returns this
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminBlockAccountListReq} returns this
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated string search_accounts = 4;
 * @return {!Array<string>}
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.getSearchAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.AdminBlockAccountListReq} returns this
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.setSearchAccountsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AdminBlockAccountListReq} returns this
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.addSearchAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminBlockAccountListReq} returns this
 */
proto.accountmanager.AdminBlockAccountListReq.prototype.clearSearchAccountsList = function() {
  return this.setSearchAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.BlockedAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.BlockedAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.BlockedAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.BlockedAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
accountNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.BlockedAccount}
 */
proto.accountmanager.BlockedAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.BlockedAccount;
  return proto.accountmanager.BlockedAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.BlockedAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.BlockedAccount}
 */
proto.accountmanager.BlockedAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.BlockedAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.BlockedAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.BlockedAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.BlockedAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_number = 1;
 * @return {string}
 */
proto.accountmanager.BlockedAccount.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.BlockedAccount} returns this
 */
proto.accountmanager.BlockedAccount.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string server_id = 2;
 * @return {string}
 */
proto.accountmanager.BlockedAccount.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.BlockedAccount} returns this
 */
proto.accountmanager.BlockedAccount.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminBlockAccountListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminBlockAccountListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminBlockAccountListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminBlockAccountListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminBlockAccountListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
blockedAccountsList: jspb.Message.toObjectList(msg.getBlockedAccountsList(),
    proto.accountmanager.BlockedAccount.toObject, includeInstance),
total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminBlockAccountListReply}
 */
proto.accountmanager.AdminBlockAccountListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminBlockAccountListReply;
  return proto.accountmanager.AdminBlockAccountListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminBlockAccountListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminBlockAccountListReply}
 */
proto.accountmanager.AdminBlockAccountListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.BlockedAccount;
      reader.readMessage(value,proto.accountmanager.BlockedAccount.deserializeBinaryFromReader);
      msg.addBlockedAccounts(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminBlockAccountListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminBlockAccountListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminBlockAccountListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminBlockAccountListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlockedAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.BlockedAccount.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated BlockedAccount blocked_accounts = 1;
 * @return {!Array<!proto.accountmanager.BlockedAccount>}
 */
proto.accountmanager.AdminBlockAccountListReply.prototype.getBlockedAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.BlockedAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.BlockedAccount, 1));
};


/**
 * @param {!Array<!proto.accountmanager.BlockedAccount>} value
 * @return {!proto.accountmanager.AdminBlockAccountListReply} returns this
*/
proto.accountmanager.AdminBlockAccountListReply.prototype.setBlockedAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.BlockedAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.BlockedAccount}
 */
proto.accountmanager.AdminBlockAccountListReply.prototype.addBlockedAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.BlockedAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminBlockAccountListReply} returns this
 */
proto.accountmanager.AdminBlockAccountListReply.prototype.clearBlockedAccountsList = function() {
  return this.setBlockedAccountsList([]);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.accountmanager.AdminBlockAccountListReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminBlockAccountListReply} returns this
 */
proto.accountmanager.AdminBlockAccountListReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminBlockAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminBlockAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminBlockAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminBlockAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 3, ""),
block: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminBlockAccountReq}
 */
proto.accountmanager.AdminBlockAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminBlockAccountReq;
  return proto.accountmanager.AdminBlockAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminBlockAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminBlockAccountReq}
 */
proto.accountmanager.AdminBlockAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlock(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminBlockAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminBlockAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminBlockAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminBlockAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBlock();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminBlockAccountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminBlockAccountReq} returns this
 */
proto.accountmanager.AdminBlockAccountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_number = 2;
 * @return {string}
 */
proto.accountmanager.AdminBlockAccountReq.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminBlockAccountReq} returns this
 */
proto.accountmanager.AdminBlockAccountReq.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string server_id = 3;
 * @return {string}
 */
proto.accountmanager.AdminBlockAccountReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminBlockAccountReq} returns this
 */
proto.accountmanager.AdminBlockAccountReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool block = 4;
 * @return {boolean}
 */
proto.accountmanager.AdminBlockAccountReq.prototype.getBlock = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AdminBlockAccountReq} returns this
 */
proto.accountmanager.AdminBlockAccountReq.prototype.setBlock = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminBlockAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminBlockAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminBlockAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminBlockAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminBlockAccountReply}
 */
proto.accountmanager.AdminBlockAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminBlockAccountReply;
  return proto.accountmanager.AdminBlockAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminBlockAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminBlockAccountReply}
 */
proto.accountmanager.AdminBlockAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminBlockAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminBlockAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminBlockAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminBlockAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetUsersTradingPlatformsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetUsersTradingPlatformsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetUsersTradingPlatformsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetUsersTradingPlatformsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetUsersTradingPlatformsReq}
 */
proto.accountmanager.GetUsersTradingPlatformsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetUsersTradingPlatformsReq;
  return proto.accountmanager.GetUsersTradingPlatformsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetUsersTradingPlatformsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetUsersTradingPlatformsReq}
 */
proto.accountmanager.GetUsersTradingPlatformsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetUsersTradingPlatformsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetUsersTradingPlatformsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetUsersTradingPlatformsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetUsersTradingPlatformsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GetUsersTradingPlatformsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetUsersTradingPlatformsReq} returns this
 */
proto.accountmanager.GetUsersTradingPlatformsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GetUsersTradingPlatformsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetUsersTradingPlatformsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetUsersTradingPlatformsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetUsersTradingPlatformsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetUsersTradingPlatformsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
platformsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetUsersTradingPlatformsReply}
 */
proto.accountmanager.GetUsersTradingPlatformsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetUsersTradingPlatformsReply;
  return proto.accountmanager.GetUsersTradingPlatformsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetUsersTradingPlatformsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetUsersTradingPlatformsReply}
 */
proto.accountmanager.GetUsersTradingPlatformsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPlatforms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetUsersTradingPlatformsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetUsersTradingPlatformsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetUsersTradingPlatformsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetUsersTradingPlatformsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlatformsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string platforms = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.GetUsersTradingPlatformsReply.prototype.getPlatformsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.GetUsersTradingPlatformsReply} returns this
 */
proto.accountmanager.GetUsersTradingPlatformsReply.prototype.setPlatformsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.GetUsersTradingPlatformsReply} returns this
 */
proto.accountmanager.GetUsersTradingPlatformsReply.prototype.addPlatforms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GetUsersTradingPlatformsReply} returns this
 */
proto.accountmanager.GetUsersTradingPlatformsReply.prototype.clearPlatformsList = function() {
  return this.setPlatformsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetTradovateUserAccountListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetTradovateUserAccountListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetTradovateUserAccountListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradovateUserAccountListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
authId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetTradovateUserAccountListReq}
 */
proto.accountmanager.GetTradovateUserAccountListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetTradovateUserAccountListReq;
  return proto.accountmanager.GetTradovateUserAccountListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetTradovateUserAccountListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetTradovateUserAccountListReq}
 */
proto.accountmanager.GetTradovateUserAccountListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuthId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetTradovateUserAccountListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetTradovateUserAccountListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetTradovateUserAccountListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradovateUserAccountListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GetTradovateUserAccountListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetTradovateUserAccountListReq} returns this
 */
proto.accountmanager.GetTradovateUserAccountListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 auth_id = 2;
 * @return {number}
 */
proto.accountmanager.GetTradovateUserAccountListReq.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.GetTradovateUserAccountListReq} returns this
 */
proto.accountmanager.GetTradovateUserAccountListReq.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.TradovateUserAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.TradovateUserAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.TradovateUserAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TradovateUserAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
active: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.TradovateUserAccount}
 */
proto.accountmanager.TradovateUserAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.TradovateUserAccount;
  return proto.accountmanager.TradovateUserAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.TradovateUserAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.TradovateUserAccount}
 */
proto.accountmanager.TradovateUserAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.TradovateUserAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.TradovateUserAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.TradovateUserAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TradovateUserAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.accountmanager.TradovateUserAccount.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.TradovateUserAccount} returns this
 */
proto.accountmanager.TradovateUserAccount.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool active = 2;
 * @return {boolean}
 */
proto.accountmanager.TradovateUserAccount.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.TradovateUserAccount} returns this
 */
proto.accountmanager.TradovateUserAccount.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool is_demo = 3;
 * @return {boolean}
 */
proto.accountmanager.TradovateUserAccount.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.TradovateUserAccount} returns this
 */
proto.accountmanager.TradovateUserAccount.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GetTradovateUserAccountListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetTradovateUserAccountListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetTradovateUserAccountListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetTradovateUserAccountListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradovateUserAccountListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
userAccountsList: jspb.Message.toObjectList(msg.getUserAccountsList(),
    proto.accountmanager.TradovateUserAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetTradovateUserAccountListReply}
 */
proto.accountmanager.GetTradovateUserAccountListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetTradovateUserAccountListReply;
  return proto.accountmanager.GetTradovateUserAccountListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetTradovateUserAccountListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetTradovateUserAccountListReply}
 */
proto.accountmanager.GetTradovateUserAccountListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.TradovateUserAccount;
      reader.readMessage(value,proto.accountmanager.TradovateUserAccount.deserializeBinaryFromReader);
      msg.addUserAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetTradovateUserAccountListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetTradovateUserAccountListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetTradovateUserAccountListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradovateUserAccountListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.TradovateUserAccount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TradovateUserAccount user_accounts = 1;
 * @return {!Array<!proto.accountmanager.TradovateUserAccount>}
 */
proto.accountmanager.GetTradovateUserAccountListReply.prototype.getUserAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.TradovateUserAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.TradovateUserAccount, 1));
};


/**
 * @param {!Array<!proto.accountmanager.TradovateUserAccount>} value
 * @return {!proto.accountmanager.GetTradovateUserAccountListReply} returns this
*/
proto.accountmanager.GetTradovateUserAccountListReply.prototype.setUserAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.TradovateUserAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.TradovateUserAccount}
 */
proto.accountmanager.GetTradovateUserAccountListReply.prototype.addUserAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.TradovateUserAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GetTradovateUserAccountListReply} returns this
 */
proto.accountmanager.GetTradovateUserAccountListReply.prototype.clearUserAccountsList = function() {
  return this.setUserAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.SaveTradovateAuthInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.SaveTradovateAuthInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.SaveTradovateAuthInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SaveTradovateAuthInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
authorizationCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
redirectUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.SaveTradovateAuthInfoReq}
 */
proto.accountmanager.SaveTradovateAuthInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.SaveTradovateAuthInfoReq;
  return proto.accountmanager.SaveTradovateAuthInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.SaveTradovateAuthInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.SaveTradovateAuthInfoReq}
 */
proto.accountmanager.SaveTradovateAuthInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorizationCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUrl(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.SaveTradovateAuthInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.SaveTradovateAuthInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.SaveTradovateAuthInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SaveTradovateAuthInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthorizationCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRedirectUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.SaveTradovateAuthInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SaveTradovateAuthInfoReq} returns this
 */
proto.accountmanager.SaveTradovateAuthInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string authorization_code = 2;
 * @return {string}
 */
proto.accountmanager.SaveTradovateAuthInfoReq.prototype.getAuthorizationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SaveTradovateAuthInfoReq} returns this
 */
proto.accountmanager.SaveTradovateAuthInfoReq.prototype.setAuthorizationCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string redirect_url = 3;
 * @return {string}
 */
proto.accountmanager.SaveTradovateAuthInfoReq.prototype.getRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SaveTradovateAuthInfoReq} returns this
 */
proto.accountmanager.SaveTradovateAuthInfoReq.prototype.setRedirectUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool is_demo = 4;
 * @return {boolean}
 */
proto.accountmanager.SaveTradovateAuthInfoReq.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.SaveTradovateAuthInfoReq} returns this
 */
proto.accountmanager.SaveTradovateAuthInfoReq.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.SaveTradovateAuthInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.SaveTradovateAuthInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.SaveTradovateAuthInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SaveTradovateAuthInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
authId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.SaveTradovateAuthInfoReply}
 */
proto.accountmanager.SaveTradovateAuthInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.SaveTradovateAuthInfoReply;
  return proto.accountmanager.SaveTradovateAuthInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.SaveTradovateAuthInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.SaveTradovateAuthInfoReply}
 */
proto.accountmanager.SaveTradovateAuthInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuthId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.SaveTradovateAuthInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.SaveTradovateAuthInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.SaveTradovateAuthInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SaveTradovateAuthInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 auth_id = 1;
 * @return {number}
 */
proto.accountmanager.SaveTradovateAuthInfoReply.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.SaveTradovateAuthInfoReply} returns this
 */
proto.accountmanager.SaveTradovateAuthInfoReply.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UpdateTradovateAuthInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UpdateTradovateAuthInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
authId: jspb.Message.getFieldWithDefault(msg, 2, 0),
nickname: (f = msg.getNickname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UpdateTradovateAuthInfoReq}
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UpdateTradovateAuthInfoReq;
  return proto.accountmanager.UpdateTradovateAuthInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UpdateTradovateAuthInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UpdateTradovateAuthInfoReq}
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuthId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setNickname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UpdateTradovateAuthInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UpdateTradovateAuthInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNickname();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UpdateTradovateAuthInfoReq} returns this
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 auth_id = 2;
 * @return {number}
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.UpdateTradovateAuthInfoReq} returns this
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue nickname = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.prototype.getNickname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.UpdateTradovateAuthInfoReq} returns this
*/
proto.accountmanager.UpdateTradovateAuthInfoReq.prototype.setNickname = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpdateTradovateAuthInfoReq} returns this
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.prototype.clearNickname = function() {
  return this.setNickname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpdateTradovateAuthInfoReq.prototype.hasNickname = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UpdateTradovateAuthInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UpdateTradovateAuthInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UpdateTradovateAuthInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateTradovateAuthInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UpdateTradovateAuthInfoReply}
 */
proto.accountmanager.UpdateTradovateAuthInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UpdateTradovateAuthInfoReply;
  return proto.accountmanager.UpdateTradovateAuthInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UpdateTradovateAuthInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UpdateTradovateAuthInfoReply}
 */
proto.accountmanager.UpdateTradovateAuthInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UpdateTradovateAuthInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UpdateTradovateAuthInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UpdateTradovateAuthInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateTradovateAuthInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.DeleteTradovateAuthInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.DeleteTradovateAuthInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.DeleteTradovateAuthInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteTradovateAuthInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
authId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.DeleteTradovateAuthInfoReq}
 */
proto.accountmanager.DeleteTradovateAuthInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.DeleteTradovateAuthInfoReq;
  return proto.accountmanager.DeleteTradovateAuthInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.DeleteTradovateAuthInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.DeleteTradovateAuthInfoReq}
 */
proto.accountmanager.DeleteTradovateAuthInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuthId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.DeleteTradovateAuthInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.DeleteTradovateAuthInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.DeleteTradovateAuthInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteTradovateAuthInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.DeleteTradovateAuthInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DeleteTradovateAuthInfoReq} returns this
 */
proto.accountmanager.DeleteTradovateAuthInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 auth_id = 2;
 * @return {number}
 */
proto.accountmanager.DeleteTradovateAuthInfoReq.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.DeleteTradovateAuthInfoReq} returns this
 */
proto.accountmanager.DeleteTradovateAuthInfoReq.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.DeleteTradovateAuthInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.DeleteTradovateAuthInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.DeleteTradovateAuthInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteTradovateAuthInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.DeleteTradovateAuthInfoReply}
 */
proto.accountmanager.DeleteTradovateAuthInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.DeleteTradovateAuthInfoReply;
  return proto.accountmanager.DeleteTradovateAuthInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.DeleteTradovateAuthInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.DeleteTradovateAuthInfoReply}
 */
proto.accountmanager.DeleteTradovateAuthInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.DeleteTradovateAuthInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.DeleteTradovateAuthInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.DeleteTradovateAuthInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteTradovateAuthInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetTradovateProfileListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetTradovateProfileListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetTradovateProfileListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradovateProfileListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetTradovateProfileListReq}
 */
proto.accountmanager.GetTradovateProfileListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetTradovateProfileListReq;
  return proto.accountmanager.GetTradovateProfileListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetTradovateProfileListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetTradovateProfileListReq}
 */
proto.accountmanager.GetTradovateProfileListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetTradovateProfileListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetTradovateProfileListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetTradovateProfileListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradovateProfileListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GetTradovateProfileListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetTradovateProfileListReq} returns this
 */
proto.accountmanager.GetTradovateProfileListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GetTradovateProfileListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetTradovateProfileListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetTradovateProfileListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetTradovateProfileListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradovateProfileListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
profilesList: jspb.Message.toObjectList(msg.getProfilesList(),
    proto.accountmanager.TradovateProfile.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetTradovateProfileListReply}
 */
proto.accountmanager.GetTradovateProfileListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetTradovateProfileListReply;
  return proto.accountmanager.GetTradovateProfileListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetTradovateProfileListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetTradovateProfileListReply}
 */
proto.accountmanager.GetTradovateProfileListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.TradovateProfile;
      reader.readMessage(value,proto.accountmanager.TradovateProfile.deserializeBinaryFromReader);
      msg.addProfiles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetTradovateProfileListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetTradovateProfileListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetTradovateProfileListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradovateProfileListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.TradovateProfile.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TradovateProfile profiles = 1;
 * @return {!Array<!proto.accountmanager.TradovateProfile>}
 */
proto.accountmanager.GetTradovateProfileListReply.prototype.getProfilesList = function() {
  return /** @type{!Array<!proto.accountmanager.TradovateProfile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.TradovateProfile, 1));
};


/**
 * @param {!Array<!proto.accountmanager.TradovateProfile>} value
 * @return {!proto.accountmanager.GetTradovateProfileListReply} returns this
*/
proto.accountmanager.GetTradovateProfileListReply.prototype.setProfilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.TradovateProfile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.TradovateProfile}
 */
proto.accountmanager.GetTradovateProfileListReply.prototype.addProfiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.TradovateProfile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GetTradovateProfileListReply} returns this
 */
proto.accountmanager.GetTradovateProfileListReply.prototype.clearProfilesList = function() {
  return this.setProfilesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.TradovateProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.TradovateProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.TradovateProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TradovateProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
authId: jspb.Message.getFieldWithDefault(msg, 1, 0),
tvUserId: jspb.Message.getFieldWithDefault(msg, 2, 0),
nickname: (f = msg.getNickname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.TradovateProfile}
 */
proto.accountmanager.TradovateProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.TradovateProfile;
  return proto.accountmanager.TradovateProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.TradovateProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.TradovateProfile}
 */
proto.accountmanager.TradovateProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuthId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTvUserId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setNickname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.TradovateProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.TradovateProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.TradovateProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TradovateProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTvUserId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNickname();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 auth_id = 1;
 * @return {number}
 */
proto.accountmanager.TradovateProfile.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.TradovateProfile} returns this
 */
proto.accountmanager.TradovateProfile.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 tv_user_id = 2;
 * @return {number}
 */
proto.accountmanager.TradovateProfile.prototype.getTvUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.TradovateProfile} returns this
 */
proto.accountmanager.TradovateProfile.prototype.setTvUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue nickname = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.TradovateProfile.prototype.getNickname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.TradovateProfile} returns this
*/
proto.accountmanager.TradovateProfile.prototype.setNickname = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.TradovateProfile} returns this
 */
proto.accountmanager.TradovateProfile.prototype.clearNickname = function() {
  return this.setNickname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.TradovateProfile.prototype.hasNickname = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminChangeAccountConnectionTypeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminChangeAccountConnectionTypeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
connectionType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminChangeAccountConnectionTypeReq}
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminChangeAccountConnectionTypeReq;
  return proto.accountmanager.AdminChangeAccountConnectionTypeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminChangeAccountConnectionTypeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminChangeAccountConnectionTypeReq}
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    case 2:
      var value = /** @type {!proto.accountmanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminChangeAccountConnectionTypeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminChangeAccountConnectionTypeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.AdminChangeAccountConnectionTypeReq} returns this
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AdminChangeAccountConnectionTypeReq} returns this
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminChangeAccountConnectionTypeReq} returns this
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * optional ConnectionType connection_type = 2;
 * @return {!proto.accountmanager.ConnectionType}
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.prototype.getConnectionType = function() {
  return /** @type {!proto.accountmanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.accountmanager.ConnectionType} value
 * @return {!proto.accountmanager.AdminChangeAccountConnectionTypeReq} returns this
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReq.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminChangeAccountConnectionTypeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminChangeAccountConnectionTypeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminChangeAccountConnectionTypeReply}
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminChangeAccountConnectionTypeReply;
  return proto.accountmanager.AdminChangeAccountConnectionTypeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminChangeAccountConnectionTypeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminChangeAccountConnectionTypeReply}
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminChangeAccountConnectionTypeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminChangeAccountConnectionTypeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminChangeAccountConnectionTypeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntChangeConnectionTypeBulkReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntChangeConnectionTypeBulkReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
connectionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
baseSymbol: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntChangeConnectionTypeBulkReq}
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntChangeConnectionTypeBulkReq;
  return proto.accountmanager.IntChangeConnectionTypeBulkReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntChangeConnectionTypeBulkReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntChangeConnectionTypeBulkReq}
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    case 2:
      var value = /** @type {!proto.accountmanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaseSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntChangeConnectionTypeBulkReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntChangeConnectionTypeBulkReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getBaseSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntChangeConnectionTypeBulkReq} returns this
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntChangeConnectionTypeBulkReq} returns this
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntChangeConnectionTypeBulkReq} returns this
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * optional ConnectionType connection_type = 2;
 * @return {!proto.accountmanager.ConnectionType}
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.prototype.getConnectionType = function() {
  return /** @type {!proto.accountmanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.accountmanager.ConnectionType} value
 * @return {!proto.accountmanager.IntChangeConnectionTypeBulkReq} returns this
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string base_symbol = 3;
 * @return {string}
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.prototype.getBaseSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntChangeConnectionTypeBulkReq} returns this
 */
proto.accountmanager.IntChangeConnectionTypeBulkReq.prototype.setBaseSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntChangeConnectionTypeBulkReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntChangeConnectionTypeBulkReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntChangeConnectionTypeBulkReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntChangeConnectionTypeBulkReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntChangeConnectionTypeBulkReply}
 */
proto.accountmanager.IntChangeConnectionTypeBulkReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntChangeConnectionTypeBulkReply;
  return proto.accountmanager.IntChangeConnectionTypeBulkReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntChangeConnectionTypeBulkReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntChangeConnectionTypeBulkReply}
 */
proto.accountmanager.IntChangeConnectionTypeBulkReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntChangeConnectionTypeBulkReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntChangeConnectionTypeBulkReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntChangeConnectionTypeBulkReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntChangeConnectionTypeBulkReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.TradeLockerAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.TradeLockerAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.TradeLockerAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TradeLockerAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
accountNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
currency: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.TradeLockerAccount}
 */
proto.accountmanager.TradeLockerAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.TradeLockerAccount;
  return proto.accountmanager.TradeLockerAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.TradeLockerAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.TradeLockerAccount}
 */
proto.accountmanager.TradeLockerAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.TradeLockerAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.TradeLockerAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.TradeLockerAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TradeLockerAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string account_number = 1;
 * @return {string}
 */
proto.accountmanager.TradeLockerAccount.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.TradeLockerAccount} returns this
 */
proto.accountmanager.TradeLockerAccount.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.TradeLockerAccount.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.TradeLockerAccount} returns this
 */
proto.accountmanager.TradeLockerAccount.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string currency = 3;
 * @return {string}
 */
proto.accountmanager.TradeLockerAccount.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.TradeLockerAccount} returns this
 */
proto.accountmanager.TradeLockerAccount.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
serverName: jspb.Message.getFieldWithDefault(msg, 4, ""),
isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReq}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetTradeLockerUsersAccountListReq;
  return proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReq}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerName(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getServerName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReq} returns this
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReq} returns this
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReq} returns this
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string server_name = 4;
 * @return {string}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.getServerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReq} returns this
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.setServerName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool is_demo = 5;
 * @return {boolean}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReq} returns this
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReq.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.TradeLockerAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReply}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetTradeLockerUsersAccountListReply;
  return proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReply}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.TradeLockerAccount;
      reader.readMessage(value,proto.accountmanager.TradeLockerAccount.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.TradeLockerAccount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TradeLockerAccount accounts = 1;
 * @return {!Array<!proto.accountmanager.TradeLockerAccount>}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.TradeLockerAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.TradeLockerAccount, 1));
};


/**
 * @param {!Array<!proto.accountmanager.TradeLockerAccount>} value
 * @return {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReply} returns this
*/
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.TradeLockerAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.TradeLockerAccount}
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.TradeLockerAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminGetTradeLockerUsersAccountListReply} returns this
 */
proto.accountmanager.AdminGetTradeLockerUsersAccountListReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetTradeLockerUsersAccountListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetTradeLockerUsersAccountListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
serverName: jspb.Message.getFieldWithDefault(msg, 4, ""),
isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetTradeLockerUsersAccountListReq}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetTradeLockerUsersAccountListReq;
  return proto.accountmanager.GetTradeLockerUsersAccountListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetTradeLockerUsersAccountListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetTradeLockerUsersAccountListReq}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerName(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetTradeLockerUsersAccountListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetTradeLockerUsersAccountListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getServerName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetTradeLockerUsersAccountListReq} returns this
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetTradeLockerUsersAccountListReq} returns this
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetTradeLockerUsersAccountListReq} returns this
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string server_name = 4;
 * @return {string}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.getServerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetTradeLockerUsersAccountListReq} returns this
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.setServerName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool is_demo = 5;
 * @return {boolean}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.GetTradeLockerUsersAccountListReq} returns this
 */
proto.accountmanager.GetTradeLockerUsersAccountListReq.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GetTradeLockerUsersAccountListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetTradeLockerUsersAccountListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetTradeLockerUsersAccountListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradeLockerUsersAccountListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.TradeLockerAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetTradeLockerUsersAccountListReply}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetTradeLockerUsersAccountListReply;
  return proto.accountmanager.GetTradeLockerUsersAccountListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetTradeLockerUsersAccountListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetTradeLockerUsersAccountListReply}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.TradeLockerAccount;
      reader.readMessage(value,proto.accountmanager.TradeLockerAccount.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetTradeLockerUsersAccountListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetTradeLockerUsersAccountListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetTradeLockerUsersAccountListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.TradeLockerAccount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TradeLockerAccount accounts = 1;
 * @return {!Array<!proto.accountmanager.TradeLockerAccount>}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.TradeLockerAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.TradeLockerAccount, 1));
};


/**
 * @param {!Array<!proto.accountmanager.TradeLockerAccount>} value
 * @return {!proto.accountmanager.GetTradeLockerUsersAccountListReply} returns this
*/
proto.accountmanager.GetTradeLockerUsersAccountListReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.TradeLockerAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.TradeLockerAccount}
 */
proto.accountmanager.GetTradeLockerUsersAccountListReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.TradeLockerAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GetTradeLockerUsersAccountListReply} returns this
 */
proto.accountmanager.GetTradeLockerUsersAccountListReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.MatchTraderAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.MatchTraderAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.MatchTraderAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MatchTraderAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
group: (f = msg.getGroup()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.MatchTraderAccount}
 */
proto.accountmanager.MatchTraderAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.MatchTraderAccount;
  return proto.accountmanager.MatchTraderAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.MatchTraderAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.MatchTraderAccount}
 */
proto.accountmanager.MatchTraderAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.MatchTraderAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.MatchTraderAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.MatchTraderAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MatchTraderAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroup();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.MatchTraderAccount.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MatchTraderAccount} returns this
 */
proto.accountmanager.MatchTraderAccount.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue group = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.MatchTraderAccount.prototype.getGroup = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.MatchTraderAccount} returns this
*/
proto.accountmanager.MatchTraderAccount.prototype.setGroup = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.MatchTraderAccount} returns this
 */
proto.accountmanager.MatchTraderAccount.prototype.clearGroup = function() {
  return this.setGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.MatchTraderAccount.prototype.hasGroup = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
brokerId: jspb.Message.getFieldWithDefault(msg, 4, 0),
host: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReq}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetMatchTraderUsersAccountListReq;
  return proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReq}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBrokerId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBrokerId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReq} returns this
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReq} returns this
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReq} returns this
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 broker_id = 4;
 * @return {number}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.getBrokerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReq} returns this
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string host = 5;
 * @return {string}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReq} returns this
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReq.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.MatchTraderAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReply}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetMatchTraderUsersAccountListReply;
  return proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReply}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.MatchTraderAccount;
      reader.readMessage(value,proto.accountmanager.MatchTraderAccount.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.MatchTraderAccount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MatchTraderAccount accounts = 1;
 * @return {!Array<!proto.accountmanager.MatchTraderAccount>}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.MatchTraderAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.MatchTraderAccount, 1));
};


/**
 * @param {!Array<!proto.accountmanager.MatchTraderAccount>} value
 * @return {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReply} returns this
*/
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.MatchTraderAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.MatchTraderAccount}
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.MatchTraderAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminGetMatchTraderUsersAccountListReply} returns this
 */
proto.accountmanager.AdminGetMatchTraderUsersAccountListReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetMatchTraderUsersAccountListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetMatchTraderUsersAccountListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
brokerId: jspb.Message.getFieldWithDefault(msg, 4, 0),
host: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetMatchTraderUsersAccountListReq}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetMatchTraderUsersAccountListReq;
  return proto.accountmanager.GetMatchTraderUsersAccountListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetMatchTraderUsersAccountListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetMatchTraderUsersAccountListReq}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBrokerId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetMatchTraderUsersAccountListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetMatchTraderUsersAccountListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBrokerId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetMatchTraderUsersAccountListReq} returns this
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetMatchTraderUsersAccountListReq} returns this
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetMatchTraderUsersAccountListReq} returns this
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 broker_id = 4;
 * @return {number}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.getBrokerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.GetMatchTraderUsersAccountListReq} returns this
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string host = 5;
 * @return {string}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetMatchTraderUsersAccountListReq} returns this
 */
proto.accountmanager.GetMatchTraderUsersAccountListReq.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GetMatchTraderUsersAccountListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetMatchTraderUsersAccountListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetMatchTraderUsersAccountListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetMatchTraderUsersAccountListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.MatchTraderAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetMatchTraderUsersAccountListReply}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetMatchTraderUsersAccountListReply;
  return proto.accountmanager.GetMatchTraderUsersAccountListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetMatchTraderUsersAccountListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetMatchTraderUsersAccountListReply}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.MatchTraderAccount;
      reader.readMessage(value,proto.accountmanager.MatchTraderAccount.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetMatchTraderUsersAccountListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetMatchTraderUsersAccountListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetMatchTraderUsersAccountListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.MatchTraderAccount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MatchTraderAccount accounts = 1;
 * @return {!Array<!proto.accountmanager.MatchTraderAccount>}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.MatchTraderAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.MatchTraderAccount, 1));
};


/**
 * @param {!Array<!proto.accountmanager.MatchTraderAccount>} value
 * @return {!proto.accountmanager.GetMatchTraderUsersAccountListReply} returns this
*/
proto.accountmanager.GetMatchTraderUsersAccountListReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.MatchTraderAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.MatchTraderAccount}
 */
proto.accountmanager.GetMatchTraderUsersAccountListReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.MatchTraderAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GetMatchTraderUsersAccountListReply} returns this
 */
proto.accountmanager.GetMatchTraderUsersAccountListReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetDxtUsersAccountListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetDxtUsersAccountListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetDxtUsersAccountListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetDxtUsersAccountListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
username: jspb.Message.getFieldWithDefault(msg, 2, ""),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
host: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetDxtUsersAccountListReq}
 */
proto.accountmanager.GetDxtUsersAccountListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetDxtUsersAccountListReq;
  return proto.accountmanager.GetDxtUsersAccountListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetDxtUsersAccountListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetDxtUsersAccountListReq}
 */
proto.accountmanager.GetDxtUsersAccountListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetDxtUsersAccountListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetDxtUsersAccountListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetDxtUsersAccountListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetDxtUsersAccountListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GetDxtUsersAccountListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetDxtUsersAccountListReq} returns this
 */
proto.accountmanager.GetDxtUsersAccountListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.accountmanager.GetDxtUsersAccountListReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetDxtUsersAccountListReq} returns this
 */
proto.accountmanager.GetDxtUsersAccountListReq.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.accountmanager.GetDxtUsersAccountListReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetDxtUsersAccountListReq} returns this
 */
proto.accountmanager.GetDxtUsersAccountListReq.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string host = 4;
 * @return {string}
 */
proto.accountmanager.GetDxtUsersAccountListReq.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetDxtUsersAccountListReq} returns this
 */
proto.accountmanager.GetDxtUsersAccountListReq.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.DxtAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.DxtAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.DxtAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DxtAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
accountNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountStatus: jspb.Message.getFieldWithDefault(msg, 2, ""),
currency: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.DxtAccount}
 */
proto.accountmanager.DxtAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.DxtAccount;
  return proto.accountmanager.DxtAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.DxtAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.DxtAccount}
 */
proto.accountmanager.DxtAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.DxtAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.DxtAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.DxtAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DxtAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string account_number = 1;
 * @return {string}
 */
proto.accountmanager.DxtAccount.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DxtAccount} returns this
 */
proto.accountmanager.DxtAccount.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_status = 2;
 * @return {string}
 */
proto.accountmanager.DxtAccount.prototype.getAccountStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DxtAccount} returns this
 */
proto.accountmanager.DxtAccount.prototype.setAccountStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string currency = 3;
 * @return {string}
 */
proto.accountmanager.DxtAccount.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DxtAccount} returns this
 */
proto.accountmanager.DxtAccount.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GetDxtUsersAccountListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetDxtUsersAccountListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetDxtUsersAccountListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetDxtUsersAccountListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetDxtUsersAccountListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.DxtAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetDxtUsersAccountListReply}
 */
proto.accountmanager.GetDxtUsersAccountListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetDxtUsersAccountListReply;
  return proto.accountmanager.GetDxtUsersAccountListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetDxtUsersAccountListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetDxtUsersAccountListReply}
 */
proto.accountmanager.GetDxtUsersAccountListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.DxtAccount;
      reader.readMessage(value,proto.accountmanager.DxtAccount.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetDxtUsersAccountListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetDxtUsersAccountListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetDxtUsersAccountListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetDxtUsersAccountListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.DxtAccount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DxtAccount accounts = 1;
 * @return {!Array<!proto.accountmanager.DxtAccount>}
 */
proto.accountmanager.GetDxtUsersAccountListReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.DxtAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.DxtAccount, 1));
};


/**
 * @param {!Array<!proto.accountmanager.DxtAccount>} value
 * @return {!proto.accountmanager.GetDxtUsersAccountListReply} returns this
*/
proto.accountmanager.GetDxtUsersAccountListReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.DxtAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.DxtAccount}
 */
proto.accountmanager.GetDxtUsersAccountListReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.DxtAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GetDxtUsersAccountListReply} returns this
 */
proto.accountmanager.GetDxtUsersAccountListReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntUpdateAccountServerTimeZoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntUpdateAccountServerTimeZoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntUpdateAccountServerTimeZoneReq}
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntUpdateAccountServerTimeZoneReq;
  return proto.accountmanager.IntUpdateAccountServerTimeZoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntUpdateAccountServerTimeZoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntUpdateAccountServerTimeZoneReq}
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntUpdateAccountServerTimeZoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntUpdateAccountServerTimeZoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntUpdateAccountServerTimeZoneReq} returns this
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntUpdateAccountServerTimeZoneReq} returns this
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntUpdateAccountServerTimeZoneReq} returns this
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntUpdateAccountServerTimeZoneReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntUpdateAccountServerTimeZoneReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply.toObject = function(includeInstance, msg) {
  var f, obj = {
failedAccountsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntUpdateAccountServerTimeZoneReply}
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntUpdateAccountServerTimeZoneReply;
  return proto.accountmanager.IntUpdateAccountServerTimeZoneReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntUpdateAccountServerTimeZoneReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntUpdateAccountServerTimeZoneReply}
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addFailedAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntUpdateAccountServerTimeZoneReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntUpdateAccountServerTimeZoneReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailedAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string failed_accounts = 2;
 * @return {!Array<string>}
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply.prototype.getFailedAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntUpdateAccountServerTimeZoneReply} returns this
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply.prototype.setFailedAccountsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntUpdateAccountServerTimeZoneReply} returns this
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply.prototype.addFailedAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntUpdateAccountServerTimeZoneReply} returns this
 */
proto.accountmanager.IntUpdateAccountServerTimeZoneReply.prototype.clearFailedAccountsList = function() {
  return this.setFailedAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.ChangeAccountEnvReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.ChangeAccountEnvReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.ChangeAccountEnvReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ChangeAccountEnvReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
dedicatedEnvId: (f = msg.getDedicatedEnvId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.ChangeAccountEnvReq}
 */
proto.accountmanager.ChangeAccountEnvReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.ChangeAccountEnvReq;
  return proto.accountmanager.ChangeAccountEnvReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.ChangeAccountEnvReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.ChangeAccountEnvReq}
 */
proto.accountmanager.ChangeAccountEnvReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDedicatedEnvId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.ChangeAccountEnvReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.ChangeAccountEnvReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.ChangeAccountEnvReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ChangeAccountEnvReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDedicatedEnvId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.ChangeAccountEnvReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ChangeAccountEnvReq} returns this
 */
proto.accountmanager.ChangeAccountEnvReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.ChangeAccountEnvReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ChangeAccountEnvReq} returns this
 */
proto.accountmanager.ChangeAccountEnvReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue dedicated_env_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.ChangeAccountEnvReq.prototype.getDedicatedEnvId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.ChangeAccountEnvReq} returns this
*/
proto.accountmanager.ChangeAccountEnvReq.prototype.setDedicatedEnvId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.ChangeAccountEnvReq} returns this
 */
proto.accountmanager.ChangeAccountEnvReq.prototype.clearDedicatedEnvId = function() {
  return this.setDedicatedEnvId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.ChangeAccountEnvReq.prototype.hasDedicatedEnvId = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetAvailableDedicatedEnvVersionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetAvailableDedicatedEnvVersionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetAvailableDedicatedEnvVersionReq}
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetAvailableDedicatedEnvVersionReq;
  return proto.accountmanager.GetAvailableDedicatedEnvVersionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetAvailableDedicatedEnvVersionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetAvailableDedicatedEnvVersionReq}
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetAvailableDedicatedEnvVersionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetAvailableDedicatedEnvVersionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAvailableDedicatedEnvVersionReq} returns this
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetAvailableDedicatedEnvVersionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetAvailableDedicatedEnvVersionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
mt4VersionsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
mt5VersionsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetAvailableDedicatedEnvVersionReply}
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetAvailableDedicatedEnvVersionReply;
  return proto.accountmanager.GetAvailableDedicatedEnvVersionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetAvailableDedicatedEnvVersionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetAvailableDedicatedEnvVersionReply}
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addMt4Versions(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addMt5Versions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetAvailableDedicatedEnvVersionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetAvailableDedicatedEnvVersionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMt4VersionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getMt5VersionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string mt4_versions = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.prototype.getMt4VersionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.GetAvailableDedicatedEnvVersionReply} returns this
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.prototype.setMt4VersionsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.GetAvailableDedicatedEnvVersionReply} returns this
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.prototype.addMt4Versions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GetAvailableDedicatedEnvVersionReply} returns this
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.prototype.clearMt4VersionsList = function() {
  return this.setMt4VersionsList([]);
};


/**
 * repeated string mt5_versions = 2;
 * @return {!Array<string>}
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.prototype.getMt5VersionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.GetAvailableDedicatedEnvVersionReply} returns this
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.prototype.setMt5VersionsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.GetAvailableDedicatedEnvVersionReply} returns this
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.prototype.addMt5Versions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GetAvailableDedicatedEnvVersionReply} returns this
 */
proto.accountmanager.GetAvailableDedicatedEnvVersionReply.prototype.clearMt5VersionsList = function() {
  return this.setMt5VersionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.ChangeAccountEnvReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.ChangeAccountEnvReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.ChangeAccountEnvReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ChangeAccountEnvReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.ChangeAccountEnvReply}
 */
proto.accountmanager.ChangeAccountEnvReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.ChangeAccountEnvReply;
  return proto.accountmanager.ChangeAccountEnvReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.ChangeAccountEnvReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.ChangeAccountEnvReply}
 */
proto.accountmanager.ChangeAccountEnvReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.ChangeAccountEnvReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.ChangeAccountEnvReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.ChangeAccountEnvReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ChangeAccountEnvReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.CheckAvailableEnvReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.CheckAvailableEnvReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.CheckAvailableEnvReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CheckAvailableEnvReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.CheckAvailableEnvReq}
 */
proto.accountmanager.CheckAvailableEnvReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.CheckAvailableEnvReq;
  return proto.accountmanager.CheckAvailableEnvReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.CheckAvailableEnvReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.CheckAvailableEnvReq}
 */
proto.accountmanager.CheckAvailableEnvReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.CheckAvailableEnvReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.CheckAvailableEnvReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.CheckAvailableEnvReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CheckAvailableEnvReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.CheckAvailableEnvReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.CheckAvailableEnvReq} returns this
 */
proto.accountmanager.CheckAvailableEnvReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.CheckAvailableEnvReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.CheckAvailableEnvReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.CheckAvailableEnvReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CheckAvailableEnvReply.toObject = function(includeInstance, msg) {
  var f, obj = {
hasCapacity: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.CheckAvailableEnvReply}
 */
proto.accountmanager.CheckAvailableEnvReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.CheckAvailableEnvReply;
  return proto.accountmanager.CheckAvailableEnvReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.CheckAvailableEnvReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.CheckAvailableEnvReply}
 */
proto.accountmanager.CheckAvailableEnvReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasCapacity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.CheckAvailableEnvReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.CheckAvailableEnvReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.CheckAvailableEnvReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CheckAvailableEnvReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasCapacity();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool has_capacity = 1;
 * @return {boolean}
 */
proto.accountmanager.CheckAvailableEnvReply.prototype.getHasCapacity = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.CheckAvailableEnvReply} returns this
 */
proto.accountmanager.CheckAvailableEnvReply.prototype.setHasCapacity = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntAdjustDedicatedEnvReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntAdjustDedicatedEnvReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntAdjustDedicatedEnvReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntAdjustDedicatedEnvReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntAdjustDedicatedEnvReq}
 */
proto.accountmanager.IntAdjustDedicatedEnvReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntAdjustDedicatedEnvReq;
  return proto.accountmanager.IntAdjustDedicatedEnvReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntAdjustDedicatedEnvReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntAdjustDedicatedEnvReq}
 */
proto.accountmanager.IntAdjustDedicatedEnvReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntAdjustDedicatedEnvReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntAdjustDedicatedEnvReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntAdjustDedicatedEnvReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntAdjustDedicatedEnvReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.IntAdjustDedicatedEnvReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntAdjustDedicatedEnvReq} returns this
 */
proto.accountmanager.IntAdjustDedicatedEnvReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.accountmanager.IntAdjustDedicatedEnvReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntAdjustDedicatedEnvReq} returns this
 */
proto.accountmanager.IntAdjustDedicatedEnvReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntAdjustDedicatedEnvReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntAdjustDedicatedEnvReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntAdjustDedicatedEnvReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntAdjustDedicatedEnvReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntAdjustDedicatedEnvReply}
 */
proto.accountmanager.IntAdjustDedicatedEnvReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntAdjustDedicatedEnvReply;
  return proto.accountmanager.IntAdjustDedicatedEnvReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntAdjustDedicatedEnvReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntAdjustDedicatedEnvReply}
 */
proto.accountmanager.IntAdjustDedicatedEnvReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntAdjustDedicatedEnvReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntAdjustDedicatedEnvReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntAdjustDedicatedEnvReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntAdjustDedicatedEnvReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddIpPoolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddIpPoolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddIpPoolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddIpPoolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
host: jspb.Message.getFieldWithDefault(msg, 1, ""),
location: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddIpPoolReq}
 */
proto.accountmanager.AdminAddIpPoolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddIpPoolReq;
  return proto.accountmanager.AdminAddIpPoolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddIpPoolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddIpPoolReq}
 */
proto.accountmanager.AdminAddIpPoolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddIpPoolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddIpPoolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddIpPoolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddIpPoolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string host = 1;
 * @return {string}
 */
proto.accountmanager.AdminAddIpPoolReq.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddIpPoolReq} returns this
 */
proto.accountmanager.AdminAddIpPoolReq.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string location = 2;
 * @return {string}
 */
proto.accountmanager.AdminAddIpPoolReq.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddIpPoolReq} returns this
 */
proto.accountmanager.AdminAddIpPoolReq.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddIpPoolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddIpPoolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddIpPoolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddIpPoolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddIpPoolReply}
 */
proto.accountmanager.AdminAddIpPoolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddIpPoolReply;
  return proto.accountmanager.AdminAddIpPoolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddIpPoolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddIpPoolReply}
 */
proto.accountmanager.AdminAddIpPoolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddIpPoolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddIpPoolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddIpPoolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddIpPoolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddDedicatedPodReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddDedicatedPodReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddDedicatedPodReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddDedicatedPodReq.toObject = function(includeInstance, msg) {
  var f, obj = {
pod: jspb.Message.getFieldWithDefault(msg, 1, ""),
platform: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddDedicatedPodReq}
 */
proto.accountmanager.AdminAddDedicatedPodReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddDedicatedPodReq;
  return proto.accountmanager.AdminAddDedicatedPodReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddDedicatedPodReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddDedicatedPodReq}
 */
proto.accountmanager.AdminAddDedicatedPodReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPod(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddDedicatedPodReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddDedicatedPodReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddDedicatedPodReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddDedicatedPodReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPod();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string pod = 1;
 * @return {string}
 */
proto.accountmanager.AdminAddDedicatedPodReq.prototype.getPod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddDedicatedPodReq} returns this
 */
proto.accountmanager.AdminAddDedicatedPodReq.prototype.setPod = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string platform = 2;
 * @return {string}
 */
proto.accountmanager.AdminAddDedicatedPodReq.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddDedicatedPodReq} returns this
 */
proto.accountmanager.AdminAddDedicatedPodReq.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddDedicatedPodReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddDedicatedPodReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddDedicatedPodReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddDedicatedPodReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddDedicatedPodReply}
 */
proto.accountmanager.AdminAddDedicatedPodReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddDedicatedPodReply;
  return proto.accountmanager.AdminAddDedicatedPodReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddDedicatedPodReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddDedicatedPodReply}
 */
proto.accountmanager.AdminAddDedicatedPodReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddDedicatedPodReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddDedicatedPodReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddDedicatedPodReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddDedicatedPodReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUpdateIpPoolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUpdateIpPoolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUpdateIpPoolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateIpPoolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
ipPoolId: jspb.Message.getFieldWithDefault(msg, 1, 0),
host: (f = msg.getHost()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
location: (f = msg.getLocation()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUpdateIpPoolReq}
 */
proto.accountmanager.AdminUpdateIpPoolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUpdateIpPoolReq;
  return proto.accountmanager.AdminUpdateIpPoolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUpdateIpPoolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUpdateIpPoolReq}
 */
proto.accountmanager.AdminUpdateIpPoolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setIpPoolId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setHost(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUpdateIpPoolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUpdateIpPoolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUpdateIpPoolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateIpPoolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIpPoolId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getHost();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 ip_pool_id = 1;
 * @return {number}
 */
proto.accountmanager.AdminUpdateIpPoolReq.prototype.getIpPoolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminUpdateIpPoolReq} returns this
 */
proto.accountmanager.AdminUpdateIpPoolReq.prototype.setIpPoolId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue host = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AdminUpdateIpPoolReq.prototype.getHost = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AdminUpdateIpPoolReq} returns this
*/
proto.accountmanager.AdminUpdateIpPoolReq.prototype.setHost = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminUpdateIpPoolReq} returns this
 */
proto.accountmanager.AdminUpdateIpPoolReq.prototype.clearHost = function() {
  return this.setHost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminUpdateIpPoolReq.prototype.hasHost = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue location = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AdminUpdateIpPoolReq.prototype.getLocation = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AdminUpdateIpPoolReq} returns this
*/
proto.accountmanager.AdminUpdateIpPoolReq.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminUpdateIpPoolReq} returns this
 */
proto.accountmanager.AdminUpdateIpPoolReq.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminUpdateIpPoolReq.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUpdateIpPoolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUpdateIpPoolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUpdateIpPoolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateIpPoolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUpdateIpPoolReply}
 */
proto.accountmanager.AdminUpdateIpPoolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUpdateIpPoolReply;
  return proto.accountmanager.AdminUpdateIpPoolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUpdateIpPoolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUpdateIpPoolReply}
 */
proto.accountmanager.AdminUpdateIpPoolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUpdateIpPoolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUpdateIpPoolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUpdateIpPoolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateIpPoolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUpdateDedicatedPodReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUpdateDedicatedPodReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUpdateDedicatedPodReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateDedicatedPodReq.toObject = function(includeInstance, msg) {
  var f, obj = {
dedicatedPodId: jspb.Message.getFieldWithDefault(msg, 1, 0),
pod: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUpdateDedicatedPodReq}
 */
proto.accountmanager.AdminUpdateDedicatedPodReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUpdateDedicatedPodReq;
  return proto.accountmanager.AdminUpdateDedicatedPodReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUpdateDedicatedPodReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUpdateDedicatedPodReq}
 */
proto.accountmanager.AdminUpdateDedicatedPodReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDedicatedPodId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUpdateDedicatedPodReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUpdateDedicatedPodReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUpdateDedicatedPodReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateDedicatedPodReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDedicatedPodId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPod();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 dedicated_pod_id = 1;
 * @return {number}
 */
proto.accountmanager.AdminUpdateDedicatedPodReq.prototype.getDedicatedPodId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminUpdateDedicatedPodReq} returns this
 */
proto.accountmanager.AdminUpdateDedicatedPodReq.prototype.setDedicatedPodId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string pod = 2;
 * @return {string}
 */
proto.accountmanager.AdminUpdateDedicatedPodReq.prototype.getPod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminUpdateDedicatedPodReq} returns this
 */
proto.accountmanager.AdminUpdateDedicatedPodReq.prototype.setPod = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUpdateDedicatedPodReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUpdateDedicatedPodReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUpdateDedicatedPodReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateDedicatedPodReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUpdateDedicatedPodReply}
 */
proto.accountmanager.AdminUpdateDedicatedPodReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUpdateDedicatedPodReply;
  return proto.accountmanager.AdminUpdateDedicatedPodReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUpdateDedicatedPodReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUpdateDedicatedPodReply}
 */
proto.accountmanager.AdminUpdateDedicatedPodReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUpdateDedicatedPodReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUpdateDedicatedPodReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUpdateDedicatedPodReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateDedicatedPodReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteIpPoolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteIpPoolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteIpPoolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteIpPoolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
ipPoolId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteIpPoolReq}
 */
proto.accountmanager.AdminDeleteIpPoolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteIpPoolReq;
  return proto.accountmanager.AdminDeleteIpPoolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteIpPoolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteIpPoolReq}
 */
proto.accountmanager.AdminDeleteIpPoolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setIpPoolId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteIpPoolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteIpPoolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteIpPoolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteIpPoolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIpPoolId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 ip_pool_id = 1;
 * @return {number}
 */
proto.accountmanager.AdminDeleteIpPoolReq.prototype.getIpPoolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminDeleteIpPoolReq} returns this
 */
proto.accountmanager.AdminDeleteIpPoolReq.prototype.setIpPoolId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteIpPoolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteIpPoolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteIpPoolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteIpPoolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteIpPoolReply}
 */
proto.accountmanager.AdminDeleteIpPoolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteIpPoolReply;
  return proto.accountmanager.AdminDeleteIpPoolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteIpPoolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteIpPoolReply}
 */
proto.accountmanager.AdminDeleteIpPoolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteIpPoolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteIpPoolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteIpPoolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteIpPoolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteDedicatedPodReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteDedicatedPodReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteDedicatedPodReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteDedicatedPodReq.toObject = function(includeInstance, msg) {
  var f, obj = {
dedicatedPodId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteDedicatedPodReq}
 */
proto.accountmanager.AdminDeleteDedicatedPodReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteDedicatedPodReq;
  return proto.accountmanager.AdminDeleteDedicatedPodReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteDedicatedPodReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteDedicatedPodReq}
 */
proto.accountmanager.AdminDeleteDedicatedPodReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDedicatedPodId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteDedicatedPodReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteDedicatedPodReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteDedicatedPodReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteDedicatedPodReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDedicatedPodId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 dedicated_pod_id = 1;
 * @return {number}
 */
proto.accountmanager.AdminDeleteDedicatedPodReq.prototype.getDedicatedPodId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminDeleteDedicatedPodReq} returns this
 */
proto.accountmanager.AdminDeleteDedicatedPodReq.prototype.setDedicatedPodId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteDedicatedPodReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteDedicatedPodReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteDedicatedPodReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteDedicatedPodReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteDedicatedPodReply}
 */
proto.accountmanager.AdminDeleteDedicatedPodReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteDedicatedPodReply;
  return proto.accountmanager.AdminDeleteDedicatedPodReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteDedicatedPodReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteDedicatedPodReply}
 */
proto.accountmanager.AdminDeleteDedicatedPodReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteDedicatedPodReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteDedicatedPodReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteDedicatedPodReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteDedicatedPodReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UpdateDedicatedEnvReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UpdateDedicatedEnvReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UpdateDedicatedEnvReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateDedicatedEnvReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
dedicatedEnvId: jspb.Message.getFieldWithDefault(msg, 2, ""),
nickName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UpdateDedicatedEnvReq}
 */
proto.accountmanager.UpdateDedicatedEnvReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UpdateDedicatedEnvReq;
  return proto.accountmanager.UpdateDedicatedEnvReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UpdateDedicatedEnvReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UpdateDedicatedEnvReq}
 */
proto.accountmanager.UpdateDedicatedEnvReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDedicatedEnvId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UpdateDedicatedEnvReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UpdateDedicatedEnvReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UpdateDedicatedEnvReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateDedicatedEnvReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDedicatedEnvId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNickName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.UpdateDedicatedEnvReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UpdateDedicatedEnvReq} returns this
 */
proto.accountmanager.UpdateDedicatedEnvReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string dedicated_env_id = 2;
 * @return {string}
 */
proto.accountmanager.UpdateDedicatedEnvReq.prototype.getDedicatedEnvId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UpdateDedicatedEnvReq} returns this
 */
proto.accountmanager.UpdateDedicatedEnvReq.prototype.setDedicatedEnvId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string nick_name = 3;
 * @return {string}
 */
proto.accountmanager.UpdateDedicatedEnvReq.prototype.getNickName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UpdateDedicatedEnvReq} returns this
 */
proto.accountmanager.UpdateDedicatedEnvReq.prototype.setNickName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UpdateDedicatedEnvReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UpdateDedicatedEnvReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UpdateDedicatedEnvReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateDedicatedEnvReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UpdateDedicatedEnvReply}
 */
proto.accountmanager.UpdateDedicatedEnvReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UpdateDedicatedEnvReply;
  return proto.accountmanager.UpdateDedicatedEnvReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UpdateDedicatedEnvReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UpdateDedicatedEnvReply}
 */
proto.accountmanager.UpdateDedicatedEnvReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UpdateDedicatedEnvReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UpdateDedicatedEnvReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UpdateDedicatedEnvReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateDedicatedEnvReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetUsersDedicatedEnvListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetUsersDedicatedEnvListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetUsersDedicatedEnvListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetUsersDedicatedEnvListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetUsersDedicatedEnvListReq}
 */
proto.accountmanager.GetUsersDedicatedEnvListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetUsersDedicatedEnvListReq;
  return proto.accountmanager.GetUsersDedicatedEnvListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetUsersDedicatedEnvListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetUsersDedicatedEnvListReq}
 */
proto.accountmanager.GetUsersDedicatedEnvListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetUsersDedicatedEnvListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetUsersDedicatedEnvListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetUsersDedicatedEnvListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetUsersDedicatedEnvListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GetUsersDedicatedEnvListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetUsersDedicatedEnvListReq} returns this
 */
proto.accountmanager.GetUsersDedicatedEnvListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.DedicatedEnv.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.DedicatedEnv.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.DedicatedEnv} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DedicatedEnv.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
nickName: jspb.Message.getFieldWithDefault(msg, 3, ""),
proxyHost: jspb.Message.getFieldWithDefault(msg, 4, ""),
proxyType: jspb.Message.getFieldWithDefault(msg, 5, ""),
accountLimit: jspb.Message.getFieldWithDefault(msg, 6, 0),
accountsCount: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.DedicatedEnv}
 */
proto.accountmanager.DedicatedEnv.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.DedicatedEnv;
  return proto.accountmanager.DedicatedEnv.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.DedicatedEnv} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.DedicatedEnv}
 */
proto.accountmanager.DedicatedEnv.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProxyHost(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProxyType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountLimit(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountsCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.DedicatedEnv.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.DedicatedEnv.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.DedicatedEnv} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DedicatedEnv.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNickName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProxyHost();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProxyType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountLimit();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAccountsCount();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.accountmanager.DedicatedEnv.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DedicatedEnv} returns this
 */
proto.accountmanager.DedicatedEnv.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.accountmanager.DedicatedEnv.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DedicatedEnv} returns this
 */
proto.accountmanager.DedicatedEnv.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string nick_name = 3;
 * @return {string}
 */
proto.accountmanager.DedicatedEnv.prototype.getNickName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DedicatedEnv} returns this
 */
proto.accountmanager.DedicatedEnv.prototype.setNickName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string proxy_host = 4;
 * @return {string}
 */
proto.accountmanager.DedicatedEnv.prototype.getProxyHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DedicatedEnv} returns this
 */
proto.accountmanager.DedicatedEnv.prototype.setProxyHost = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string proxy_type = 5;
 * @return {string}
 */
proto.accountmanager.DedicatedEnv.prototype.getProxyType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DedicatedEnv} returns this
 */
proto.accountmanager.DedicatedEnv.prototype.setProxyType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 account_limit = 6;
 * @return {number}
 */
proto.accountmanager.DedicatedEnv.prototype.getAccountLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.DedicatedEnv} returns this
 */
proto.accountmanager.DedicatedEnv.prototype.setAccountLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 accounts_count = 7;
 * @return {number}
 */
proto.accountmanager.DedicatedEnv.prototype.getAccountsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.DedicatedEnv} returns this
 */
proto.accountmanager.DedicatedEnv.prototype.setAccountsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GetUsersDedicatedEnvListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetUsersDedicatedEnvListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetUsersDedicatedEnvListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetUsersDedicatedEnvListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetUsersDedicatedEnvListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
dedicatedEnvsList: jspb.Message.toObjectList(msg.getDedicatedEnvsList(),
    proto.accountmanager.DedicatedEnv.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetUsersDedicatedEnvListReply}
 */
proto.accountmanager.GetUsersDedicatedEnvListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetUsersDedicatedEnvListReply;
  return proto.accountmanager.GetUsersDedicatedEnvListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetUsersDedicatedEnvListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetUsersDedicatedEnvListReply}
 */
proto.accountmanager.GetUsersDedicatedEnvListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.DedicatedEnv;
      reader.readMessage(value,proto.accountmanager.DedicatedEnv.deserializeBinaryFromReader);
      msg.addDedicatedEnvs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetUsersDedicatedEnvListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetUsersDedicatedEnvListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetUsersDedicatedEnvListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetUsersDedicatedEnvListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDedicatedEnvsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.DedicatedEnv.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DedicatedEnv dedicated_envs = 1;
 * @return {!Array<!proto.accountmanager.DedicatedEnv>}
 */
proto.accountmanager.GetUsersDedicatedEnvListReply.prototype.getDedicatedEnvsList = function() {
  return /** @type{!Array<!proto.accountmanager.DedicatedEnv>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.DedicatedEnv, 1));
};


/**
 * @param {!Array<!proto.accountmanager.DedicatedEnv>} value
 * @return {!proto.accountmanager.GetUsersDedicatedEnvListReply} returns this
*/
proto.accountmanager.GetUsersDedicatedEnvListReply.prototype.setDedicatedEnvsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.DedicatedEnv=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.DedicatedEnv}
 */
proto.accountmanager.GetUsersDedicatedEnvListReply.prototype.addDedicatedEnvs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.DedicatedEnv, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GetUsersDedicatedEnvListReply} returns this
 */
proto.accountmanager.GetUsersDedicatedEnvListReply.prototype.clearDedicatedEnvsList = function() {
  return this.setDedicatedEnvsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminCloseAccountsTradesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminCloseAccountsTradesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminCloseAccountsTradesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCloseAccountsTradesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminCloseAccountsTradesReq}
 */
proto.accountmanager.AdminCloseAccountsTradesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminCloseAccountsTradesReq;
  return proto.accountmanager.AdminCloseAccountsTradesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminCloseAccountsTradesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminCloseAccountsTradesReq}
 */
proto.accountmanager.AdminCloseAccountsTradesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminCloseAccountsTradesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminCloseAccountsTradesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminCloseAccountsTradesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCloseAccountsTradesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminCloseAccountsTradesReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminCloseAccountsTradesReq} returns this
 */
proto.accountmanager.AdminCloseAccountsTradesReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminCloseAccountsTradesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminCloseAccountsTradesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminCloseAccountsTradesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCloseAccountsTradesReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminCloseAccountsTradesReply}
 */
proto.accountmanager.AdminCloseAccountsTradesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminCloseAccountsTradesReply;
  return proto.accountmanager.AdminCloseAccountsTradesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminCloseAccountsTradesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminCloseAccountsTradesReply}
 */
proto.accountmanager.AdminCloseAccountsTradesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminCloseAccountsTradesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminCloseAccountsTradesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminCloseAccountsTradesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCloseAccountsTradesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetEPSettingsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetEPSettingsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetEPSettingsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetEPSettingsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetEPSettingsReq}
 */
proto.accountmanager.AdminGetEPSettingsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetEPSettingsReq;
  return proto.accountmanager.AdminGetEPSettingsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetEPSettingsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetEPSettingsReq}
 */
proto.accountmanager.AdminGetEPSettingsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetEPSettingsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetEPSettingsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetEPSettingsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetEPSettingsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminGetEPSettingsReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReq} returns this
 */
proto.accountmanager.AdminGetEPSettingsReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminGetEPSettingsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReq} returns this
 */
proto.accountmanager.AdminGetEPSettingsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetEPSettingsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetEPSettingsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetEPSettingsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
manageExisting: (f = msg.getManageExisting()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
closeCopiedOpenTrades: (f = msg.getCloseCopiedOpenTrades()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
closeAllOpenTrades: (f = msg.getCloseAllOpenTrades()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
drawDownPercentage: (f = msg.getDrawDownPercentage()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
drawDownDifferenceValue: (f = msg.getDrawDownDifferenceValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
absoluteMinimum: (f = msg.getAbsoluteMinimum()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
absoluteMaximum: (f = msg.getAbsoluteMaximum()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
enableEp: (f = msg.getEnableEp()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
profitPercentage: (f = msg.getProfitPercentage()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
profitDifferenceValue: (f = msg.getProfitDifferenceValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
configurationStyle: (f = msg.getConfigurationStyle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
timelyResetSetting: (f = msg.getTimelyResetSetting()) && proto.accountmanager.TimelyReset.toObject(includeInstance, f),
accountBalance: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
stopLossProtectionValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
takeProfitProtectionValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply}
 */
proto.accountmanager.AdminGetEPSettingsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetEPSettingsReply;
  return proto.accountmanager.AdminGetEPSettingsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetEPSettingsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply}
 */
proto.accountmanager.AdminGetEPSettingsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setManageExisting(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCloseCopiedOpenTrades(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCloseAllOpenTrades(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setDrawDownPercentage(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setDrawDownDifferenceValue(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setAbsoluteMinimum(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setAbsoluteMaximum(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnableEp(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setProfitPercentage(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setProfitDifferenceValue(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setConfigurationStyle(value);
      break;
    case 13:
      var value = new proto.accountmanager.TimelyReset;
      reader.readMessage(value,proto.accountmanager.TimelyReset.deserializeBinaryFromReader);
      msg.setTimelyResetSetting(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAccountBalance(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStopLossProtectionValue(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTakeProfitProtectionValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetEPSettingsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetEPSettingsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetEPSettingsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getManageExisting();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseCopiedOpenTrades();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseAllOpenTrades();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getDrawDownPercentage();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getDrawDownDifferenceValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getAbsoluteMinimum();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getAbsoluteMaximum();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getEnableEp();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitPercentage();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitDifferenceValue();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getConfigurationStyle();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimelyResetSetting();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.accountmanager.TimelyReset.serializeBinaryToWriter
    );
  }
  f = message.getAccountBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getStopLossProtectionValue();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getTakeProfitProtectionValue();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.BoolValue manage_existing = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getManageExisting = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setManageExisting = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearManageExisting = function() {
  return this.setManageExisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasManageExisting = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue close_copied_open_trades = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getCloseCopiedOpenTrades = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setCloseCopiedOpenTrades = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearCloseCopiedOpenTrades = function() {
  return this.setCloseCopiedOpenTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasCloseCopiedOpenTrades = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue close_all_open_trades = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getCloseAllOpenTrades = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setCloseAllOpenTrades = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearCloseAllOpenTrades = function() {
  return this.setCloseAllOpenTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasCloseAllOpenTrades = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue draw_down_percentage = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getDrawDownPercentage = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setDrawDownPercentage = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearDrawDownPercentage = function() {
  return this.setDrawDownPercentage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasDrawDownPercentage = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue draw_down_difference_value = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getDrawDownDifferenceValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setDrawDownDifferenceValue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearDrawDownDifferenceValue = function() {
  return this.setDrawDownDifferenceValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasDrawDownDifferenceValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.DoubleValue absolute_minimum = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getAbsoluteMinimum = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setAbsoluteMinimum = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearAbsoluteMinimum = function() {
  return this.setAbsoluteMinimum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasAbsoluteMinimum = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.DoubleValue absolute_maximum = 8;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getAbsoluteMaximum = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 8));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setAbsoluteMaximum = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearAbsoluteMaximum = function() {
  return this.setAbsoluteMaximum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasAbsoluteMaximum = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.BoolValue enable_ep = 9;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getEnableEp = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 9));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setEnableEp = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearEnableEp = function() {
  return this.setEnableEp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasEnableEp = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.DoubleValue profit_percentage = 10;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getProfitPercentage = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 10));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setProfitPercentage = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearProfitPercentage = function() {
  return this.setProfitPercentage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasProfitPercentage = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.DoubleValue profit_difference_value = 11;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getProfitDifferenceValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 11));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setProfitDifferenceValue = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearProfitDifferenceValue = function() {
  return this.setProfitDifferenceValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasProfitDifferenceValue = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue configuration_style = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getConfigurationStyle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setConfigurationStyle = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearConfigurationStyle = function() {
  return this.setConfigurationStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasConfigurationStyle = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional TimelyReset timely_reset_setting = 13;
 * @return {?proto.accountmanager.TimelyReset}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getTimelyResetSetting = function() {
  return /** @type{?proto.accountmanager.TimelyReset} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.TimelyReset, 13));
};


/**
 * @param {?proto.accountmanager.TimelyReset|undefined} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
*/
proto.accountmanager.AdminGetEPSettingsReply.prototype.setTimelyResetSetting = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.clearTimelyResetSetting = function() {
  return this.setTimelyResetSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.hasTimelyResetSetting = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional double account_balance = 14;
 * @return {number}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getAccountBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.setAccountBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double stop_loss_protection_value = 15;
 * @return {number}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getStopLossProtectionValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.setStopLossProtectionValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double take_profit_protection_value = 16;
 * @return {number}
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.getTakeProfitProtectionValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminGetEPSettingsReply} returns this
 */
proto.accountmanager.AdminGetEPSettingsReply.prototype.setTakeProfitProtectionValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteAccountReq}
 */
proto.accountmanager.AdminDeleteAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteAccountReq;
  return proto.accountmanager.AdminDeleteAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteAccountReq}
 */
proto.accountmanager.AdminDeleteAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminDeleteAccountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminDeleteAccountReq} returns this
 */
proto.accountmanager.AdminDeleteAccountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminDeleteAccountReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminDeleteAccountReq} returns this
 */
proto.accountmanager.AdminDeleteAccountReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteAccountReply}
 */
proto.accountmanager.AdminDeleteAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteAccountReply;
  return proto.accountmanager.AdminDeleteAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteAccountReply}
 */
proto.accountmanager.AdminDeleteAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.CloseAccountsTradesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.CloseAccountsTradesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.CloseAccountsTradesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CloseAccountsTradesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.CloseAccountsTradesReq}
 */
proto.accountmanager.CloseAccountsTradesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.CloseAccountsTradesReq;
  return proto.accountmanager.CloseAccountsTradesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.CloseAccountsTradesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.CloseAccountsTradesReq}
 */
proto.accountmanager.CloseAccountsTradesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.CloseAccountsTradesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.CloseAccountsTradesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.CloseAccountsTradesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CloseAccountsTradesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.CloseAccountsTradesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.CloseAccountsTradesReq} returns this
 */
proto.accountmanager.CloseAccountsTradesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.CloseAccountsTradesReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.CloseAccountsTradesReq} returns this
 */
proto.accountmanager.CloseAccountsTradesReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.CloseAccountsTradesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.CloseAccountsTradesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.CloseAccountsTradesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CloseAccountsTradesReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.CloseAccountsTradesReply}
 */
proto.accountmanager.CloseAccountsTradesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.CloseAccountsTradesReply;
  return proto.accountmanager.CloseAccountsTradesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.CloseAccountsTradesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.CloseAccountsTradesReply}
 */
proto.accountmanager.CloseAccountsTradesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.CloseAccountsTradesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.CloseAccountsTradesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.CloseAccountsTradesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CloseAccountsTradesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetEPSettingsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetEPSettingsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetEPSettingsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetEPSettingsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetEPSettingsReq}
 */
proto.accountmanager.GetEPSettingsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetEPSettingsReq;
  return proto.accountmanager.GetEPSettingsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetEPSettingsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetEPSettingsReq}
 */
proto.accountmanager.GetEPSettingsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetEPSettingsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetEPSettingsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetEPSettingsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetEPSettingsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.GetEPSettingsReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetEPSettingsReq} returns this
 */
proto.accountmanager.GetEPSettingsReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.accountmanager.GetEPSettingsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetEPSettingsReq} returns this
 */
proto.accountmanager.GetEPSettingsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetEPSettingsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetEPSettingsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetEPSettingsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetEPSettingsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
manageExisting: (f = msg.getManageExisting()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
closeCopiedOpenTrades: (f = msg.getCloseCopiedOpenTrades()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
closeAllOpenTrades: (f = msg.getCloseAllOpenTrades()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
drawDownPercentage: (f = msg.getDrawDownPercentage()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
drawDownDifferenceValue: (f = msg.getDrawDownDifferenceValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
absoluteMinimum: (f = msg.getAbsoluteMinimum()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
absoluteMaximum: (f = msg.getAbsoluteMaximum()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
enableEp: (f = msg.getEnableEp()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
profitPercentage: (f = msg.getProfitPercentage()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
profitDifferenceValue: (f = msg.getProfitDifferenceValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
configurationStyle: (f = msg.getConfigurationStyle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
timelyResetSetting: (f = msg.getTimelyResetSetting()) && proto.accountmanager.TimelyReset.toObject(includeInstance, f),
accountBalance: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
stopLossProtectionValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
takeProfitProtectionValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetEPSettingsReply}
 */
proto.accountmanager.GetEPSettingsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetEPSettingsReply;
  return proto.accountmanager.GetEPSettingsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetEPSettingsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetEPSettingsReply}
 */
proto.accountmanager.GetEPSettingsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setManageExisting(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCloseCopiedOpenTrades(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCloseAllOpenTrades(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setDrawDownPercentage(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setDrawDownDifferenceValue(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setAbsoluteMinimum(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setAbsoluteMaximum(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnableEp(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setProfitPercentage(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setProfitDifferenceValue(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setConfigurationStyle(value);
      break;
    case 13:
      var value = new proto.accountmanager.TimelyReset;
      reader.readMessage(value,proto.accountmanager.TimelyReset.deserializeBinaryFromReader);
      msg.setTimelyResetSetting(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAccountBalance(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStopLossProtectionValue(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTakeProfitProtectionValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetEPSettingsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetEPSettingsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetEPSettingsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetEPSettingsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getManageExisting();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseCopiedOpenTrades();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseAllOpenTrades();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getDrawDownPercentage();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getDrawDownDifferenceValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getAbsoluteMinimum();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getAbsoluteMaximum();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getEnableEp();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitPercentage();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitDifferenceValue();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getConfigurationStyle();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimelyResetSetting();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.accountmanager.TimelyReset.serializeBinaryToWriter
    );
  }
  f = message.getAccountBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getStopLossProtectionValue();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getTakeProfitProtectionValue();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.BoolValue manage_existing = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getManageExisting = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setManageExisting = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearManageExisting = function() {
  return this.setManageExisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasManageExisting = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue close_copied_open_trades = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getCloseCopiedOpenTrades = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setCloseCopiedOpenTrades = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearCloseCopiedOpenTrades = function() {
  return this.setCloseCopiedOpenTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasCloseCopiedOpenTrades = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue close_all_open_trades = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getCloseAllOpenTrades = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setCloseAllOpenTrades = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearCloseAllOpenTrades = function() {
  return this.setCloseAllOpenTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasCloseAllOpenTrades = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue draw_down_percentage = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getDrawDownPercentage = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setDrawDownPercentage = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearDrawDownPercentage = function() {
  return this.setDrawDownPercentage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasDrawDownPercentage = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue draw_down_difference_value = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getDrawDownDifferenceValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setDrawDownDifferenceValue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearDrawDownDifferenceValue = function() {
  return this.setDrawDownDifferenceValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasDrawDownDifferenceValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.DoubleValue absolute_minimum = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getAbsoluteMinimum = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setAbsoluteMinimum = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearAbsoluteMinimum = function() {
  return this.setAbsoluteMinimum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasAbsoluteMinimum = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.DoubleValue absolute_maximum = 8;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getAbsoluteMaximum = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 8));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setAbsoluteMaximum = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearAbsoluteMaximum = function() {
  return this.setAbsoluteMaximum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasAbsoluteMaximum = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.BoolValue enable_ep = 9;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getEnableEp = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 9));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setEnableEp = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearEnableEp = function() {
  return this.setEnableEp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasEnableEp = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.DoubleValue profit_percentage = 10;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getProfitPercentage = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 10));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setProfitPercentage = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearProfitPercentage = function() {
  return this.setProfitPercentage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasProfitPercentage = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.DoubleValue profit_difference_value = 11;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getProfitDifferenceValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 11));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setProfitDifferenceValue = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearProfitDifferenceValue = function() {
  return this.setProfitDifferenceValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasProfitDifferenceValue = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue configuration_style = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getConfigurationStyle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setConfigurationStyle = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearConfigurationStyle = function() {
  return this.setConfigurationStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasConfigurationStyle = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional TimelyReset timely_reset_setting = 13;
 * @return {?proto.accountmanager.TimelyReset}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getTimelyResetSetting = function() {
  return /** @type{?proto.accountmanager.TimelyReset} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.TimelyReset, 13));
};


/**
 * @param {?proto.accountmanager.TimelyReset|undefined} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
*/
proto.accountmanager.GetEPSettingsReply.prototype.setTimelyResetSetting = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.clearTimelyResetSetting = function() {
  return this.setTimelyResetSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetEPSettingsReply.prototype.hasTimelyResetSetting = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional double account_balance = 14;
 * @return {number}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getAccountBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.setAccountBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double stop_loss_protection_value = 15;
 * @return {number}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getStopLossProtectionValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.setStopLossProtectionValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double take_profit_protection_value = 16;
 * @return {number}
 */
proto.accountmanager.GetEPSettingsReply.prototype.getTakeProfitProtectionValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.GetEPSettingsReply} returns this
 */
proto.accountmanager.GetEPSettingsReply.prototype.setTakeProfitProtectionValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UpsertEPSettingsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UpsertEPSettingsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpsertEPSettingsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
manageExisting: (f = msg.getManageExisting()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
closeAllOpenTrades: (f = msg.getCloseAllOpenTrades()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
drawDownPercentage: (f = msg.getDrawDownPercentage()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
drawDownDifferenceValue: (f = msg.getDrawDownDifferenceValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
absoluteMinimum: (f = msg.getAbsoluteMinimum()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
absoluteMaximum: (f = msg.getAbsoluteMaximum()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
closeCopiedOpenTrades: (f = msg.getCloseCopiedOpenTrades()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
profitPercentage: (f = msg.getProfitPercentage()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
profitDifferenceValue: (f = msg.getProfitDifferenceValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
enableEp: (f = msg.getEnableEp()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
configurationStyle: (f = msg.getConfigurationStyle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
timelyResetSetting: (f = msg.getTimelyResetSetting()) && proto.accountmanager.TimelyReset.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UpsertEPSettingsReq}
 */
proto.accountmanager.UpsertEPSettingsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UpsertEPSettingsReq;
  return proto.accountmanager.UpsertEPSettingsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UpsertEPSettingsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UpsertEPSettingsReq}
 */
proto.accountmanager.UpsertEPSettingsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setManageExisting(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCloseAllOpenTrades(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setDrawDownPercentage(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setDrawDownDifferenceValue(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setAbsoluteMinimum(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setAbsoluteMaximum(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCloseCopiedOpenTrades(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setProfitPercentage(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setProfitDifferenceValue(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnableEp(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setConfigurationStyle(value);
      break;
    case 14:
      var value = new proto.accountmanager.TimelyReset;
      reader.readMessage(value,proto.accountmanager.TimelyReset.deserializeBinaryFromReader);
      msg.setTimelyResetSetting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UpsertEPSettingsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UpsertEPSettingsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpsertEPSettingsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getManageExisting();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseAllOpenTrades();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getDrawDownPercentage();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getDrawDownDifferenceValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getAbsoluteMinimum();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getAbsoluteMaximum();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseCopiedOpenTrades();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitPercentage();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitDifferenceValue();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getEnableEp();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getConfigurationStyle();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimelyResetSetting();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.accountmanager.TimelyReset.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.BoolValue manage_existing = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getManageExisting = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setManageExisting = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearManageExisting = function() {
  return this.setManageExisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasManageExisting = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue close_all_open_trades = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getCloseAllOpenTrades = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setCloseAllOpenTrades = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearCloseAllOpenTrades = function() {
  return this.setCloseAllOpenTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasCloseAllOpenTrades = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue draw_down_percentage = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getDrawDownPercentage = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setDrawDownPercentage = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearDrawDownPercentage = function() {
  return this.setDrawDownPercentage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasDrawDownPercentage = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue draw_down_difference_value = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getDrawDownDifferenceValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setDrawDownDifferenceValue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearDrawDownDifferenceValue = function() {
  return this.setDrawDownDifferenceValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasDrawDownDifferenceValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.DoubleValue absolute_minimum = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getAbsoluteMinimum = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setAbsoluteMinimum = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearAbsoluteMinimum = function() {
  return this.setAbsoluteMinimum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasAbsoluteMinimum = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.DoubleValue absolute_maximum = 8;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getAbsoluteMaximum = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 8));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setAbsoluteMaximum = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearAbsoluteMaximum = function() {
  return this.setAbsoluteMaximum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasAbsoluteMaximum = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.BoolValue close_copied_open_trades = 9;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getCloseCopiedOpenTrades = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 9));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setCloseCopiedOpenTrades = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearCloseCopiedOpenTrades = function() {
  return this.setCloseCopiedOpenTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasCloseCopiedOpenTrades = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.DoubleValue profit_percentage = 10;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getProfitPercentage = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 10));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setProfitPercentage = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearProfitPercentage = function() {
  return this.setProfitPercentage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasProfitPercentage = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.DoubleValue profit_difference_value = 11;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getProfitDifferenceValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 11));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setProfitDifferenceValue = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearProfitDifferenceValue = function() {
  return this.setProfitDifferenceValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasProfitDifferenceValue = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.BoolValue enable_ep = 12;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getEnableEp = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 12));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setEnableEp = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearEnableEp = function() {
  return this.setEnableEp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasEnableEp = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue configuration_style = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getConfigurationStyle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setConfigurationStyle = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearConfigurationStyle = function() {
  return this.setConfigurationStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasConfigurationStyle = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional TimelyReset timely_reset_setting = 14;
 * @return {?proto.accountmanager.TimelyReset}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.getTimelyResetSetting = function() {
  return /** @type{?proto.accountmanager.TimelyReset} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.TimelyReset, 14));
};


/**
 * @param {?proto.accountmanager.TimelyReset|undefined} value
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
*/
proto.accountmanager.UpsertEPSettingsReq.prototype.setTimelyResetSetting = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpsertEPSettingsReq} returns this
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.clearTimelyResetSetting = function() {
  return this.setTimelyResetSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpsertEPSettingsReq.prototype.hasTimelyResetSetting = function() {
  return jspb.Message.getField(this, 14) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UpsertEPSettingsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UpsertEPSettingsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UpsertEPSettingsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpsertEPSettingsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UpsertEPSettingsReply}
 */
proto.accountmanager.UpsertEPSettingsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UpsertEPSettingsReply;
  return proto.accountmanager.UpsertEPSettingsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UpsertEPSettingsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UpsertEPSettingsReply}
 */
proto.accountmanager.UpsertEPSettingsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UpsertEPSettingsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UpsertEPSettingsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UpsertEPSettingsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpsertEPSettingsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminSyncSymbolsReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminSyncSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminSyncSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminSyncSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSyncSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminSyncSymbolsReq}
 */
proto.accountmanager.AdminSyncSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminSyncSymbolsReq;
  return proto.accountmanager.AdminSyncSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminSyncSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminSyncSymbolsReq}
 */
proto.accountmanager.AdminSyncSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminSyncSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminSyncSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminSyncSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSyncSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.AdminSyncSymbolsReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.AdminSyncSymbolsReq} returns this
 */
proto.accountmanager.AdminSyncSymbolsReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AdminSyncSymbolsReq} returns this
 */
proto.accountmanager.AdminSyncSymbolsReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminSyncSymbolsReq} returns this
 */
proto.accountmanager.AdminSyncSymbolsReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminSyncSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminSyncSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminSyncSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSyncSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminSyncSymbolsReply}
 */
proto.accountmanager.AdminSyncSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminSyncSymbolsReply;
  return proto.accountmanager.AdminSyncSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminSyncSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminSyncSymbolsReply}
 */
proto.accountmanager.AdminSyncSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminSyncSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminSyncSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminSyncSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSyncSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminEnableAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminEnableAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminEnableAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
enable: (f = msg.getEnable()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
priority: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminEnableAccountReq}
 */
proto.accountmanager.AdminEnableAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminEnableAccountReq;
  return proto.accountmanager.AdminEnableAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminEnableAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminEnableAccountReq}
 */
proto.accountmanager.AdminEnableAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnable(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminEnableAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminEnableAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminEnableAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnable();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getPriority();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminEnableAccountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminEnableAccountReq} returns this
 */
proto.accountmanager.AdminEnableAccountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminEnableAccountReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminEnableAccountReq} returns this
 */
proto.accountmanager.AdminEnableAccountReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.BoolValue enable = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.AdminEnableAccountReq.prototype.getEnable = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.AdminEnableAccountReq} returns this
*/
proto.accountmanager.AdminEnableAccountReq.prototype.setEnable = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminEnableAccountReq} returns this
 */
proto.accountmanager.AdminEnableAccountReq.prototype.clearEnable = function() {
  return this.setEnable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminEnableAccountReq.prototype.hasEnable = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 priority = 4;
 * @return {number}
 */
proto.accountmanager.AdminEnableAccountReq.prototype.getPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminEnableAccountReq} returns this
 */
proto.accountmanager.AdminEnableAccountReq.prototype.setPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminEnableAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminEnableAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminEnableAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
failedPriority: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminEnableAccountReply}
 */
proto.accountmanager.AdminEnableAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminEnableAccountReply;
  return proto.accountmanager.AdminEnableAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminEnableAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminEnableAccountReply}
 */
proto.accountmanager.AdminEnableAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFailedPriority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminEnableAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminEnableAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminEnableAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getFailedPriority();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.accountmanager.AdminEnableAccountReply.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AdminEnableAccountReply} returns this
 */
proto.accountmanager.AdminEnableAccountReply.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 failed_priority = 2;
 * @return {number}
 */
proto.accountmanager.AdminEnableAccountReply.prototype.getFailedPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminEnableAccountReply} returns this
 */
proto.accountmanager.AdminEnableAccountReply.prototype.setFailedPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminListAccountSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminListAccountSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListAccountSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
query: jspb.Message.getFieldWithDefault(msg, 3, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 4, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminListAccountSymbolsReq}
 */
proto.accountmanager.AdminListAccountSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminListAccountSymbolsReq;
  return proto.accountmanager.AdminListAccountSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminListAccountSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminListAccountSymbolsReq}
 */
proto.accountmanager.AdminListAccountSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminListAccountSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminListAccountSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListAccountSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListAccountSymbolsReq} returns this
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListAccountSymbolsReq} returns this
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string query = 3;
 * @return {string}
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListAccountSymbolsReq} returns this
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string pagination_cursor = 4;
 * @return {string}
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListAccountSymbolsReq} returns this
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 page_size = 5;
 * @return {number}
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListAccountSymbolsReq} returns this
 */
proto.accountmanager.AdminListAccountSymbolsReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminListAccountSymbolsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminListAccountSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminListAccountSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListAccountSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
symbolsList: jspb.Message.toObjectList(msg.getSymbolsList(),
    proto.accountmanager.Symbol.toObject, includeInstance),
allEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 3, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
total: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminListAccountSymbolsReply}
 */
proto.accountmanager.AdminListAccountSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminListAccountSymbolsReply;
  return proto.accountmanager.AdminListAccountSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminListAccountSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminListAccountSymbolsReply}
 */
proto.accountmanager.AdminListAccountSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.Symbol;
      reader.readMessage(value,proto.accountmanager.Symbol.deserializeBinaryFromReader);
      msg.addSymbols(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllEnabled(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminListAccountSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminListAccountSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListAccountSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.Symbol.serializeBinaryToWriter
    );
  }
  f = message.getAllEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * repeated Symbol symbols = 1;
 * @return {!Array<!proto.accountmanager.Symbol>}
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.getSymbolsList = function() {
  return /** @type{!Array<!proto.accountmanager.Symbol>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.Symbol, 1));
};


/**
 * @param {!Array<!proto.accountmanager.Symbol>} value
 * @return {!proto.accountmanager.AdminListAccountSymbolsReply} returns this
*/
proto.accountmanager.AdminListAccountSymbolsReply.prototype.setSymbolsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.Symbol=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.Symbol}
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.addSymbols = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.Symbol, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminListAccountSymbolsReply} returns this
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.clearSymbolsList = function() {
  return this.setSymbolsList([]);
};


/**
 * optional bool all_enabled = 2;
 * @return {boolean}
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.getAllEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AdminListAccountSymbolsReply} returns this
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.setAllEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string next_page_cursor = 3;
 * @return {string}
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListAccountSymbolsReply} returns this
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 page_size = 4;
 * @return {number}
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListAccountSymbolsReply} returns this
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 total = 5;
 * @return {number}
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListAccountSymbolsReply} returns this
 */
proto.accountmanager.AdminListAccountSymbolsReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminCopierLogsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminCopierLogsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminCopierLogsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCopierLogsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
searchNumber: (f = msg.getSearchNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminCopierLogsReq}
 */
proto.accountmanager.AdminCopierLogsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminCopierLogsReq;
  return proto.accountmanager.AdminCopierLogsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminCopierLogsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminCopierLogsReq}
 */
proto.accountmanager.AdminCopierLogsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSearchNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminCopierLogsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminCopierLogsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminCopierLogsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCopierLogsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSearchNumber();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminCopierLogsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminCopierLogsReq} returns this
 */
proto.accountmanager.AdminCopierLogsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pagination_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AdminCopierLogsReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminCopierLogsReq} returns this
 */
proto.accountmanager.AdminCopierLogsReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminCopierLogsReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminCopierLogsReq} returns this
 */
proto.accountmanager.AdminCopierLogsReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue search_number = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AdminCopierLogsReq.prototype.getSearchNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AdminCopierLogsReq} returns this
*/
proto.accountmanager.AdminCopierLogsReq.prototype.setSearchNumber = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminCopierLogsReq} returns this
 */
proto.accountmanager.AdminCopierLogsReq.prototype.clearSearchNumber = function() {
  return this.setSearchNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminCopierLogsReq.prototype.hasSearchNumber = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminCopierLogsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminCopierLogsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminCopierLogsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminCopierLogsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCopierLogsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tradesList: jspb.Message.toObjectList(msg.getTradesList(),
    proto.accountmanager.Trade.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminCopierLogsReply}
 */
proto.accountmanager.AdminCopierLogsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminCopierLogsReply;
  return proto.accountmanager.AdminCopierLogsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminCopierLogsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminCopierLogsReply}
 */
proto.accountmanager.AdminCopierLogsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.Trade;
      reader.readMessage(value,proto.accountmanager.Trade.deserializeBinaryFromReader);
      msg.addTrades(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminCopierLogsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminCopierLogsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminCopierLogsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCopierLogsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.Trade.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated Trade trades = 1;
 * @return {!Array<!proto.accountmanager.Trade>}
 */
proto.accountmanager.AdminCopierLogsReply.prototype.getTradesList = function() {
  return /** @type{!Array<!proto.accountmanager.Trade>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.Trade, 1));
};


/**
 * @param {!Array<!proto.accountmanager.Trade>} value
 * @return {!proto.accountmanager.AdminCopierLogsReply} returns this
*/
proto.accountmanager.AdminCopierLogsReply.prototype.setTradesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.Trade=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.Trade}
 */
proto.accountmanager.AdminCopierLogsReply.prototype.addTrades = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.Trade, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminCopierLogsReply} returns this
 */
proto.accountmanager.AdminCopierLogsReply.prototype.clearTradesList = function() {
  return this.setTradesList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AdminCopierLogsReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminCopierLogsReply} returns this
 */
proto.accountmanager.AdminCopierLogsReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminCopierLogsReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminCopierLogsReply} returns this
 */
proto.accountmanager.AdminCopierLogsReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.accountmanager.AdminCopierLogsReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminCopierLogsReply} returns this
 */
proto.accountmanager.AdminCopierLogsReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetAccountStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetAccountStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetAccountStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetAccountStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetAccountStatusReq}
 */
proto.accountmanager.AdminGetAccountStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetAccountStatusReq;
  return proto.accountmanager.AdminGetAccountStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetAccountStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetAccountStatusReq}
 */
proto.accountmanager.AdminGetAccountStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetAccountStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetAccountStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetAccountStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetAccountStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountStatusReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountStatusReq} returns this
 */
proto.accountmanager.AdminGetAccountStatusReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountStatusReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountStatusReq} returns this
 */
proto.accountmanager.AdminGetAccountStatusReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetAccountStatusReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetAccountStatusReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetAccountStatusReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetAccountStatusReply.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetAccountStatusReply}
 */
proto.accountmanager.AdminGetAccountStatusReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetAccountStatusReply;
  return proto.accountmanager.AdminGetAccountStatusReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetAccountStatusReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetAccountStatusReply}
 */
proto.accountmanager.AdminGetAccountStatusReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetAccountStatusReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetAccountStatusReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetAccountStatusReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetAccountStatusReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.accountmanager.AdminGetAccountStatusReply.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AdminGetAccountStatusReply} returns this
 */
proto.accountmanager.AdminGetAccountStatusReply.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminListAccountsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminListAccountsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminListAccountsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListAccountsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
searchPattern: jspb.Message.getFieldWithDefault(msg, 1, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
status: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminListAccountsReq}
 */
proto.accountmanager.AdminListAccountsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminListAccountsReq;
  return proto.accountmanager.AdminListAccountsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminListAccountsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminListAccountsReq}
 */
proto.accountmanager.AdminListAccountsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchPattern(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminListAccountsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminListAccountsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminListAccountsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListAccountsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchPattern();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string search_pattern = 1;
 * @return {string}
 */
proto.accountmanager.AdminListAccountsReq.prototype.getSearchPattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListAccountsReq} returns this
 */
proto.accountmanager.AdminListAccountsReq.prototype.setSearchPattern = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pagination_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AdminListAccountsReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListAccountsReq} returns this
 */
proto.accountmanager.AdminListAccountsReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminListAccountsReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListAccountsReq} returns this
 */
proto.accountmanager.AdminListAccountsReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.accountmanager.AdminListAccountsReq.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListAccountsReq} returns this
 */
proto.accountmanager.AdminListAccountsReq.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminListAccountsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminListAccountsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminListAccountsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminListAccountsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListAccountsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.AccountInfoLite.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
count: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminListAccountsReply}
 */
proto.accountmanager.AdminListAccountsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminListAccountsReply;
  return proto.accountmanager.AdminListAccountsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminListAccountsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminListAccountsReply}
 */
proto.accountmanager.AdminListAccountsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.AccountInfoLite;
      reader.readMessage(value,proto.accountmanager.AccountInfoLite.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminListAccountsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminListAccountsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminListAccountsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListAccountsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.AccountInfoLite.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated AccountInfoLite accounts = 1;
 * @return {!Array<!proto.accountmanager.AccountInfoLite>}
 */
proto.accountmanager.AdminListAccountsReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.AccountInfoLite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.AccountInfoLite, 1));
};


/**
 * @param {!Array<!proto.accountmanager.AccountInfoLite>} value
 * @return {!proto.accountmanager.AdminListAccountsReply} returns this
*/
proto.accountmanager.AdminListAccountsReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.AccountInfoLite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AccountInfoLite}
 */
proto.accountmanager.AdminListAccountsReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.AccountInfoLite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminListAccountsReply} returns this
 */
proto.accountmanager.AdminListAccountsReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AdminListAccountsReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListAccountsReply} returns this
 */
proto.accountmanager.AdminListAccountsReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminListAccountsReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListAccountsReply} returns this
 */
proto.accountmanager.AdminListAccountsReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 count = 4;
 * @return {number}
 */
proto.accountmanager.AdminListAccountsReply.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListAccountsReply} returns this
 */
proto.accountmanager.AdminListAccountsReply.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetTotalAndTodaysAccountCountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReq.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReq}
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetTotalAndTodaysAccountCountReq;
  return proto.accountmanager.IntGetTotalAndTodaysAccountCountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReq}
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetTotalAndTodaysAccountCountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
totalAccount: jspb.Message.getFieldWithDefault(msg, 1, 0),
todaysAccount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReply}
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetTotalAndTodaysAccountCountReply;
  return proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReply}
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalAccount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTodaysAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalAccount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTodaysAccount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 total_account = 1;
 * @return {number}
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.prototype.getTotalAccount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReply} returns this
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.prototype.setTotalAccount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 todays_account = 2;
 * @return {number}
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.prototype.getTodaysAccount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.IntGetTotalAndTodaysAccountCountReply} returns this
 */
proto.accountmanager.IntGetTotalAndTodaysAccountCountReply.prototype.setTodaysAccount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetUserAccountsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetUserAccountsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetUserAccountsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetUserAccountsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetUserAccountsReq}
 */
proto.accountmanager.AdminGetUserAccountsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetUserAccountsReq;
  return proto.accountmanager.AdminGetUserAccountsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetUserAccountsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetUserAccountsReq}
 */
proto.accountmanager.AdminGetUserAccountsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetUserAccountsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetUserAccountsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetUserAccountsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetUserAccountsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminGetUserAccountsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetUserAccountsReq} returns this
 */
proto.accountmanager.AdminGetUserAccountsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pagination_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AdminGetUserAccountsReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetUserAccountsReq} returns this
 */
proto.accountmanager.AdminGetUserAccountsReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminGetUserAccountsReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminGetUserAccountsReq} returns this
 */
proto.accountmanager.AdminGetUserAccountsReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminGetUserAccountsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetUserAccountsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetUserAccountsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetUserAccountsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetUserAccountsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
userAccountList: jspb.Message.toObjectList(msg.getUserAccountList(),
    proto.accountmanager.UserAccount.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
count: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetUserAccountsReply}
 */
proto.accountmanager.AdminGetUserAccountsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetUserAccountsReply;
  return proto.accountmanager.AdminGetUserAccountsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetUserAccountsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetUserAccountsReply}
 */
proto.accountmanager.AdminGetUserAccountsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.UserAccount;
      reader.readMessage(value,proto.accountmanager.UserAccount.deserializeBinaryFromReader);
      msg.addUserAccount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetUserAccountsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetUserAccountsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetUserAccountsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetUserAccountsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserAccountList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.UserAccount.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated UserAccount user_account = 1;
 * @return {!Array<!proto.accountmanager.UserAccount>}
 */
proto.accountmanager.AdminGetUserAccountsReply.prototype.getUserAccountList = function() {
  return /** @type{!Array<!proto.accountmanager.UserAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.UserAccount, 1));
};


/**
 * @param {!Array<!proto.accountmanager.UserAccount>} value
 * @return {!proto.accountmanager.AdminGetUserAccountsReply} returns this
*/
proto.accountmanager.AdminGetUserAccountsReply.prototype.setUserAccountList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.UserAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.UserAccount}
 */
proto.accountmanager.AdminGetUserAccountsReply.prototype.addUserAccount = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.UserAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminGetUserAccountsReply} returns this
 */
proto.accountmanager.AdminGetUserAccountsReply.prototype.clearUserAccountList = function() {
  return this.setUserAccountList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AdminGetUserAccountsReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetUserAccountsReply} returns this
 */
proto.accountmanager.AdminGetUserAccountsReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminGetUserAccountsReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminGetUserAccountsReply} returns this
 */
proto.accountmanager.AdminGetUserAccountsReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 count = 4;
 * @return {number}
 */
proto.accountmanager.AdminGetUserAccountsReply.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminGetUserAccountsReply} returns this
 */
proto.accountmanager.AdminGetUserAccountsReply.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UserAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UserAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UserAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UserAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
accountName: jspb.Message.getFieldWithDefault(msg, 1, ""),
broker: jspb.Message.getFieldWithDefault(msg, 2, ""),
currency: jspb.Message.getFieldWithDefault(msg, 3, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
balance: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
serverId: jspb.Message.getFieldWithDefault(msg, 6, ""),
brokerId: jspb.Message.getFieldWithDefault(msg, 7, ""),
nickName: jspb.Message.getFieldWithDefault(msg, 8, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 9, ""),
platform: jspb.Message.getFieldWithDefault(msg, 10, ""),
connectionId: jspb.Message.getFieldWithDefault(msg, 11, ""),
status: jspb.Message.getFieldWithDefault(msg, 12, ""),
errorCode: jspb.Message.getFieldWithDefault(msg, 13, ""),
podId: jspb.Message.getFieldWithDefault(msg, 14, ""),
benthos: jspb.Message.getFieldWithDefault(msg, 15, ""),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
withProxy: (f = msg.getWithProxy()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
dedicatedEnvId: (f = msg.getDedicatedEnvId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
error: jspb.Message.getFieldWithDefault(msg, 19, ""),
connectionType: jspb.Message.getFieldWithDefault(msg, 20, 0),
cluster: jspb.Message.getFieldWithDefault(msg, 21, ""),
isBlocked: (f = msg.getIsBlocked()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
premium: jspb.Message.getBooleanFieldWithDefault(msg, 23, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UserAccount}
 */
proto.accountmanager.UserAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UserAccount;
  return proto.accountmanager.UserAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UserAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UserAccount}
 */
proto.accountmanager.UserAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalance(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectionId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorCode(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setPodId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenthos(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setWithProxy(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDedicatedEnvId(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 20:
      var value = /** @type {!proto.accountmanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setCluster(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsBlocked(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPremium(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UserAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UserAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UserAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UserAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getNickName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getConnectionId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getErrorCode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPodId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getBenthos();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getWithProxy();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getDedicatedEnvId();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getCluster();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getIsBlocked();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getPremium();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
};


/**
 * optional string account_name = 1;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string broker = 2;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string currency = 3;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_number = 4;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double balance = 5;
 * @return {number}
 */
proto.accountmanager.UserAccount.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string server_id = 6;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string broker_id = 7;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string nick_name = 8;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getNickName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setNickName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string account_id = 9;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string platform = 10;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string connection_id = 11;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getConnectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setConnectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string status = 12;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string error_code = 13;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getErrorCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setErrorCode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string pod_id = 14;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getPodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setPodId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string benthos = 15;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getBenthos = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setBenthos = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool enabled = 16;
 * @return {boolean}
 */
proto.accountmanager.UserAccount.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional google.protobuf.BoolValue with_proxy = 17;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.UserAccount.prototype.getWithProxy = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 17));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.UserAccount} returns this
*/
proto.accountmanager.UserAccount.prototype.setWithProxy = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.clearWithProxy = function() {
  return this.setWithProxy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UserAccount.prototype.hasWithProxy = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.StringValue dedicated_env_id = 18;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.UserAccount.prototype.getDedicatedEnvId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 18));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.UserAccount} returns this
*/
proto.accountmanager.UserAccount.prototype.setDedicatedEnvId = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.clearDedicatedEnvId = function() {
  return this.setDedicatedEnvId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UserAccount.prototype.hasDedicatedEnvId = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string error = 19;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional ConnectionType connection_type = 20;
 * @return {!proto.accountmanager.ConnectionType}
 */
proto.accountmanager.UserAccount.prototype.getConnectionType = function() {
  return /** @type {!proto.accountmanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.accountmanager.ConnectionType} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional string cluster = 21;
 * @return {string}
 */
proto.accountmanager.UserAccount.prototype.getCluster = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setCluster = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional google.protobuf.BoolValue is_blocked = 22;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.UserAccount.prototype.getIsBlocked = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 22));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.UserAccount} returns this
*/
proto.accountmanager.UserAccount.prototype.setIsBlocked = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.clearIsBlocked = function() {
  return this.setIsBlocked(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UserAccount.prototype.hasIsBlocked = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional bool premium = 23;
 * @return {boolean}
 */
proto.accountmanager.UserAccount.prototype.getPremium = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.UserAccount} returns this
 */
proto.accountmanager.UserAccount.prototype.setPremium = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntGetUsersAccountCountReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetUsersAccountCountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetUsersAccountCountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetUsersAccountCountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetUsersAccountCountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetUsersAccountCountReq}
 */
proto.accountmanager.IntGetUsersAccountCountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetUsersAccountCountReq;
  return proto.accountmanager.IntGetUsersAccountCountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetUsersAccountCountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetUsersAccountCountReq}
 */
proto.accountmanager.IntGetUsersAccountCountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetUsersAccountCountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetUsersAccountCountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetUsersAccountCountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetUsersAccountCountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string user_ids = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntGetUsersAccountCountReq.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntGetUsersAccountCountReq} returns this
 */
proto.accountmanager.IntGetUsersAccountCountReq.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntGetUsersAccountCountReq} returns this
 */
proto.accountmanager.IntGetUsersAccountCountReq.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntGetUsersAccountCountReq} returns this
 */
proto.accountmanager.IntGetUsersAccountCountReq.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetUsersAccountCountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetUsersAccountCountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetUsersAccountCountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetUsersAccountCountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
usersAccountCountMap: (f = msg.getUsersAccountCountMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetUsersAccountCountReply}
 */
proto.accountmanager.IntGetUsersAccountCountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetUsersAccountCountReply;
  return proto.accountmanager.IntGetUsersAccountCountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetUsersAccountCountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetUsersAccountCountReply}
 */
proto.accountmanager.IntGetUsersAccountCountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getUsersAccountCountMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt64, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetUsersAccountCountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetUsersAccountCountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetUsersAccountCountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetUsersAccountCountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersAccountCountMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt64);
  }
};


/**
 * map<string, int64> users_account_count = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.accountmanager.IntGetUsersAccountCountReply.prototype.getUsersAccountCountMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.accountmanager.IntGetUsersAccountCountReply} returns this
 */
proto.accountmanager.IntGetUsersAccountCountReply.prototype.clearUsersAccountCountMap = function() {
  this.getUsersAccountCountMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetUserAccountCountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetUserAccountCountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetUserAccountCountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetUserAccountCountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetUserAccountCountReq}
 */
proto.accountmanager.IntGetUserAccountCountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetUserAccountCountReq;
  return proto.accountmanager.IntGetUserAccountCountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetUserAccountCountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetUserAccountCountReq}
 */
proto.accountmanager.IntGetUserAccountCountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetUserAccountCountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetUserAccountCountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetUserAccountCountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetUserAccountCountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.IntGetUserAccountCountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntGetUserAccountCountReq} returns this
 */
proto.accountmanager.IntGetUserAccountCountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetUserAccountCountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetUserAccountCountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetUserAccountCountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetUserAccountCountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accounts: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetUserAccountCountReply}
 */
proto.accountmanager.IntGetUserAccountCountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetUserAccountCountReply;
  return proto.accountmanager.IntGetUserAccountCountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetUserAccountCountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetUserAccountCountReply}
 */
proto.accountmanager.IntGetUserAccountCountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetUserAccountCountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetUserAccountCountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetUserAccountCountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetUserAccountCountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccounts();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 accounts = 1;
 * @return {number}
 */
proto.accountmanager.IntGetUserAccountCountReply.prototype.getAccounts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.IntGetUserAccountCountReply} returns this
 */
proto.accountmanager.IntGetUserAccountCountReply.prototype.setAccounts = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
host: jspb.Message.getFieldWithDefault(msg, 4, ""),
port: jspb.Message.getFieldWithDefault(msg, 5, 0),
nickname: jspb.Message.getFieldWithDefault(msg, 6, ""),
platform: jspb.Message.getFieldWithDefault(msg, 7, ""),
brokerId: jspb.Message.getFieldWithDefault(msg, 8, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 9, ""),
dedicatedEnvId: (f = msg.getDedicatedEnvId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
dxtInfo: (f = msg.getDxtInfo()) && proto.accountmanager.DxtInfoReq.toObject(includeInstance, f),
tradeLockerInfo: (f = msg.getTradeLockerInfo()) && proto.accountmanager.TradeLockerInfoReq.toObject(includeInstance, f),
matchTraderInfo: (f = msg.getMatchTraderInfo()) && proto.accountmanager.MatchTreaderInfoReq.toObject(includeInstance, f),
priority: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddAccountReq}
 */
proto.accountmanager.AdminAddAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddAccountReq;
  return proto.accountmanager.AdminAddAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddAccountReq}
 */
proto.accountmanager.AdminAddAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPort(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDedicatedEnvId(value);
      break;
    case 11:
      var value = new proto.accountmanager.DxtInfoReq;
      reader.readMessage(value,proto.accountmanager.DxtInfoReq.deserializeBinaryFromReader);
      msg.setDxtInfo(value);
      break;
    case 12:
      var value = new proto.accountmanager.TradeLockerInfoReq;
      reader.readMessage(value,proto.accountmanager.TradeLockerInfoReq.deserializeBinaryFromReader);
      msg.setTradeLockerInfo(value);
      break;
    case 13:
      var value = new proto.accountmanager.MatchTreaderInfoReq;
      reader.readMessage(value,proto.accountmanager.MatchTreaderInfoReq.deserializeBinaryFromReader);
      msg.setMatchTraderInfo(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDedicatedEnvId();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDxtInfo();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.accountmanager.DxtInfoReq.serializeBinaryToWriter
    );
  }
  f = message.getTradeLockerInfo();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.accountmanager.TradeLockerInfoReq.serializeBinaryToWriter
    );
  }
  f = message.getMatchTraderInfo();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.accountmanager.MatchTreaderInfoReq.serializeBinaryToWriter
    );
  }
  f = message.getPriority();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_number = 2;
 * @return {string}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string host = 4;
 * @return {string}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 port = 5;
 * @return {number}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string nickname = 6;
 * @return {string}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string platform = 7;
 * @return {string}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string broker_id = 8;
 * @return {string}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string server_id = 9;
 * @return {string}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.protobuf.StringValue dedicated_env_id = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getDedicatedEnvId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
*/
proto.accountmanager.AdminAddAccountReq.prototype.setDedicatedEnvId = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.clearDedicatedEnvId = function() {
  return this.setDedicatedEnvId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminAddAccountReq.prototype.hasDedicatedEnvId = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional DxtInfoReq dxt_info = 11;
 * @return {?proto.accountmanager.DxtInfoReq}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getDxtInfo = function() {
  return /** @type{?proto.accountmanager.DxtInfoReq} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.DxtInfoReq, 11));
};


/**
 * @param {?proto.accountmanager.DxtInfoReq|undefined} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
*/
proto.accountmanager.AdminAddAccountReq.prototype.setDxtInfo = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.clearDxtInfo = function() {
  return this.setDxtInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminAddAccountReq.prototype.hasDxtInfo = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional TradeLockerInfoReq trade_locker_info = 12;
 * @return {?proto.accountmanager.TradeLockerInfoReq}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getTradeLockerInfo = function() {
  return /** @type{?proto.accountmanager.TradeLockerInfoReq} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.TradeLockerInfoReq, 12));
};


/**
 * @param {?proto.accountmanager.TradeLockerInfoReq|undefined} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
*/
proto.accountmanager.AdminAddAccountReq.prototype.setTradeLockerInfo = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.clearTradeLockerInfo = function() {
  return this.setTradeLockerInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminAddAccountReq.prototype.hasTradeLockerInfo = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional MatchTreaderInfoReq match_trader_info = 13;
 * @return {?proto.accountmanager.MatchTreaderInfoReq}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getMatchTraderInfo = function() {
  return /** @type{?proto.accountmanager.MatchTreaderInfoReq} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.MatchTreaderInfoReq, 13));
};


/**
 * @param {?proto.accountmanager.MatchTreaderInfoReq|undefined} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
*/
proto.accountmanager.AdminAddAccountReq.prototype.setMatchTraderInfo = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.clearMatchTraderInfo = function() {
  return this.setMatchTraderInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminAddAccountReq.prototype.hasMatchTraderInfo = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional int32 priority = 14;
 * @return {number}
 */
proto.accountmanager.AdminAddAccountReq.prototype.getPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminAddAccountReq} returns this
 */
proto.accountmanager.AdminAddAccountReq.prototype.setPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
failedPriority: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddAccountReply}
 */
proto.accountmanager.AdminAddAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddAccountReply;
  return proto.accountmanager.AdminAddAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddAccountReply}
 */
proto.accountmanager.AdminAddAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFailedPriority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getFailedPriority();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.accountmanager.AdminAddAccountReply.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AdminAddAccountReply} returns this
 */
proto.accountmanager.AdminAddAccountReply.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 failed_priority = 2;
 * @return {number}
 */
proto.accountmanager.AdminAddAccountReply.prototype.getFailedPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminAddAccountReply} returns this
 */
proto.accountmanager.AdminAddAccountReply.prototype.setFailedPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AddAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AddAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AddAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AddAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
host: jspb.Message.getFieldWithDefault(msg, 4, ""),
port: jspb.Message.getFieldWithDefault(msg, 5, 0),
nickname: jspb.Message.getFieldWithDefault(msg, 6, ""),
platform: jspb.Message.getFieldWithDefault(msg, 7, ""),
brokerId: jspb.Message.getFieldWithDefault(msg, 8, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 9, ""),
dedicatedEnvId: (f = msg.getDedicatedEnvId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
ctraderInfo: (f = msg.getCtraderInfo()) && proto.accountmanager.CTraderInfoReq.toObject(includeInstance, f),
dxtInfo: (f = msg.getDxtInfo()) && proto.accountmanager.DxtInfoReq.toObject(includeInstance, f),
tradeLockerInfo: (f = msg.getTradeLockerInfo()) && proto.accountmanager.TradeLockerInfoReq.toObject(includeInstance, f),
matchTraderInfo: (f = msg.getMatchTraderInfo()) && proto.accountmanager.MatchTreaderInfoReq.toObject(includeInstance, f),
priority: jspb.Message.getFieldWithDefault(msg, 15, 0),
tradovateInfo: (f = msg.getTradovateInfo()) && proto.accountmanager.TradovateInfoReq.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AddAccountReq}
 */
proto.accountmanager.AddAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AddAccountReq;
  return proto.accountmanager.AddAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AddAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AddAccountReq}
 */
proto.accountmanager.AddAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPort(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDedicatedEnvId(value);
      break;
    case 11:
      var value = new proto.accountmanager.CTraderInfoReq;
      reader.readMessage(value,proto.accountmanager.CTraderInfoReq.deserializeBinaryFromReader);
      msg.setCtraderInfo(value);
      break;
    case 12:
      var value = new proto.accountmanager.DxtInfoReq;
      reader.readMessage(value,proto.accountmanager.DxtInfoReq.deserializeBinaryFromReader);
      msg.setDxtInfo(value);
      break;
    case 13:
      var value = new proto.accountmanager.TradeLockerInfoReq;
      reader.readMessage(value,proto.accountmanager.TradeLockerInfoReq.deserializeBinaryFromReader);
      msg.setTradeLockerInfo(value);
      break;
    case 14:
      var value = new proto.accountmanager.MatchTreaderInfoReq;
      reader.readMessage(value,proto.accountmanager.MatchTreaderInfoReq.deserializeBinaryFromReader);
      msg.setMatchTraderInfo(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriority(value);
      break;
    case 16:
      var value = new proto.accountmanager.TradovateInfoReq;
      reader.readMessage(value,proto.accountmanager.TradovateInfoReq.deserializeBinaryFromReader);
      msg.setTradovateInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AddAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AddAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AddAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AddAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDedicatedEnvId();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCtraderInfo();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.accountmanager.CTraderInfoReq.serializeBinaryToWriter
    );
  }
  f = message.getDxtInfo();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.accountmanager.DxtInfoReq.serializeBinaryToWriter
    );
  }
  f = message.getTradeLockerInfo();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.accountmanager.TradeLockerInfoReq.serializeBinaryToWriter
    );
  }
  f = message.getMatchTraderInfo();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.accountmanager.MatchTreaderInfoReq.serializeBinaryToWriter
    );
  }
  f = message.getPriority();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getTradovateInfo();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.accountmanager.TradovateInfoReq.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AddAccountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_number = 2;
 * @return {string}
 */
proto.accountmanager.AddAccountReq.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.accountmanager.AddAccountReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string host = 4;
 * @return {string}
 */
proto.accountmanager.AddAccountReq.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 port = 5;
 * @return {number}
 */
proto.accountmanager.AddAccountReq.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string nickname = 6;
 * @return {string}
 */
proto.accountmanager.AddAccountReq.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string platform = 7;
 * @return {string}
 */
proto.accountmanager.AddAccountReq.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string broker_id = 8;
 * @return {string}
 */
proto.accountmanager.AddAccountReq.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string server_id = 9;
 * @return {string}
 */
proto.accountmanager.AddAccountReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.protobuf.StringValue dedicated_env_id = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AddAccountReq.prototype.getDedicatedEnvId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
*/
proto.accountmanager.AddAccountReq.prototype.setDedicatedEnvId = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.clearDedicatedEnvId = function() {
  return this.setDedicatedEnvId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AddAccountReq.prototype.hasDedicatedEnvId = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional CTraderInfoReq ctrader_info = 11;
 * @return {?proto.accountmanager.CTraderInfoReq}
 */
proto.accountmanager.AddAccountReq.prototype.getCtraderInfo = function() {
  return /** @type{?proto.accountmanager.CTraderInfoReq} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.CTraderInfoReq, 11));
};


/**
 * @param {?proto.accountmanager.CTraderInfoReq|undefined} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
*/
proto.accountmanager.AddAccountReq.prototype.setCtraderInfo = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.clearCtraderInfo = function() {
  return this.setCtraderInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AddAccountReq.prototype.hasCtraderInfo = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional DxtInfoReq dxt_info = 12;
 * @return {?proto.accountmanager.DxtInfoReq}
 */
proto.accountmanager.AddAccountReq.prototype.getDxtInfo = function() {
  return /** @type{?proto.accountmanager.DxtInfoReq} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.DxtInfoReq, 12));
};


/**
 * @param {?proto.accountmanager.DxtInfoReq|undefined} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
*/
proto.accountmanager.AddAccountReq.prototype.setDxtInfo = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.clearDxtInfo = function() {
  return this.setDxtInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AddAccountReq.prototype.hasDxtInfo = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional TradeLockerInfoReq trade_locker_info = 13;
 * @return {?proto.accountmanager.TradeLockerInfoReq}
 */
proto.accountmanager.AddAccountReq.prototype.getTradeLockerInfo = function() {
  return /** @type{?proto.accountmanager.TradeLockerInfoReq} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.TradeLockerInfoReq, 13));
};


/**
 * @param {?proto.accountmanager.TradeLockerInfoReq|undefined} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
*/
proto.accountmanager.AddAccountReq.prototype.setTradeLockerInfo = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.clearTradeLockerInfo = function() {
  return this.setTradeLockerInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AddAccountReq.prototype.hasTradeLockerInfo = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional MatchTreaderInfoReq match_trader_info = 14;
 * @return {?proto.accountmanager.MatchTreaderInfoReq}
 */
proto.accountmanager.AddAccountReq.prototype.getMatchTraderInfo = function() {
  return /** @type{?proto.accountmanager.MatchTreaderInfoReq} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.MatchTreaderInfoReq, 14));
};


/**
 * @param {?proto.accountmanager.MatchTreaderInfoReq|undefined} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
*/
proto.accountmanager.AddAccountReq.prototype.setMatchTraderInfo = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.clearMatchTraderInfo = function() {
  return this.setMatchTraderInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AddAccountReq.prototype.hasMatchTraderInfo = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional int32 priority = 15;
 * @return {number}
 */
proto.accountmanager.AddAccountReq.prototype.getPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.setPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional TradovateInfoReq tradovate_info = 16;
 * @return {?proto.accountmanager.TradovateInfoReq}
 */
proto.accountmanager.AddAccountReq.prototype.getTradovateInfo = function() {
  return /** @type{?proto.accountmanager.TradovateInfoReq} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.TradovateInfoReq, 16));
};


/**
 * @param {?proto.accountmanager.TradovateInfoReq|undefined} value
 * @return {!proto.accountmanager.AddAccountReq} returns this
*/
proto.accountmanager.AddAccountReq.prototype.setTradovateInfo = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AddAccountReq} returns this
 */
proto.accountmanager.AddAccountReq.prototype.clearTradovateInfo = function() {
  return this.setTradovateInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AddAccountReq.prototype.hasTradovateInfo = function() {
  return jspb.Message.getField(this, 16) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.TradeLockerInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.TradeLockerInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.TradeLockerInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TradeLockerInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, ""),
isLive: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
betaUser: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.TradeLockerInfoReq}
 */
proto.accountmanager.TradeLockerInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.TradeLockerInfoReq;
  return proto.accountmanager.TradeLockerInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.TradeLockerInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.TradeLockerInfoReq}
 */
proto.accountmanager.TradeLockerInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLive(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBetaUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.TradeLockerInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.TradeLockerInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.TradeLockerInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TradeLockerInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsLive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getBetaUser();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.accountmanager.TradeLockerInfoReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.TradeLockerInfoReq} returns this
 */
proto.accountmanager.TradeLockerInfoReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_live = 2;
 * @return {boolean}
 */
proto.accountmanager.TradeLockerInfoReq.prototype.getIsLive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.TradeLockerInfoReq} returns this
 */
proto.accountmanager.TradeLockerInfoReq.prototype.setIsLive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool beta_user = 3;
 * @return {boolean}
 */
proto.accountmanager.TradeLockerInfoReq.prototype.getBetaUser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.TradeLockerInfoReq} returns this
 */
proto.accountmanager.TradeLockerInfoReq.prototype.setBetaUser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.MatchTreaderInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.MatchTreaderInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.MatchTreaderInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MatchTreaderInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, ""),
brokerId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.MatchTreaderInfoReq}
 */
proto.accountmanager.MatchTreaderInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.MatchTreaderInfoReq;
  return proto.accountmanager.MatchTreaderInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.MatchTreaderInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.MatchTreaderInfoReq}
 */
proto.accountmanager.MatchTreaderInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBrokerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.MatchTreaderInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.MatchTreaderInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.MatchTreaderInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MatchTreaderInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrokerId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.accountmanager.MatchTreaderInfoReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MatchTreaderInfoReq} returns this
 */
proto.accountmanager.MatchTreaderInfoReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 broker_id = 2;
 * @return {number}
 */
proto.accountmanager.MatchTreaderInfoReq.prototype.getBrokerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.MatchTreaderInfoReq} returns this
 */
proto.accountmanager.MatchTreaderInfoReq.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.DxtInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.DxtInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.DxtInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DxtInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
username: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.DxtInfoReq}
 */
proto.accountmanager.DxtInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.DxtInfoReq;
  return proto.accountmanager.DxtInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.DxtInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.DxtInfoReq}
 */
proto.accountmanager.DxtInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.DxtInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.DxtInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.DxtInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DxtInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.accountmanager.DxtInfoReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DxtInfoReq} returns this
 */
proto.accountmanager.DxtInfoReq.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.CTraderInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.CTraderInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.CTraderInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CTraderInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
authId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.CTraderInfoReq}
 */
proto.accountmanager.CTraderInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.CTraderInfoReq;
  return proto.accountmanager.CTraderInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.CTraderInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.CTraderInfoReq}
 */
proto.accountmanager.CTraderInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuthId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.CTraderInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.CTraderInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.CTraderInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CTraderInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 auth_id = 1;
 * @return {number}
 */
proto.accountmanager.CTraderInfoReq.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.CTraderInfoReq} returns this
 */
proto.accountmanager.CTraderInfoReq.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.TradovateInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.TradovateInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.TradovateInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TradovateInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
authId: jspb.Message.getFieldWithDefault(msg, 1, 0),
isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.TradovateInfoReq}
 */
proto.accountmanager.TradovateInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.TradovateInfoReq;
  return proto.accountmanager.TradovateInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.TradovateInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.TradovateInfoReq}
 */
proto.accountmanager.TradovateInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAuthId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.TradovateInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.TradovateInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.TradovateInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TradovateInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional uint64 auth_id = 1;
 * @return {number}
 */
proto.accountmanager.TradovateInfoReq.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.TradovateInfoReq} returns this
 */
proto.accountmanager.TradovateInfoReq.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool is_demo = 2;
 * @return {boolean}
 */
proto.accountmanager.TradovateInfoReq.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.TradovateInfoReq} returns this
 */
proto.accountmanager.TradovateInfoReq.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AddAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AddAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AddAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AddAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
failedPriority: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AddAccountReply}
 */
proto.accountmanager.AddAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AddAccountReply;
  return proto.accountmanager.AddAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AddAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AddAccountReply}
 */
proto.accountmanager.AddAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFailedPriority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AddAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AddAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AddAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AddAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getFailedPriority();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.accountmanager.AddAccountReply.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AddAccountReply} returns this
 */
proto.accountmanager.AddAccountReply.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 failed_priority = 2;
 * @return {number}
 */
proto.accountmanager.AddAccountReply.prototype.getFailedPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AddAccountReply} returns this
 */
proto.accountmanager.AddAccountReply.prototype.setFailedPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetAccountInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetAccountInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetAccountInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetAccountInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetAccountInfoReq}
 */
proto.accountmanager.AdminGetAccountInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetAccountInfoReq;
  return proto.accountmanager.AdminGetAccountInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetAccountInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetAccountInfoReq}
 */
proto.accountmanager.AdminGetAccountInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetAccountInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetAccountInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetAccountInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetAccountInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReq} returns this
 */
proto.accountmanager.AdminGetAccountInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReq} returns this
 */
proto.accountmanager.AdminGetAccountInfoReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetAccountInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetAccountInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetAccountInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
leverage: jspb.Message.getFieldWithDefault(msg, 4, 0),
supportEmail: jspb.Message.getFieldWithDefault(msg, 5, ""),
broker: jspb.Message.getFieldWithDefault(msg, 6, ""),
accountType: jspb.Message.getFieldWithDefault(msg, 7, ""),
tradeServer: jspb.Message.getFieldWithDefault(msg, 8, ""),
reportsEnabled: jspb.Message.getFieldWithDefault(msg, 9, 0),
isPublic: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
nickname: jspb.Message.getFieldWithDefault(msg, 11, ""),
platform: jspb.Message.getFieldWithDefault(msg, 12, ""),
enabled: (f = msg.getEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 14, ""),
brokerId: jspb.Message.getFieldWithDefault(msg, 15, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 16, ""),
considerOnPortfolio: (f = msg.getConsiderOnPortfolio()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
serverTimeZoneInMinutes: jspb.Message.getFieldWithDefault(msg, 18, 0),
amStatus: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetAccountInfoReply}
 */
proto.accountmanager.AdminGetAccountInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetAccountInfoReply;
  return proto.accountmanager.AdminGetAccountInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetAccountInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetAccountInfoReply}
 */
proto.accountmanager.AdminGetAccountInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeverage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupportEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradeServer(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReportsEnabled(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublic(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnabled(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setConsiderOnPortfolio(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServerTimeZoneInMinutes(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setAmStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetAccountInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetAccountInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetAccountInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLeverage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSupportEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAccountType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTradeServer();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getReportsEnabled();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getIsPublic();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getEnabled();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getConsiderOnPortfolio();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getServerTimeZoneInMinutes();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getAmStatus();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_number = 2;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 leverage = 4;
 * @return {number}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getLeverage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setLeverage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string support_email = 5;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getSupportEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setSupportEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string broker = 6;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string account_type = 7;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getAccountType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string trade_server = 8;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getTradeServer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setTradeServer = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 reports_enabled = 9;
 * @return {number}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getReportsEnabled = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setReportsEnabled = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool is_public = 10;
 * @return {boolean}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getIsPublic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setIsPublic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string nickname = 11;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string platform = 12;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional google.protobuf.BoolValue enabled = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
*/
proto.accountmanager.AdminGetAccountInfoReply.prototype.setEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.clearEnabled = function() {
  return this.setEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.hasEnabled = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string status = 14;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string broker_id = 15;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string server_id = 16;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional google.protobuf.BoolValue consider_on_portfolio = 17;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getConsiderOnPortfolio = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 17));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
*/
proto.accountmanager.AdminGetAccountInfoReply.prototype.setConsiderOnPortfolio = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.clearConsiderOnPortfolio = function() {
  return this.setConsiderOnPortfolio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.hasConsiderOnPortfolio = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional int32 server_time_zone_in_minutes = 18;
 * @return {number}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getServerTimeZoneInMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setServerTimeZoneInMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string am_status = 19;
 * @return {string}
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.getAmStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetAccountInfoReply} returns this
 */
proto.accountmanager.AdminGetAccountInfoReply.prototype.setAmStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetAccountInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetAccountInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetAccountInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAccountInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetAccountInfoReq}
 */
proto.accountmanager.GetAccountInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetAccountInfoReq;
  return proto.accountmanager.GetAccountInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetAccountInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetAccountInfoReq}
 */
proto.accountmanager.GetAccountInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetAccountInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetAccountInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetAccountInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAccountInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReq} returns this
 */
proto.accountmanager.GetAccountInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReq} returns this
 */
proto.accountmanager.GetAccountInfoReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetAccountInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetAccountInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetAccountInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAccountInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
leverage: jspb.Message.getFieldWithDefault(msg, 4, 0),
supportEmail: jspb.Message.getFieldWithDefault(msg, 5, ""),
broker: jspb.Message.getFieldWithDefault(msg, 6, ""),
accountType: jspb.Message.getFieldWithDefault(msg, 7, ""),
tradeServer: jspb.Message.getFieldWithDefault(msg, 8, ""),
reportsEnabled: jspb.Message.getFieldWithDefault(msg, 9, 0),
isPublic: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
nickname: jspb.Message.getFieldWithDefault(msg, 11, ""),
platform: jspb.Message.getFieldWithDefault(msg, 12, ""),
enabled: (f = msg.getEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 14, ""),
brokerId: jspb.Message.getFieldWithDefault(msg, 15, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 16, ""),
considerOnPortfolio: (f = msg.getConsiderOnPortfolio()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
serverTimeZoneInMinutes: jspb.Message.getFieldWithDefault(msg, 18, 0),
amStatus: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetAccountInfoReply}
 */
proto.accountmanager.GetAccountInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetAccountInfoReply;
  return proto.accountmanager.GetAccountInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetAccountInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetAccountInfoReply}
 */
proto.accountmanager.GetAccountInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeverage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupportEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradeServer(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReportsEnabled(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublic(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnabled(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setConsiderOnPortfolio(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServerTimeZoneInMinutes(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setAmStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetAccountInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetAccountInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetAccountInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAccountInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLeverage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSupportEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAccountType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTradeServer();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getReportsEnabled();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getIsPublic();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getEnabled();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getConsiderOnPortfolio();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getServerTimeZoneInMinutes();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getAmStatus();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_number = 2;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 leverage = 4;
 * @return {number}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getLeverage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setLeverage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string support_email = 5;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getSupportEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setSupportEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string broker = 6;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string account_type = 7;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getAccountType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string trade_server = 8;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getTradeServer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setTradeServer = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 reports_enabled = 9;
 * @return {number}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getReportsEnabled = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setReportsEnabled = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool is_public = 10;
 * @return {boolean}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getIsPublic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setIsPublic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string nickname = 11;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string platform = 12;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional google.protobuf.BoolValue enabled = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
*/
proto.accountmanager.GetAccountInfoReply.prototype.setEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.clearEnabled = function() {
  return this.setEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetAccountInfoReply.prototype.hasEnabled = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string status = 14;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string broker_id = 15;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string server_id = 16;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional google.protobuf.BoolValue consider_on_portfolio = 17;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getConsiderOnPortfolio = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 17));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
*/
proto.accountmanager.GetAccountInfoReply.prototype.setConsiderOnPortfolio = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.clearConsiderOnPortfolio = function() {
  return this.setConsiderOnPortfolio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.GetAccountInfoReply.prototype.hasConsiderOnPortfolio = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional int32 server_time_zone_in_minutes = 18;
 * @return {number}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getServerTimeZoneInMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setServerTimeZoneInMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string am_status = 19;
 * @return {string}
 */
proto.accountmanager.GetAccountInfoReply.prototype.getAmStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAccountInfoReply} returns this
 */
proto.accountmanager.GetAccountInfoReply.prototype.setAmStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.DeleteAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.DeleteAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.DeleteAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.DeleteAccountReq}
 */
proto.accountmanager.DeleteAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.DeleteAccountReq;
  return proto.accountmanager.DeleteAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.DeleteAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.DeleteAccountReq}
 */
proto.accountmanager.DeleteAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.DeleteAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.DeleteAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.DeleteAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.DeleteAccountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DeleteAccountReq} returns this
 */
proto.accountmanager.DeleteAccountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.DeleteAccountReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DeleteAccountReq} returns this
 */
proto.accountmanager.DeleteAccountReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.DeleteAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.DeleteAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.DeleteAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.DeleteAccountReply}
 */
proto.accountmanager.DeleteAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.DeleteAccountReply;
  return proto.accountmanager.DeleteAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.DeleteAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.DeleteAccountReply}
 */
proto.accountmanager.DeleteAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.DeleteAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.DeleteAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.DeleteAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AccountListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AccountListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AccountListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
searchPattern: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AccountListReq}
 */
proto.accountmanager.AccountListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AccountListReq;
  return proto.accountmanager.AccountListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AccountListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AccountListReq}
 */
proto.accountmanager.AccountListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchPattern(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AccountListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AccountListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AccountListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSearchPattern();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AccountListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountListReq} returns this
 */
proto.accountmanager.AccountListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pagination_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AccountListReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountListReq} returns this
 */
proto.accountmanager.AccountListReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AccountListReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountListReq} returns this
 */
proto.accountmanager.AccountListReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string search_pattern = 4;
 * @return {string}
 */
proto.accountmanager.AccountListReq.prototype.getSearchPattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountListReq} returns this
 */
proto.accountmanager.AccountListReq.prototype.setSearchPattern = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AccountListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AccountListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AccountListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AccountListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.AccountInfoLite.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AccountListReply}
 */
proto.accountmanager.AccountListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AccountListReply;
  return proto.accountmanager.AccountListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AccountListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AccountListReply}
 */
proto.accountmanager.AccountListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.AccountInfoLite;
      reader.readMessage(value,proto.accountmanager.AccountInfoLite.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AccountListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AccountListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AccountListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.AccountInfoLite.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated AccountInfoLite accounts = 1;
 * @return {!Array<!proto.accountmanager.AccountInfoLite>}
 */
proto.accountmanager.AccountListReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.AccountInfoLite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.AccountInfoLite, 1));
};


/**
 * @param {!Array<!proto.accountmanager.AccountInfoLite>} value
 * @return {!proto.accountmanager.AccountListReply} returns this
*/
proto.accountmanager.AccountListReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.AccountInfoLite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AccountInfoLite}
 */
proto.accountmanager.AccountListReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.AccountInfoLite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AccountListReply} returns this
 */
proto.accountmanager.AccountListReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AccountListReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountListReply} returns this
 */
proto.accountmanager.AccountListReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AccountListReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountListReply} returns this
 */
proto.accountmanager.AccountListReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.accountmanager.AccountListReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountListReply} returns this
 */
proto.accountmanager.AccountListReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AccountInfoLite.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AccountInfoLite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AccountInfoLite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountInfoLite.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
balance: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
equity: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
nickname: jspb.Message.getFieldWithDefault(msg, 5, ""),
platform: jspb.Message.getFieldWithDefault(msg, 6, ""),
enabled: (f = msg.getEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 8, ""),
errorCode: jspb.Message.getFieldWithDefault(msg, 9, ""),
openPl: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
currency: (f = msg.getCurrency()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
userId: (f = msg.getUserId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
withProxy: (f = msg.getWithProxy()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
dedicatedEnvId: (f = msg.getDedicatedEnvId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
ctrAuthError: (f = msg.getCtrAuthError()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
broker: jspb.Message.getFieldWithDefault(msg, 17, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 18, ""),
amStatus: jspb.Message.getFieldWithDefault(msg, 19, ""),
connectionType: jspb.Message.getFieldWithDefault(msg, 20, 0),
cluster: jspb.Message.getFieldWithDefault(msg, 21, ""),
betaConnector: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
analyzerEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
premium: jspb.Message.getBooleanFieldWithDefault(msg, 24, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AccountInfoLite}
 */
proto.accountmanager.AccountInfoLite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AccountInfoLite;
  return proto.accountmanager.AccountInfoLite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AccountInfoLite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AccountInfoLite}
 */
proto.accountmanager.AccountInfoLite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalance(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEquity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnabled(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorCode(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpenPl(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCurrency(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setWithProxy(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDedicatedEnvId(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCtrAuthError(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setAmStatus(value);
      break;
    case 20:
      var value = /** @type {!proto.accountmanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setCluster(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBetaConnector(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAnalyzerEnabled(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPremium(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AccountInfoLite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AccountInfoLite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AccountInfoLite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountInfoLite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getEquity();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEnabled();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getErrorCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getOpenPl();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getWithProxy();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getDedicatedEnvId();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCtrAuthError();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getAmStatus();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getCluster();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getBetaConnector();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getAnalyzerEnabled();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getPremium();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AccountInfoLite.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_number = 2;
 * @return {string}
 */
proto.accountmanager.AccountInfoLite.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double balance = 3;
 * @return {number}
 */
proto.accountmanager.AccountInfoLite.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double equity = 4;
 * @return {number}
 */
proto.accountmanager.AccountInfoLite.prototype.getEquity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setEquity = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string nickname = 5;
 * @return {string}
 */
proto.accountmanager.AccountInfoLite.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string platform = 6;
 * @return {string}
 */
proto.accountmanager.AccountInfoLite.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.BoolValue enabled = 7;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.AccountInfoLite.prototype.getEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 7));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
*/
proto.accountmanager.AccountInfoLite.prototype.setEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.clearEnabled = function() {
  return this.setEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountInfoLite.prototype.hasEnabled = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string status = 8;
 * @return {string}
 */
proto.accountmanager.AccountInfoLite.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string error_code = 9;
 * @return {string}
 */
proto.accountmanager.AccountInfoLite.prototype.getErrorCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setErrorCode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional double open_pl = 10;
 * @return {number}
 */
proto.accountmanager.AccountInfoLite.prototype.getOpenPl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setOpenPl = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional google.protobuf.StringValue name = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AccountInfoLite.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
*/
proto.accountmanager.AccountInfoLite.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountInfoLite.prototype.hasName = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue currency = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AccountInfoLite.prototype.getCurrency = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
*/
proto.accountmanager.AccountInfoLite.prototype.setCurrency = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.clearCurrency = function() {
  return this.setCurrency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountInfoLite.prototype.hasCurrency = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue user_id = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AccountInfoLite.prototype.getUserId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
*/
proto.accountmanager.AccountInfoLite.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountInfoLite.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.BoolValue with_proxy = 14;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.AccountInfoLite.prototype.getWithProxy = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 14));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
*/
proto.accountmanager.AccountInfoLite.prototype.setWithProxy = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.clearWithProxy = function() {
  return this.setWithProxy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountInfoLite.prototype.hasWithProxy = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue dedicated_env_id = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AccountInfoLite.prototype.getDedicatedEnvId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
*/
proto.accountmanager.AccountInfoLite.prototype.setDedicatedEnvId = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.clearDedicatedEnvId = function() {
  return this.setDedicatedEnvId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountInfoLite.prototype.hasDedicatedEnvId = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.StringValue ctr_auth_error = 16;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AccountInfoLite.prototype.getCtrAuthError = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 16));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
*/
proto.accountmanager.AccountInfoLite.prototype.setCtrAuthError = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.clearCtrAuthError = function() {
  return this.setCtrAuthError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountInfoLite.prototype.hasCtrAuthError = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string broker = 17;
 * @return {string}
 */
proto.accountmanager.AccountInfoLite.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string server_id = 18;
 * @return {string}
 */
proto.accountmanager.AccountInfoLite.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string am_status = 19;
 * @return {string}
 */
proto.accountmanager.AccountInfoLite.prototype.getAmStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setAmStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional ConnectionType connection_type = 20;
 * @return {!proto.accountmanager.ConnectionType}
 */
proto.accountmanager.AccountInfoLite.prototype.getConnectionType = function() {
  return /** @type {!proto.accountmanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.accountmanager.ConnectionType} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional string cluster = 21;
 * @return {string}
 */
proto.accountmanager.AccountInfoLite.prototype.getCluster = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setCluster = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional bool beta_connector = 22;
 * @return {boolean}
 */
proto.accountmanager.AccountInfoLite.prototype.getBetaConnector = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setBetaConnector = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional bool analyzer_enabled = 23;
 * @return {boolean}
 */
proto.accountmanager.AccountInfoLite.prototype.getAnalyzerEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setAnalyzerEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool premium = 24;
 * @return {boolean}
 */
proto.accountmanager.AccountInfoLite.prototype.getPremium = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AccountInfoLite} returns this
 */
proto.accountmanager.AccountInfoLite.prototype.setPremium = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UpdateAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UpdateAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UpdateAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
nickname: jspb.Message.getFieldWithDefault(msg, 3, ""),
password: (f = msg.getPassword()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
considerOnPortfolio: (f = msg.getConsiderOnPortfolio()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
activatePremium: (f = msg.getActivatePremium()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UpdateAccountReq}
 */
proto.accountmanager.UpdateAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UpdateAccountReq;
  return proto.accountmanager.UpdateAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UpdateAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UpdateAccountReq}
 */
proto.accountmanager.UpdateAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPassword(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setConsiderOnPortfolio(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setActivatePremium(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UpdateAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UpdateAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UpdateAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassword();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getConsiderOnPortfolio();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getActivatePremium();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.UpdateAccountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UpdateAccountReq} returns this
 */
proto.accountmanager.UpdateAccountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.UpdateAccountReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UpdateAccountReq} returns this
 */
proto.accountmanager.UpdateAccountReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string nickname = 3;
 * @return {string}
 */
proto.accountmanager.UpdateAccountReq.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UpdateAccountReq} returns this
 */
proto.accountmanager.UpdateAccountReq.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue password = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.UpdateAccountReq.prototype.getPassword = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.UpdateAccountReq} returns this
*/
proto.accountmanager.UpdateAccountReq.prototype.setPassword = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpdateAccountReq} returns this
 */
proto.accountmanager.UpdateAccountReq.prototype.clearPassword = function() {
  return this.setPassword(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpdateAccountReq.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue consider_on_portfolio = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.UpdateAccountReq.prototype.getConsiderOnPortfolio = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.UpdateAccountReq} returns this
*/
proto.accountmanager.UpdateAccountReq.prototype.setConsiderOnPortfolio = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpdateAccountReq} returns this
 */
proto.accountmanager.UpdateAccountReq.prototype.clearConsiderOnPortfolio = function() {
  return this.setConsiderOnPortfolio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpdateAccountReq.prototype.hasConsiderOnPortfolio = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.BoolValue activate_premium = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.UpdateAccountReq.prototype.getActivatePremium = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.UpdateAccountReq} returns this
*/
proto.accountmanager.UpdateAccountReq.prototype.setActivatePremium = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpdateAccountReq} returns this
 */
proto.accountmanager.UpdateAccountReq.prototype.clearActivatePremium = function() {
  return this.setActivatePremium(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpdateAccountReq.prototype.hasActivatePremium = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UpdateAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UpdateAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UpdateAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UpdateAccountReply}
 */
proto.accountmanager.UpdateAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UpdateAccountReply;
  return proto.accountmanager.UpdateAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UpdateAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UpdateAccountReply}
 */
proto.accountmanager.UpdateAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UpdateAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UpdateAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UpdateAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.EnableAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.EnableAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.EnableAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
enable: (f = msg.getEnable()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
priority: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.EnableAccountReq}
 */
proto.accountmanager.EnableAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.EnableAccountReq;
  return proto.accountmanager.EnableAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.EnableAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.EnableAccountReq}
 */
proto.accountmanager.EnableAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnable(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.EnableAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.EnableAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.EnableAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnable();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getPriority();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.EnableAccountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.EnableAccountReq} returns this
 */
proto.accountmanager.EnableAccountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.EnableAccountReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.EnableAccountReq} returns this
 */
proto.accountmanager.EnableAccountReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.BoolValue enable = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.EnableAccountReq.prototype.getEnable = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.EnableAccountReq} returns this
*/
proto.accountmanager.EnableAccountReq.prototype.setEnable = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.EnableAccountReq} returns this
 */
proto.accountmanager.EnableAccountReq.prototype.clearEnable = function() {
  return this.setEnable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.EnableAccountReq.prototype.hasEnable = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 priority = 4;
 * @return {number}
 */
proto.accountmanager.EnableAccountReq.prototype.getPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.EnableAccountReq} returns this
 */
proto.accountmanager.EnableAccountReq.prototype.setPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.EnableAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.EnableAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.EnableAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
failedPriority: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.EnableAccountReply}
 */
proto.accountmanager.EnableAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.EnableAccountReply;
  return proto.accountmanager.EnableAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.EnableAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.EnableAccountReply}
 */
proto.accountmanager.EnableAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFailedPriority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.EnableAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.EnableAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.EnableAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getFailedPriority();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.accountmanager.EnableAccountReply.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.EnableAccountReply} returns this
 */
proto.accountmanager.EnableAccountReply.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 failed_priority = 2;
 * @return {number}
 */
proto.accountmanager.EnableAccountReply.prototype.getFailedPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.EnableAccountReply} returns this
 */
proto.accountmanager.EnableAccountReply.prototype.setFailedPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.ActivateBetaConnectionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.ActivateBetaConnectionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.ActivateBetaConnectionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ActivateBetaConnectionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
activateBeta: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.ActivateBetaConnectionReq}
 */
proto.accountmanager.ActivateBetaConnectionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.ActivateBetaConnectionReq;
  return proto.accountmanager.ActivateBetaConnectionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.ActivateBetaConnectionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.ActivateBetaConnectionReq}
 */
proto.accountmanager.ActivateBetaConnectionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActivateBeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.ActivateBetaConnectionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.ActivateBetaConnectionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.ActivateBetaConnectionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ActivateBetaConnectionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActivateBeta();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.ActivateBetaConnectionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ActivateBetaConnectionReq} returns this
 */
proto.accountmanager.ActivateBetaConnectionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.ActivateBetaConnectionReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ActivateBetaConnectionReq} returns this
 */
proto.accountmanager.ActivateBetaConnectionReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool activate_beta = 3;
 * @return {boolean}
 */
proto.accountmanager.ActivateBetaConnectionReq.prototype.getActivateBeta = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.ActivateBetaConnectionReq} returns this
 */
proto.accountmanager.ActivateBetaConnectionReq.prototype.setActivateBeta = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.ActivateBetaConnectionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.ActivateBetaConnectionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.ActivateBetaConnectionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ActivateBetaConnectionReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.ActivateBetaConnectionReply}
 */
proto.accountmanager.ActivateBetaConnectionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.ActivateBetaConnectionReply;
  return proto.accountmanager.ActivateBetaConnectionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.ActivateBetaConnectionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.ActivateBetaConnectionReply}
 */
proto.accountmanager.ActivateBetaConnectionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.ActivateBetaConnectionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.ActivateBetaConnectionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.ActivateBetaConnectionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ActivateBetaConnectionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminActivateBetaConnectionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminActivateBetaConnectionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminActivateBetaConnectionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminActivateBetaConnectionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
activateBeta: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminActivateBetaConnectionReq}
 */
proto.accountmanager.AdminActivateBetaConnectionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminActivateBetaConnectionReq;
  return proto.accountmanager.AdminActivateBetaConnectionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminActivateBetaConnectionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminActivateBetaConnectionReq}
 */
proto.accountmanager.AdminActivateBetaConnectionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActivateBeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminActivateBetaConnectionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminActivateBetaConnectionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminActivateBetaConnectionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminActivateBetaConnectionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActivateBeta();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminActivateBetaConnectionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminActivateBetaConnectionReq} returns this
 */
proto.accountmanager.AdminActivateBetaConnectionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminActivateBetaConnectionReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminActivateBetaConnectionReq} returns this
 */
proto.accountmanager.AdminActivateBetaConnectionReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool activate_beta = 3;
 * @return {boolean}
 */
proto.accountmanager.AdminActivateBetaConnectionReq.prototype.getActivateBeta = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AdminActivateBetaConnectionReq} returns this
 */
proto.accountmanager.AdminActivateBetaConnectionReq.prototype.setActivateBeta = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminActivateBetaConnectionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminActivateBetaConnectionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminActivateBetaConnectionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminActivateBetaConnectionReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminActivateBetaConnectionReply}
 */
proto.accountmanager.AdminActivateBetaConnectionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminActivateBetaConnectionReply;
  return proto.accountmanager.AdminActivateBetaConnectionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminActivateBetaConnectionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminActivateBetaConnectionReply}
 */
proto.accountmanager.AdminActivateBetaConnectionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminActivateBetaConnectionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminActivateBetaConnectionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminActivateBetaConnectionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminActivateBetaConnectionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.ListAccountSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.ListAccountSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ListAccountSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
query: jspb.Message.getFieldWithDefault(msg, 3, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 4, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.ListAccountSymbolsReq}
 */
proto.accountmanager.ListAccountSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.ListAccountSymbolsReq;
  return proto.accountmanager.ListAccountSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.ListAccountSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.ListAccountSymbolsReq}
 */
proto.accountmanager.ListAccountSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.ListAccountSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.ListAccountSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ListAccountSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ListAccountSymbolsReq} returns this
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ListAccountSymbolsReq} returns this
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string query = 3;
 * @return {string}
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ListAccountSymbolsReq} returns this
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string pagination_cursor = 4;
 * @return {string}
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ListAccountSymbolsReq} returns this
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 page_size = 5;
 * @return {number}
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.ListAccountSymbolsReq} returns this
 */
proto.accountmanager.ListAccountSymbolsReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.ListAccountSymbolsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.ListAccountSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.ListAccountSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ListAccountSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
symbolsList: jspb.Message.toObjectList(msg.getSymbolsList(),
    proto.accountmanager.Symbol.toObject, includeInstance),
allEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 3, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
total: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.ListAccountSymbolsReply}
 */
proto.accountmanager.ListAccountSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.ListAccountSymbolsReply;
  return proto.accountmanager.ListAccountSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.ListAccountSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.ListAccountSymbolsReply}
 */
proto.accountmanager.ListAccountSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.Symbol;
      reader.readMessage(value,proto.accountmanager.Symbol.deserializeBinaryFromReader);
      msg.addSymbols(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllEnabled(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.ListAccountSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.ListAccountSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ListAccountSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.Symbol.serializeBinaryToWriter
    );
  }
  f = message.getAllEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * repeated Symbol symbols = 1;
 * @return {!Array<!proto.accountmanager.Symbol>}
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.getSymbolsList = function() {
  return /** @type{!Array<!proto.accountmanager.Symbol>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.Symbol, 1));
};


/**
 * @param {!Array<!proto.accountmanager.Symbol>} value
 * @return {!proto.accountmanager.ListAccountSymbolsReply} returns this
*/
proto.accountmanager.ListAccountSymbolsReply.prototype.setSymbolsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.Symbol=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.Symbol}
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.addSymbols = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.Symbol, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.ListAccountSymbolsReply} returns this
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.clearSymbolsList = function() {
  return this.setSymbolsList([]);
};


/**
 * optional bool all_enabled = 2;
 * @return {boolean}
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.getAllEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.ListAccountSymbolsReply} returns this
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.setAllEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string next_page_cursor = 3;
 * @return {string}
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ListAccountSymbolsReply} returns this
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 page_size = 4;
 * @return {number}
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.ListAccountSymbolsReply} returns this
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 total = 5;
 * @return {number}
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.ListAccountSymbolsReply} returns this
 */
proto.accountmanager.ListAccountSymbolsReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.Symbol.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.Symbol.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.Symbol} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.Symbol.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
tradeModeEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
info: (f = msg.getInfo()) && proto.accountmanager.SymbolInfo.toObject(includeInstance, f),
infoOverride: (f = msg.getInfoOverride()) && proto.accountmanager.SymbolInfo.toObject(includeInstance, f),
description: (f = msg.getDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.Symbol}
 */
proto.accountmanager.Symbol.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.Symbol;
  return proto.accountmanager.Symbol.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.Symbol} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.Symbol}
 */
proto.accountmanager.Symbol.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTradeModeEnabled(value);
      break;
    case 5:
      var value = new proto.accountmanager.SymbolInfo;
      reader.readMessage(value,proto.accountmanager.SymbolInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 6:
      var value = new proto.accountmanager.SymbolInfo;
      reader.readMessage(value,proto.accountmanager.SymbolInfo.deserializeBinaryFromReader);
      msg.setInfoOverride(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.Symbol.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.Symbol.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.Symbol} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.Symbol.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTradeModeEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.accountmanager.SymbolInfo.serializeBinaryToWriter
    );
  }
  f = message.getInfoOverride();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.accountmanager.SymbolInfo.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.accountmanager.Symbol.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.Symbol} returns this
 */
proto.accountmanager.Symbol.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.accountmanager.Symbol.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Symbol} returns this
 */
proto.accountmanager.Symbol.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool enabled = 3;
 * @return {boolean}
 */
proto.accountmanager.Symbol.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.Symbol} returns this
 */
proto.accountmanager.Symbol.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool trade_mode_enabled = 4;
 * @return {boolean}
 */
proto.accountmanager.Symbol.prototype.getTradeModeEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.Symbol} returns this
 */
proto.accountmanager.Symbol.prototype.setTradeModeEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional SymbolInfo info = 5;
 * @return {?proto.accountmanager.SymbolInfo}
 */
proto.accountmanager.Symbol.prototype.getInfo = function() {
  return /** @type{?proto.accountmanager.SymbolInfo} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.SymbolInfo, 5));
};


/**
 * @param {?proto.accountmanager.SymbolInfo|undefined} value
 * @return {!proto.accountmanager.Symbol} returns this
*/
proto.accountmanager.Symbol.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Symbol} returns this
 */
proto.accountmanager.Symbol.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Symbol.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional SymbolInfo info_override = 6;
 * @return {?proto.accountmanager.SymbolInfo}
 */
proto.accountmanager.Symbol.prototype.getInfoOverride = function() {
  return /** @type{?proto.accountmanager.SymbolInfo} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.SymbolInfo, 6));
};


/**
 * @param {?proto.accountmanager.SymbolInfo|undefined} value
 * @return {!proto.accountmanager.Symbol} returns this
*/
proto.accountmanager.Symbol.prototype.setInfoOverride = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Symbol} returns this
 */
proto.accountmanager.Symbol.prototype.clearInfoOverride = function() {
  return this.setInfoOverride(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Symbol.prototype.hasInfoOverride = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue description = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.Symbol.prototype.getDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.Symbol} returns this
*/
proto.accountmanager.Symbol.prototype.setDescription = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Symbol} returns this
 */
proto.accountmanager.Symbol.prototype.clearDescription = function() {
  return this.setDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Symbol.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.SymbolInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.SymbolInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.SymbolInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
minLots: (f = msg.getMinLots()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLots: (f = msg.getMaxLots()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotsStep: (f = msg.getLotsStep()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
contractSize: (f = msg.getContractSize()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tickValue: (f = msg.getTickValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tickSize: (f = msg.getTickSize()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
profitMode: (f = msg.getProfitMode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
tradeMode: (f = msg.getTradeMode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.SymbolInfo}
 */
proto.accountmanager.SymbolInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.SymbolInfo;
  return proto.accountmanager.SymbolInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.SymbolInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.SymbolInfo}
 */
proto.accountmanager.SymbolInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLots(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLots(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotsStep(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setContractSize(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTickValue(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTickSize(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfitMode(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTradeMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.SymbolInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.SymbolInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.SymbolInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinLots();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLots();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotsStep();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getContractSize();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTickValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTickSize();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitMode();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTradeMode();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.DoubleValue min_lots = 1;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolInfo.prototype.getMinLots = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 1));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolInfo} returns this
*/
proto.accountmanager.SymbolInfo.prototype.setMinLots = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolInfo} returns this
 */
proto.accountmanager.SymbolInfo.prototype.clearMinLots = function() {
  return this.setMinLots(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolInfo.prototype.hasMinLots = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lots = 2;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolInfo.prototype.getMaxLots = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 2));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolInfo} returns this
*/
proto.accountmanager.SymbolInfo.prototype.setMaxLots = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolInfo} returns this
 */
proto.accountmanager.SymbolInfo.prototype.clearMaxLots = function() {
  return this.setMaxLots(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolInfo.prototype.hasMaxLots = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.DoubleValue lots_step = 3;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolInfo.prototype.getLotsStep = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 3));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolInfo} returns this
*/
proto.accountmanager.SymbolInfo.prototype.setLotsStep = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolInfo} returns this
 */
proto.accountmanager.SymbolInfo.prototype.clearLotsStep = function() {
  return this.setLotsStep(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolInfo.prototype.hasLotsStep = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.DoubleValue contract_size = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolInfo.prototype.getContractSize = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolInfo} returns this
*/
proto.accountmanager.SymbolInfo.prototype.setContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolInfo} returns this
 */
proto.accountmanager.SymbolInfo.prototype.clearContractSize = function() {
  return this.setContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolInfo.prototype.hasContractSize = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue tick_value = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolInfo.prototype.getTickValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolInfo} returns this
*/
proto.accountmanager.SymbolInfo.prototype.setTickValue = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolInfo} returns this
 */
proto.accountmanager.SymbolInfo.prototype.clearTickValue = function() {
  return this.setTickValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolInfo.prototype.hasTickValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue tick_size = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolInfo.prototype.getTickSize = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolInfo} returns this
*/
proto.accountmanager.SymbolInfo.prototype.setTickSize = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolInfo} returns this
 */
proto.accountmanager.SymbolInfo.prototype.clearTickSize = function() {
  return this.setTickSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolInfo.prototype.hasTickSize = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue profit_mode = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.SymbolInfo.prototype.getProfitMode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.SymbolInfo} returns this
*/
proto.accountmanager.SymbolInfo.prototype.setProfitMode = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolInfo} returns this
 */
proto.accountmanager.SymbolInfo.prototype.clearProfitMode = function() {
  return this.setProfitMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolInfo.prototype.hasProfitMode = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue trade_mode = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.SymbolInfo.prototype.getTradeMode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.SymbolInfo} returns this
*/
proto.accountmanager.SymbolInfo.prototype.setTradeMode = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolInfo} returns this
 */
proto.accountmanager.SymbolInfo.prototype.clearTradeMode = function() {
  return this.setTradeMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolInfo.prototype.hasTradeMode = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.EnableAccountSymbolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.EnableAccountSymbolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.EnableAccountSymbolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAccountSymbolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbolId: jspb.Message.getFieldWithDefault(msg, 3, 0),
enable: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.EnableAccountSymbolReq}
 */
proto.accountmanager.EnableAccountSymbolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.EnableAccountSymbolReq;
  return proto.accountmanager.EnableAccountSymbolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.EnableAccountSymbolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.EnableAccountSymbolReq}
 */
proto.accountmanager.EnableAccountSymbolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSymbolId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.EnableAccountSymbolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.EnableAccountSymbolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.EnableAccountSymbolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAccountSymbolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getEnable();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.EnableAccountSymbolReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.EnableAccountSymbolReq} returns this
 */
proto.accountmanager.EnableAccountSymbolReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.EnableAccountSymbolReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.EnableAccountSymbolReq} returns this
 */
proto.accountmanager.EnableAccountSymbolReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 symbol_id = 3;
 * @return {number}
 */
proto.accountmanager.EnableAccountSymbolReq.prototype.getSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.EnableAccountSymbolReq} returns this
 */
proto.accountmanager.EnableAccountSymbolReq.prototype.setSymbolId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool enable = 4;
 * @return {boolean}
 */
proto.accountmanager.EnableAccountSymbolReq.prototype.getEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.EnableAccountSymbolReq} returns this
 */
proto.accountmanager.EnableAccountSymbolReq.prototype.setEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.EnableAccountSymbolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.EnableAccountSymbolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.EnableAccountSymbolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAccountSymbolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.EnableAccountSymbolReply}
 */
proto.accountmanager.EnableAccountSymbolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.EnableAccountSymbolReply;
  return proto.accountmanager.EnableAccountSymbolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.EnableAccountSymbolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.EnableAccountSymbolReply}
 */
proto.accountmanager.EnableAccountSymbolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.EnableAccountSymbolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.EnableAccountSymbolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.EnableAccountSymbolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAccountSymbolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.EnableAllAccountSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.EnableAllAccountSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.EnableAllAccountSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAllAccountSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
enable: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.EnableAllAccountSymbolsReq}
 */
proto.accountmanager.EnableAllAccountSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.EnableAllAccountSymbolsReq;
  return proto.accountmanager.EnableAllAccountSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.EnableAllAccountSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.EnableAllAccountSymbolsReq}
 */
proto.accountmanager.EnableAllAccountSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.EnableAllAccountSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.EnableAllAccountSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.EnableAllAccountSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAllAccountSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnable();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.EnableAllAccountSymbolsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.EnableAllAccountSymbolsReq} returns this
 */
proto.accountmanager.EnableAllAccountSymbolsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.EnableAllAccountSymbolsReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.EnableAllAccountSymbolsReq} returns this
 */
proto.accountmanager.EnableAllAccountSymbolsReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool enable = 3;
 * @return {boolean}
 */
proto.accountmanager.EnableAllAccountSymbolsReq.prototype.getEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.EnableAllAccountSymbolsReq} returns this
 */
proto.accountmanager.EnableAllAccountSymbolsReq.prototype.setEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.EnableAllAccountSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.EnableAllAccountSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.EnableAllAccountSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAllAccountSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.EnableAllAccountSymbolsReply}
 */
proto.accountmanager.EnableAllAccountSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.EnableAllAccountSymbolsReply;
  return proto.accountmanager.EnableAllAccountSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.EnableAllAccountSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.EnableAllAccountSymbolsReply}
 */
proto.accountmanager.EnableAllAccountSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.EnableAllAccountSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.EnableAllAccountSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.EnableAllAccountSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.EnableAllAccountSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.ListCopiedTradesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.ListCopiedTradesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.ListCopiedTradesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ListCopiedTradesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
searchTicket: (f = msg.getSearchTicket()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.ListCopiedTradesReq}
 */
proto.accountmanager.ListCopiedTradesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.ListCopiedTradesReq;
  return proto.accountmanager.ListCopiedTradesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.ListCopiedTradesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.ListCopiedTradesReq}
 */
proto.accountmanager.ListCopiedTradesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSearchTicket(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.ListCopiedTradesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.ListCopiedTradesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.ListCopiedTradesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ListCopiedTradesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSearchTicket();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.ListCopiedTradesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ListCopiedTradesReq} returns this
 */
proto.accountmanager.ListCopiedTradesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pagination_cursor = 2;
 * @return {string}
 */
proto.accountmanager.ListCopiedTradesReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ListCopiedTradesReq} returns this
 */
proto.accountmanager.ListCopiedTradesReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.ListCopiedTradesReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.ListCopiedTradesReq} returns this
 */
proto.accountmanager.ListCopiedTradesReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue search_ticket = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.ListCopiedTradesReq.prototype.getSearchTicket = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.ListCopiedTradesReq} returns this
*/
proto.accountmanager.ListCopiedTradesReq.prototype.setSearchTicket = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.ListCopiedTradesReq} returns this
 */
proto.accountmanager.ListCopiedTradesReq.prototype.clearSearchTicket = function() {
  return this.setSearchTicket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.ListCopiedTradesReq.prototype.hasSearchTicket = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.ListCopiedTradesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.ListCopiedTradesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.ListCopiedTradesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.ListCopiedTradesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ListCopiedTradesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tradesList: jspb.Message.toObjectList(msg.getTradesList(),
    proto.accountmanager.Trade.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.ListCopiedTradesReply}
 */
proto.accountmanager.ListCopiedTradesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.ListCopiedTradesReply;
  return proto.accountmanager.ListCopiedTradesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.ListCopiedTradesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.ListCopiedTradesReply}
 */
proto.accountmanager.ListCopiedTradesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.Trade;
      reader.readMessage(value,proto.accountmanager.Trade.deserializeBinaryFromReader);
      msg.addTrades(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.ListCopiedTradesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.ListCopiedTradesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.ListCopiedTradesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ListCopiedTradesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.Trade.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated Trade trades = 1;
 * @return {!Array<!proto.accountmanager.Trade>}
 */
proto.accountmanager.ListCopiedTradesReply.prototype.getTradesList = function() {
  return /** @type{!Array<!proto.accountmanager.Trade>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.Trade, 1));
};


/**
 * @param {!Array<!proto.accountmanager.Trade>} value
 * @return {!proto.accountmanager.ListCopiedTradesReply} returns this
*/
proto.accountmanager.ListCopiedTradesReply.prototype.setTradesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.Trade=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.Trade}
 */
proto.accountmanager.ListCopiedTradesReply.prototype.addTrades = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.Trade, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.ListCopiedTradesReply} returns this
 */
proto.accountmanager.ListCopiedTradesReply.prototype.clearTradesList = function() {
  return this.setTradesList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.accountmanager.ListCopiedTradesReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ListCopiedTradesReply} returns this
 */
proto.accountmanager.ListCopiedTradesReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.ListCopiedTradesReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.ListCopiedTradesReply} returns this
 */
proto.accountmanager.ListCopiedTradesReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.accountmanager.ListCopiedTradesReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.ListCopiedTradesReply} returns this
 */
proto.accountmanager.ListCopiedTradesReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.Trade.repeatedFields_ = [17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.Trade.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.Trade.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.Trade} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.Trade.toObject = function(includeInstance, msg) {
  var f, obj = {
ticket: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountName: jspb.Message.getFieldWithDefault(msg, 2, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
type: jspb.Message.getFieldWithDefault(msg, 5, ""),
lots: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
openPrice: (f = msg.getOpenPrice()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
stopLoss: (f = msg.getStopLoss()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
takeProfit: (f = msg.getTakeProfit()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
commission: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
swap: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
profit: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
comment: jspb.Message.getFieldWithDefault(msg, 13, ""),
openTime: (f = msg.getOpenTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
closeTime: (f = msg.getCloseTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
closePrice: (f = msg.getClosePrice()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
logsList: jspb.Message.toObjectList(msg.getLogsList(),
    proto.accountmanager.Log.toObject, includeInstance),
currency: jspb.Message.getFieldWithDefault(msg, 18, ""),
closeComment: (f = msg.getCloseComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
master: (f = msg.getMaster()) && proto.accountmanager.MasterTrade.toObject(includeInstance, f),
accountId: jspb.Message.getFieldWithDefault(msg, 21, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
id: jspb.Message.getFieldWithDefault(msg, 23, 0),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.Trade}
 */
proto.accountmanager.Trade.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.Trade;
  return proto.accountmanager.Trade.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.Trade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.Trade}
 */
proto.accountmanager.Trade.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicket(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLots(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOpenPrice(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStopLoss(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTakeProfit(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommission(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSwap(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfit(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOpenTime(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCloseTime(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setClosePrice(value);
      break;
    case 17:
      var value = new proto.accountmanager.Log;
      reader.readMessage(value,proto.accountmanager.Log.deserializeBinaryFromReader);
      msg.addLogs(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCloseComment(value);
      break;
    case 20:
      var value = new proto.accountmanager.MasterTrade;
      reader.readMessage(value,proto.accountmanager.MasterTrade.deserializeBinaryFromReader);
      msg.setMaster(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 22:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.Trade.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.Trade.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.Trade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.Trade.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLots();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getOpenPrice();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStopLoss();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTakeProfit();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCommission();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getSwap();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getOpenTime();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCloseTime();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getClosePrice();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.accountmanager.Log.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getCloseComment();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMaster();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.accountmanager.MasterTrade.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      23,
      f
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ticket = 1;
 * @return {string}
 */
proto.accountmanager.Trade.prototype.getTicket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setTicket = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_name = 2;
 * @return {string}
 */
proto.accountmanager.Trade.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_number = 3;
 * @return {string}
 */
proto.accountmanager.Trade.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.accountmanager.Trade.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string type = 5;
 * @return {string}
 */
proto.accountmanager.Trade.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional double lots = 6;
 * @return {number}
 */
proto.accountmanager.Trade.prototype.getLots = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setLots = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional google.protobuf.StringValue open_price = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.Trade.prototype.getOpenPrice = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.Trade} returns this
*/
proto.accountmanager.Trade.prototype.setOpenPrice = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.clearOpenPrice = function() {
  return this.setOpenPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Trade.prototype.hasOpenPrice = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue stop_loss = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.Trade.prototype.getStopLoss = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.Trade} returns this
*/
proto.accountmanager.Trade.prototype.setStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.clearStopLoss = function() {
  return this.setStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Trade.prototype.hasStopLoss = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue take_profit = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.Trade.prototype.getTakeProfit = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.Trade} returns this
*/
proto.accountmanager.Trade.prototype.setTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.clearTakeProfit = function() {
  return this.setTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Trade.prototype.hasTakeProfit = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional double commission = 10;
 * @return {number}
 */
proto.accountmanager.Trade.prototype.getCommission = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setCommission = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double swap = 11;
 * @return {number}
 */
proto.accountmanager.Trade.prototype.getSwap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setSwap = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double profit = 12;
 * @return {number}
 */
proto.accountmanager.Trade.prototype.getProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional string comment = 13;
 * @return {string}
 */
proto.accountmanager.Trade.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional google.protobuf.Timestamp open_time = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountmanager.Trade.prototype.getOpenTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountmanager.Trade} returns this
*/
proto.accountmanager.Trade.prototype.setOpenTime = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.clearOpenTime = function() {
  return this.setOpenTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Trade.prototype.hasOpenTime = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Timestamp close_time = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountmanager.Trade.prototype.getCloseTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountmanager.Trade} returns this
*/
proto.accountmanager.Trade.prototype.setCloseTime = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.clearCloseTime = function() {
  return this.setCloseTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Trade.prototype.hasCloseTime = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.StringValue close_price = 16;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.Trade.prototype.getClosePrice = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 16));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.Trade} returns this
*/
proto.accountmanager.Trade.prototype.setClosePrice = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.clearClosePrice = function() {
  return this.setClosePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Trade.prototype.hasClosePrice = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * repeated Log logs = 17;
 * @return {!Array<!proto.accountmanager.Log>}
 */
proto.accountmanager.Trade.prototype.getLogsList = function() {
  return /** @type{!Array<!proto.accountmanager.Log>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.Log, 17));
};


/**
 * @param {!Array<!proto.accountmanager.Log>} value
 * @return {!proto.accountmanager.Trade} returns this
*/
proto.accountmanager.Trade.prototype.setLogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.accountmanager.Log=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.Log}
 */
proto.accountmanager.Trade.prototype.addLogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.accountmanager.Log, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.clearLogsList = function() {
  return this.setLogsList([]);
};


/**
 * optional string currency = 18;
 * @return {string}
 */
proto.accountmanager.Trade.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional google.protobuf.StringValue close_comment = 19;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.Trade.prototype.getCloseComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 19));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.Trade} returns this
*/
proto.accountmanager.Trade.prototype.setCloseComment = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.clearCloseComment = function() {
  return this.setCloseComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Trade.prototype.hasCloseComment = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional MasterTrade master = 20;
 * @return {?proto.accountmanager.MasterTrade}
 */
proto.accountmanager.Trade.prototype.getMaster = function() {
  return /** @type{?proto.accountmanager.MasterTrade} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.MasterTrade, 20));
};


/**
 * @param {?proto.accountmanager.MasterTrade|undefined} value
 * @return {!proto.accountmanager.Trade} returns this
*/
proto.accountmanager.Trade.prototype.setMaster = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.clearMaster = function() {
  return this.setMaster(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Trade.prototype.hasMaster = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional string account_id = 21;
 * @return {string}
 */
proto.accountmanager.Trade.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 22;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountmanager.Trade.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 22));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountmanager.Trade} returns this
*/
proto.accountmanager.Trade.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Trade.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional uint64 id = 23;
 * @return {number}
 */
proto.accountmanager.Trade.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional google.protobuf.Int64Value magic_number = 24;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.accountmanager.Trade.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 24));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.accountmanager.Trade} returns this
*/
proto.accountmanager.Trade.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Trade} returns this
 */
proto.accountmanager.Trade.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Trade.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 24) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.Log.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.Log.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.Log} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.Log.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, ""),
message: (f = msg.getMessage()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
level: jspb.Message.getFieldWithDefault(msg, 3, ""),
reqPayload: msg.getReqPayload_asB64(),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.Log}
 */
proto.accountmanager.Log.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.Log;
  return proto.accountmanager.Log.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.Log} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.Log}
 */
proto.accountmanager.Log.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLevel(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setReqPayload(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.Log.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.Log.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.Log} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.Log.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLevel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReqPayload_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.accountmanager.Log.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Log} returns this
 */
proto.accountmanager.Log.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue message = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.Log.prototype.getMessage = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.Log} returns this
*/
proto.accountmanager.Log.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Log} returns this
 */
proto.accountmanager.Log.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Log.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string level = 3;
 * @return {string}
 */
proto.accountmanager.Log.prototype.getLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Log} returns this
 */
proto.accountmanager.Log.prototype.setLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bytes req_payload = 4;
 * @return {!(string|Uint8Array)}
 */
proto.accountmanager.Log.prototype.getReqPayload = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes req_payload = 4;
 * This is a type-conversion wrapper around `getReqPayload()`
 * @return {string}
 */
proto.accountmanager.Log.prototype.getReqPayload_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getReqPayload()));
};


/**
 * optional bytes req_payload = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getReqPayload()`
 * @return {!Uint8Array}
 */
proto.accountmanager.Log.prototype.getReqPayload_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getReqPayload()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.accountmanager.Log} returns this
 */
proto.accountmanager.Log.prototype.setReqPayload = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountmanager.Log.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountmanager.Log} returns this
*/
proto.accountmanager.Log.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.Log} returns this
 */
proto.accountmanager.Log.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.Log.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.MasterTrade.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.MasterTrade.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.MasterTrade} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MasterTrade.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
ticket: jspb.Message.getFieldWithDefault(msg, 3, ""),
accountName: jspb.Message.getFieldWithDefault(msg, 4, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
type: jspb.Message.getFieldWithDefault(msg, 6, ""),
lots: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
openTime: (f = msg.getOpenTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
profit: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
openPrice: (f = msg.getOpenPrice()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
closePrice: (f = msg.getClosePrice()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
closeTime: (f = msg.getCloseTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
accountCurrency: jspb.Message.getFieldWithDefault(msg, 13, ""),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.MasterTrade}
 */
proto.accountmanager.MasterTrade.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.MasterTrade;
  return proto.accountmanager.MasterTrade.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.MasterTrade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.MasterTrade}
 */
proto.accountmanager.MasterTrade.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicket(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLots(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOpenTime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfit(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOpenPrice(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setClosePrice(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCloseTime(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountCurrency(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.MasterTrade.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.MasterTrade.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.MasterTrade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MasterTrade.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicket();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLots();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getOpenTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getOpenPrice();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getClosePrice();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseTime();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccountCurrency();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.MasterTrade.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_number = 2;
 * @return {string}
 */
proto.accountmanager.MasterTrade.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ticket = 3;
 * @return {string}
 */
proto.accountmanager.MasterTrade.prototype.getTicket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.setTicket = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_name = 4;
 * @return {string}
 */
proto.accountmanager.MasterTrade.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.accountmanager.MasterTrade.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string type = 6;
 * @return {string}
 */
proto.accountmanager.MasterTrade.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional double lots = 7;
 * @return {number}
 */
proto.accountmanager.MasterTrade.prototype.getLots = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.setLots = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp open_time = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountmanager.MasterTrade.prototype.getOpenTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountmanager.MasterTrade} returns this
*/
proto.accountmanager.MasterTrade.prototype.setOpenTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.clearOpenTime = function() {
  return this.setOpenTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.MasterTrade.prototype.hasOpenTime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional double profit = 9;
 * @return {number}
 */
proto.accountmanager.MasterTrade.prototype.getProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.setProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional google.protobuf.StringValue open_price = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.MasterTrade.prototype.getOpenPrice = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.MasterTrade} returns this
*/
proto.accountmanager.MasterTrade.prototype.setOpenPrice = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.clearOpenPrice = function() {
  return this.setOpenPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.MasterTrade.prototype.hasOpenPrice = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue close_price = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.MasterTrade.prototype.getClosePrice = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.MasterTrade} returns this
*/
proto.accountmanager.MasterTrade.prototype.setClosePrice = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.clearClosePrice = function() {
  return this.setClosePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.MasterTrade.prototype.hasClosePrice = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp close_time = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountmanager.MasterTrade.prototype.getCloseTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountmanager.MasterTrade} returns this
*/
proto.accountmanager.MasterTrade.prototype.setCloseTime = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.clearCloseTime = function() {
  return this.setCloseTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.MasterTrade.prototype.hasCloseTime = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string account_currency = 13;
 * @return {string}
 */
proto.accountmanager.MasterTrade.prototype.getAccountCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.setAccountCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional google.protobuf.Int64Value magic_number = 14;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.accountmanager.MasterTrade.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 14));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.accountmanager.MasterTrade} returns this
*/
proto.accountmanager.MasterTrade.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.MasterTrade} returns this
 */
proto.accountmanager.MasterTrade.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.MasterTrade.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 14) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.CompareSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.CompareSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.CompareSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CompareSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveAccount: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.CompareSymbolsReq}
 */
proto.accountmanager.CompareSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.CompareSymbolsReq;
  return proto.accountmanager.CompareSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.CompareSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.CompareSymbolsReq}
 */
proto.accountmanager.CompareSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.CompareSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.CompareSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.CompareSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CompareSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveAccount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.CompareSymbolsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.CompareSymbolsReq} returns this
 */
proto.accountmanager.CompareSymbolsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.accountmanager.CompareSymbolsReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.CompareSymbolsReq} returns this
 */
proto.accountmanager.CompareSymbolsReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_account = 3;
 * @return {string}
 */
proto.accountmanager.CompareSymbolsReq.prototype.getSlaveAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.CompareSymbolsReq} returns this
 */
proto.accountmanager.CompareSymbolsReq.prototype.setSlaveAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.CompareSymbolsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.CompareSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.CompareSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.CompareSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CompareSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
suggestionsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.CompareSymbolsReply}
 */
proto.accountmanager.CompareSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.CompareSymbolsReply;
  return proto.accountmanager.CompareSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.CompareSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.CompareSymbolsReply}
 */
proto.accountmanager.CompareSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addSuggestions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.CompareSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.CompareSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.CompareSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CompareSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuggestionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string suggestions = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.CompareSymbolsReply.prototype.getSuggestionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.CompareSymbolsReply} returns this
 */
proto.accountmanager.CompareSymbolsReply.prototype.setSuggestionsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.CompareSymbolsReply} returns this
 */
proto.accountmanager.CompareSymbolsReply.prototype.addSuggestions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.CompareSymbolsReply} returns this
 */
proto.accountmanager.CompareSymbolsReply.prototype.clearSuggestionsList = function() {
  return this.setSuggestionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntGetAccountsWithIDsReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetAccountsWithIDsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetAccountsWithIDsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetAccountsWithIDsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountsWithIDsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetAccountsWithIDsReq}
 */
proto.accountmanager.IntGetAccountsWithIDsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetAccountsWithIDsReq;
  return proto.accountmanager.IntGetAccountsWithIDsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetAccountsWithIDsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetAccountsWithIDsReq}
 */
proto.accountmanager.IntGetAccountsWithIDsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetAccountsWithIDsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetAccountsWithIDsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetAccountsWithIDsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountsWithIDsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.IntGetAccountsWithIDsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntGetAccountsWithIDsReq} returns this
 */
proto.accountmanager.IntGetAccountsWithIDsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string accounts = 2;
 * @return {!Array<string>}
 */
proto.accountmanager.IntGetAccountsWithIDsReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntGetAccountsWithIDsReq} returns this
 */
proto.accountmanager.IntGetAccountsWithIDsReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntGetAccountsWithIDsReq} returns this
 */
proto.accountmanager.IntGetAccountsWithIDsReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntGetAccountsWithIDsReq} returns this
 */
proto.accountmanager.IntGetAccountsWithIDsReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntGetAccountsWithIDsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetAccountsWithIDsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetAccountsWithIDsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetAccountsWithIDsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountsWithIDsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.AccountBalance.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetAccountsWithIDsReply}
 */
proto.accountmanager.IntGetAccountsWithIDsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetAccountsWithIDsReply;
  return proto.accountmanager.IntGetAccountsWithIDsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetAccountsWithIDsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetAccountsWithIDsReply}
 */
proto.accountmanager.IntGetAccountsWithIDsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.AccountBalance;
      reader.readMessage(value,proto.accountmanager.AccountBalance.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetAccountsWithIDsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetAccountsWithIDsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetAccountsWithIDsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountsWithIDsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.AccountBalance.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountBalance accounts = 1;
 * @return {!Array<!proto.accountmanager.AccountBalance>}
 */
proto.accountmanager.IntGetAccountsWithIDsReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.AccountBalance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.AccountBalance, 1));
};


/**
 * @param {!Array<!proto.accountmanager.AccountBalance>} value
 * @return {!proto.accountmanager.IntGetAccountsWithIDsReply} returns this
*/
proto.accountmanager.IntGetAccountsWithIDsReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.AccountBalance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AccountBalance}
 */
proto.accountmanager.IntGetAccountsWithIDsReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.AccountBalance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntGetAccountsWithIDsReply} returns this
 */
proto.accountmanager.IntGetAccountsWithIDsReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AccountBalance.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AccountBalance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AccountBalance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountBalance.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
balance: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
platform: jspb.Message.getFieldWithDefault(msg, 3, ""),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
betaConnector: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AccountBalance}
 */
proto.accountmanager.AccountBalance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AccountBalance;
  return proto.accountmanager.AccountBalance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AccountBalance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AccountBalance}
 */
proto.accountmanager.AccountBalance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalance(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBetaConnector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AccountBalance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AccountBalance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AccountBalance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountBalance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getBetaConnector();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AccountBalance.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountBalance} returns this
 */
proto.accountmanager.AccountBalance.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double balance = 2;
 * @return {number}
 */
proto.accountmanager.AccountBalance.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountBalance} returns this
 */
proto.accountmanager.AccountBalance.prototype.setBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string platform = 3;
 * @return {string}
 */
proto.accountmanager.AccountBalance.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountBalance} returns this
 */
proto.accountmanager.AccountBalance.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool enabled = 4;
 * @return {boolean}
 */
proto.accountmanager.AccountBalance.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AccountBalance} returns this
 */
proto.accountmanager.AccountBalance.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool beta_connector = 5;
 * @return {boolean}
 */
proto.accountmanager.AccountBalance.prototype.getBetaConnector = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AccountBalance} returns this
 */
proto.accountmanager.AccountBalance.prototype.setBetaConnector = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntGetAccountsInfoReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetAccountsInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetAccountsInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetAccountsInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountsInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetAccountsInfoReq}
 */
proto.accountmanager.IntGetAccountsInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetAccountsInfoReq;
  return proto.accountmanager.IntGetAccountsInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetAccountsInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetAccountsInfoReq}
 */
proto.accountmanager.IntGetAccountsInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetAccountsInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetAccountsInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetAccountsInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountsInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.IntGetAccountsInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntGetAccountsInfoReq} returns this
 */
proto.accountmanager.IntGetAccountsInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string accounts = 2;
 * @return {!Array<string>}
 */
proto.accountmanager.IntGetAccountsInfoReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntGetAccountsInfoReq} returns this
 */
proto.accountmanager.IntGetAccountsInfoReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntGetAccountsInfoReq} returns this
 */
proto.accountmanager.IntGetAccountsInfoReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntGetAccountsInfoReq} returns this
 */
proto.accountmanager.IntGetAccountsInfoReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntGetAccountsInfoReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetAccountsInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetAccountsInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetAccountsInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountsInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.AccountInfoLite.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetAccountsInfoReply}
 */
proto.accountmanager.IntGetAccountsInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetAccountsInfoReply;
  return proto.accountmanager.IntGetAccountsInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetAccountsInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetAccountsInfoReply}
 */
proto.accountmanager.IntGetAccountsInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.AccountInfoLite;
      reader.readMessage(value,proto.accountmanager.AccountInfoLite.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetAccountsInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetAccountsInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetAccountsInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountsInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.AccountInfoLite.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountInfoLite accounts = 1;
 * @return {!Array<!proto.accountmanager.AccountInfoLite>}
 */
proto.accountmanager.IntGetAccountsInfoReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.AccountInfoLite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.AccountInfoLite, 1));
};


/**
 * @param {!Array<!proto.accountmanager.AccountInfoLite>} value
 * @return {!proto.accountmanager.IntGetAccountsInfoReply} returns this
*/
proto.accountmanager.IntGetAccountsInfoReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.AccountInfoLite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AccountInfoLite}
 */
proto.accountmanager.IntGetAccountsInfoReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.AccountInfoLite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntGetAccountsInfoReply} returns this
 */
proto.accountmanager.IntGetAccountsInfoReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntAdjustActiveAccountsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntAdjustActiveAccountsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntAdjustActiveAccountsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountLimit: (f = msg.getAccountLimit()) && proto.accountmanager.AccountLimit.toObject(includeInstance, f),
shouldDisableAnalyzer: (f = msg.getShouldDisableAnalyzer()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
hasPremiumSub: (f = msg.getHasPremiumSub()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntAdjustActiveAccountsReq}
 */
proto.accountmanager.IntAdjustActiveAccountsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntAdjustActiveAccountsReq;
  return proto.accountmanager.IntAdjustActiveAccountsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntAdjustActiveAccountsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntAdjustActiveAccountsReq}
 */
proto.accountmanager.IntAdjustActiveAccountsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.accountmanager.AccountLimit;
      reader.readMessage(value,proto.accountmanager.AccountLimit.deserializeBinaryFromReader);
      msg.setAccountLimit(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setShouldDisableAnalyzer(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setHasPremiumSub(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntAdjustActiveAccountsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntAdjustActiveAccountsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntAdjustActiveAccountsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountLimit();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.accountmanager.AccountLimit.serializeBinaryToWriter
    );
  }
  f = message.getShouldDisableAnalyzer();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getHasPremiumSub();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntAdjustActiveAccountsReq} returns this
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AccountLimit account_limit = 2;
 * @return {?proto.accountmanager.AccountLimit}
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.getAccountLimit = function() {
  return /** @type{?proto.accountmanager.AccountLimit} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.AccountLimit, 2));
};


/**
 * @param {?proto.accountmanager.AccountLimit|undefined} value
 * @return {!proto.accountmanager.IntAdjustActiveAccountsReq} returns this
*/
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.setAccountLimit = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.IntAdjustActiveAccountsReq} returns this
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.clearAccountLimit = function() {
  return this.setAccountLimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.hasAccountLimit = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue should_disable_analyzer = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.getShouldDisableAnalyzer = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.IntAdjustActiveAccountsReq} returns this
*/
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.setShouldDisableAnalyzer = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.IntAdjustActiveAccountsReq} returns this
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.clearShouldDisableAnalyzer = function() {
  return this.setShouldDisableAnalyzer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.hasShouldDisableAnalyzer = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue has_premium_sub = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.getHasPremiumSub = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.IntAdjustActiveAccountsReq} returns this
*/
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.setHasPremiumSub = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.IntAdjustActiveAccountsReq} returns this
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.clearHasPremiumSub = function() {
  return this.setHasPremiumSub(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.IntAdjustActiveAccountsReq.prototype.hasHasPremiumSub = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntReactivateAccountsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntReactivateAccountsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntReactivateAccountsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntReactivateAccountsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountLimit: (f = msg.getAccountLimit()) && proto.accountmanager.AccountLimit.toObject(includeInstance, f),
shouldHaveAnalyzer: (f = msg.getShouldHaveAnalyzer()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntReactivateAccountsReq}
 */
proto.accountmanager.IntReactivateAccountsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntReactivateAccountsReq;
  return proto.accountmanager.IntReactivateAccountsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntReactivateAccountsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntReactivateAccountsReq}
 */
proto.accountmanager.IntReactivateAccountsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.accountmanager.AccountLimit;
      reader.readMessage(value,proto.accountmanager.AccountLimit.deserializeBinaryFromReader);
      msg.setAccountLimit(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setShouldHaveAnalyzer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntReactivateAccountsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntReactivateAccountsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntReactivateAccountsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntReactivateAccountsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountLimit();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.accountmanager.AccountLimit.serializeBinaryToWriter
    );
  }
  f = message.getShouldHaveAnalyzer();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.IntReactivateAccountsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntReactivateAccountsReq} returns this
 */
proto.accountmanager.IntReactivateAccountsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AccountLimit account_limit = 2;
 * @return {?proto.accountmanager.AccountLimit}
 */
proto.accountmanager.IntReactivateAccountsReq.prototype.getAccountLimit = function() {
  return /** @type{?proto.accountmanager.AccountLimit} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.AccountLimit, 2));
};


/**
 * @param {?proto.accountmanager.AccountLimit|undefined} value
 * @return {!proto.accountmanager.IntReactivateAccountsReq} returns this
*/
proto.accountmanager.IntReactivateAccountsReq.prototype.setAccountLimit = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.IntReactivateAccountsReq} returns this
 */
proto.accountmanager.IntReactivateAccountsReq.prototype.clearAccountLimit = function() {
  return this.setAccountLimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.IntReactivateAccountsReq.prototype.hasAccountLimit = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue should_have_analyzer = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.IntReactivateAccountsReq.prototype.getShouldHaveAnalyzer = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.IntReactivateAccountsReq} returns this
*/
proto.accountmanager.IntReactivateAccountsReq.prototype.setShouldHaveAnalyzer = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.IntReactivateAccountsReq} returns this
 */
proto.accountmanager.IntReactivateAccountsReq.prototype.clearShouldHaveAnalyzer = function() {
  return this.setShouldHaveAnalyzer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.IntReactivateAccountsReq.prototype.hasShouldHaveAnalyzer = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntReactivateAccountsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntReactivateAccountsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntReactivateAccountsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntReactivateAccountsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntReactivateAccountsReply}
 */
proto.accountmanager.IntReactivateAccountsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntReactivateAccountsReply;
  return proto.accountmanager.IntReactivateAccountsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntReactivateAccountsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntReactivateAccountsReply}
 */
proto.accountmanager.IntReactivateAccountsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntReactivateAccountsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntReactivateAccountsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntReactivateAccountsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntReactivateAccountsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AccountLimit.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AccountLimit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AccountLimit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountLimit.toObject = function(includeInstance, msg) {
  var f, obj = {
monthly: (f = msg.getMonthly()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
yearly: (f = msg.getYearly()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
quarterly: (f = msg.getQuarterly()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
semiannually: (f = msg.getSemiannually()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AccountLimit}
 */
proto.accountmanager.AccountLimit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AccountLimit;
  return proto.accountmanager.AccountLimit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AccountLimit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AccountLimit}
 */
proto.accountmanager.AccountLimit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMonthly(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setYearly(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setQuarterly(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setSemiannually(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AccountLimit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AccountLimit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AccountLimit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountLimit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMonthly();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getYearly();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getQuarterly();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getSemiannually();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int64Value monthly = 1;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.accountmanager.AccountLimit.prototype.getMonthly = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.accountmanager.AccountLimit} returns this
*/
proto.accountmanager.AccountLimit.prototype.setMonthly = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountLimit} returns this
 */
proto.accountmanager.AccountLimit.prototype.clearMonthly = function() {
  return this.setMonthly(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountLimit.prototype.hasMonthly = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int64Value yearly = 2;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.accountmanager.AccountLimit.prototype.getYearly = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.accountmanager.AccountLimit} returns this
*/
proto.accountmanager.AccountLimit.prototype.setYearly = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountLimit} returns this
 */
proto.accountmanager.AccountLimit.prototype.clearYearly = function() {
  return this.setYearly(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountLimit.prototype.hasYearly = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int64Value quarterly = 3;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.accountmanager.AccountLimit.prototype.getQuarterly = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.accountmanager.AccountLimit} returns this
*/
proto.accountmanager.AccountLimit.prototype.setQuarterly = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountLimit} returns this
 */
proto.accountmanager.AccountLimit.prototype.clearQuarterly = function() {
  return this.setQuarterly(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountLimit.prototype.hasQuarterly = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Int64Value semiannually = 4;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.accountmanager.AccountLimit.prototype.getSemiannually = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.accountmanager.AccountLimit} returns this
*/
proto.accountmanager.AccountLimit.prototype.setSemiannually = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountLimit} returns this
 */
proto.accountmanager.AccountLimit.prototype.clearSemiannually = function() {
  return this.setSemiannually(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountLimit.prototype.hasSemiannually = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntAdjustActiveAccountsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntAdjustActiveAccountsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntAdjustActiveAccountsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntAdjustActiveAccountsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntAdjustActiveAccountsReply}
 */
proto.accountmanager.IntAdjustActiveAccountsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntAdjustActiveAccountsReply;
  return proto.accountmanager.IntAdjustActiveAccountsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntAdjustActiveAccountsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntAdjustActiveAccountsReply}
 */
proto.accountmanager.IntAdjustActiveAccountsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntAdjustActiveAccountsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntAdjustActiveAccountsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntAdjustActiveAccountsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntAdjustActiveAccountsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntConnectAccountBulkReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntConnectAccountBulkReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntConnectAccountBulkReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntConnectAccountBulkReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntConnectAccountBulkReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.AccountReconnect.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntConnectAccountBulkReq}
 */
proto.accountmanager.IntConnectAccountBulkReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntConnectAccountBulkReq;
  return proto.accountmanager.IntConnectAccountBulkReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntConnectAccountBulkReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntConnectAccountBulkReq}
 */
proto.accountmanager.IntConnectAccountBulkReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.AccountReconnect;
      reader.readMessage(value,proto.accountmanager.AccountReconnect.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntConnectAccountBulkReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntConnectAccountBulkReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntConnectAccountBulkReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntConnectAccountBulkReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.AccountReconnect.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountReconnect accounts = 1;
 * @return {!Array<!proto.accountmanager.AccountReconnect>}
 */
proto.accountmanager.IntConnectAccountBulkReq.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.AccountReconnect>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.AccountReconnect, 1));
};


/**
 * @param {!Array<!proto.accountmanager.AccountReconnect>} value
 * @return {!proto.accountmanager.IntConnectAccountBulkReq} returns this
*/
proto.accountmanager.IntConnectAccountBulkReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.AccountReconnect=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AccountReconnect}
 */
proto.accountmanager.IntConnectAccountBulkReq.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.AccountReconnect, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntConnectAccountBulkReq} returns this
 */
proto.accountmanager.IntConnectAccountBulkReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntConnectAccountBulkReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntConnectAccountBulkReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntConnectAccountBulkReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntConnectAccountBulkReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntConnectAccountBulkReply.toObject = function(includeInstance, msg) {
  var f, obj = {
failedList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntConnectAccountBulkReply}
 */
proto.accountmanager.IntConnectAccountBulkReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntConnectAccountBulkReply;
  return proto.accountmanager.IntConnectAccountBulkReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntConnectAccountBulkReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntConnectAccountBulkReply}
 */
proto.accountmanager.IntConnectAccountBulkReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFailed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntConnectAccountBulkReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntConnectAccountBulkReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntConnectAccountBulkReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntConnectAccountBulkReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string failed = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntConnectAccountBulkReply.prototype.getFailedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntConnectAccountBulkReply} returns this
 */
proto.accountmanager.IntConnectAccountBulkReply.prototype.setFailedList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntConnectAccountBulkReply} returns this
 */
proto.accountmanager.IntConnectAccountBulkReply.prototype.addFailed = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntConnectAccountBulkReply} returns this
 */
proto.accountmanager.IntConnectAccountBulkReply.prototype.clearFailedList = function() {
  return this.setFailedList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntFilterSymbolReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntFilterSymbolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntFilterSymbolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntFilterSymbolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntFilterSymbolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountSymbolsList: jspb.Message.toObjectList(msg.getAccountSymbolsList(),
    proto.accountmanager.AccountSymbol.toObject, includeInstance),
filterEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
masterSymbol: (f = msg.getMasterSymbol()) && proto.accountmanager.AccountSymbol.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntFilterSymbolReq}
 */
proto.accountmanager.IntFilterSymbolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntFilterSymbolReq;
  return proto.accountmanager.IntFilterSymbolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntFilterSymbolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntFilterSymbolReq}
 */
proto.accountmanager.IntFilterSymbolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.AccountSymbol;
      reader.readMessage(value,proto.accountmanager.AccountSymbol.deserializeBinaryFromReader);
      msg.addAccountSymbols(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilterEnabled(value);
      break;
    case 3:
      var value = new proto.accountmanager.AccountSymbol;
      reader.readMessage(value,proto.accountmanager.AccountSymbol.deserializeBinaryFromReader);
      msg.setMasterSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntFilterSymbolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntFilterSymbolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntFilterSymbolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntFilterSymbolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.AccountSymbol.serializeBinaryToWriter
    );
  }
  f = message.getFilterEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMasterSymbol();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.accountmanager.AccountSymbol.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountSymbol account_symbols = 1;
 * @return {!Array<!proto.accountmanager.AccountSymbol>}
 */
proto.accountmanager.IntFilterSymbolReq.prototype.getAccountSymbolsList = function() {
  return /** @type{!Array<!proto.accountmanager.AccountSymbol>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.AccountSymbol, 1));
};


/**
 * @param {!Array<!proto.accountmanager.AccountSymbol>} value
 * @return {!proto.accountmanager.IntFilterSymbolReq} returns this
*/
proto.accountmanager.IntFilterSymbolReq.prototype.setAccountSymbolsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.AccountSymbol=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AccountSymbol}
 */
proto.accountmanager.IntFilterSymbolReq.prototype.addAccountSymbols = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.AccountSymbol, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntFilterSymbolReq} returns this
 */
proto.accountmanager.IntFilterSymbolReq.prototype.clearAccountSymbolsList = function() {
  return this.setAccountSymbolsList([]);
};


/**
 * optional bool filter_enabled = 2;
 * @return {boolean}
 */
proto.accountmanager.IntFilterSymbolReq.prototype.getFilterEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.IntFilterSymbolReq} returns this
 */
proto.accountmanager.IntFilterSymbolReq.prototype.setFilterEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AccountSymbol master_symbol = 3;
 * @return {?proto.accountmanager.AccountSymbol}
 */
proto.accountmanager.IntFilterSymbolReq.prototype.getMasterSymbol = function() {
  return /** @type{?proto.accountmanager.AccountSymbol} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.AccountSymbol, 3));
};


/**
 * @param {?proto.accountmanager.AccountSymbol|undefined} value
 * @return {!proto.accountmanager.IntFilterSymbolReq} returns this
*/
proto.accountmanager.IntFilterSymbolReq.prototype.setMasterSymbol = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.IntFilterSymbolReq} returns this
 */
proto.accountmanager.IntFilterSymbolReq.prototype.clearMasterSymbol = function() {
  return this.setMasterSymbol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.IntFilterSymbolReq.prototype.hasMasterSymbol = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AccountSymbol.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AccountSymbol.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AccountSymbol} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountSymbol.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AccountSymbol}
 */
proto.accountmanager.AccountSymbol.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AccountSymbol;
  return proto.accountmanager.AccountSymbol.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AccountSymbol} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AccountSymbol}
 */
proto.accountmanager.AccountSymbol.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AccountSymbol.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AccountSymbol.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AccountSymbol} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountSymbol.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AccountSymbol.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountSymbol} returns this
 */
proto.accountmanager.AccountSymbol.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.accountmanager.AccountSymbol.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountSymbol} returns this
 */
proto.accountmanager.AccountSymbol.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntFilterSymbolReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntFilterSymbolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntFilterSymbolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntFilterSymbolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntFilterSymbolReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountSymbolsList: jspb.Message.toObjectList(msg.getAccountSymbolsList(),
    proto.accountmanager.AccountSymbolInfo.toObject, includeInstance),
masterSymbol: (f = msg.getMasterSymbol()) && proto.accountmanager.AccountSymbolInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntFilterSymbolReply}
 */
proto.accountmanager.IntFilterSymbolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntFilterSymbolReply;
  return proto.accountmanager.IntFilterSymbolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntFilterSymbolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntFilterSymbolReply}
 */
proto.accountmanager.IntFilterSymbolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.AccountSymbolInfo;
      reader.readMessage(value,proto.accountmanager.AccountSymbolInfo.deserializeBinaryFromReader);
      msg.addAccountSymbols(value);
      break;
    case 2:
      var value = new proto.accountmanager.AccountSymbolInfo;
      reader.readMessage(value,proto.accountmanager.AccountSymbolInfo.deserializeBinaryFromReader);
      msg.setMasterSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntFilterSymbolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntFilterSymbolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntFilterSymbolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntFilterSymbolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.AccountSymbolInfo.serializeBinaryToWriter
    );
  }
  f = message.getMasterSymbol();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.accountmanager.AccountSymbolInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountSymbolInfo account_symbols = 1;
 * @return {!Array<!proto.accountmanager.AccountSymbolInfo>}
 */
proto.accountmanager.IntFilterSymbolReply.prototype.getAccountSymbolsList = function() {
  return /** @type{!Array<!proto.accountmanager.AccountSymbolInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.AccountSymbolInfo, 1));
};


/**
 * @param {!Array<!proto.accountmanager.AccountSymbolInfo>} value
 * @return {!proto.accountmanager.IntFilterSymbolReply} returns this
*/
proto.accountmanager.IntFilterSymbolReply.prototype.setAccountSymbolsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.AccountSymbolInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AccountSymbolInfo}
 */
proto.accountmanager.IntFilterSymbolReply.prototype.addAccountSymbols = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.AccountSymbolInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntFilterSymbolReply} returns this
 */
proto.accountmanager.IntFilterSymbolReply.prototype.clearAccountSymbolsList = function() {
  return this.setAccountSymbolsList([]);
};


/**
 * optional AccountSymbolInfo master_symbol = 2;
 * @return {?proto.accountmanager.AccountSymbolInfo}
 */
proto.accountmanager.IntFilterSymbolReply.prototype.getMasterSymbol = function() {
  return /** @type{?proto.accountmanager.AccountSymbolInfo} */ (
    jspb.Message.getWrapperField(this, proto.accountmanager.AccountSymbolInfo, 2));
};


/**
 * @param {?proto.accountmanager.AccountSymbolInfo|undefined} value
 * @return {!proto.accountmanager.IntFilterSymbolReply} returns this
*/
proto.accountmanager.IntFilterSymbolReply.prototype.setMasterSymbol = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.IntFilterSymbolReply} returns this
 */
proto.accountmanager.IntFilterSymbolReply.prototype.clearMasterSymbol = function() {
  return this.setMasterSymbol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.IntFilterSymbolReply.prototype.hasMasterSymbol = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AccountSymbolInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AccountSymbolInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AccountSymbolInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountSymbolInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
minLots: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
maxLots: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
lotsStep: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
contractSize: (f = msg.getContractSize()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
profitMode: (f = msg.getProfitMode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
tickValue: (f = msg.getTickValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tickSize: (f = msg.getTickSize()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
marginCurrency: (f = msg.getMarginCurrency()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
description: (f = msg.getDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AccountSymbolInfo}
 */
proto.accountmanager.AccountSymbolInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AccountSymbolInfo;
  return proto.accountmanager.AccountSymbolInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AccountSymbolInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AccountSymbolInfo}
 */
proto.accountmanager.AccountSymbolInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinLots(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxLots(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLotsStep(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setContractSize(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfitMode(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTickValue(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTickSize(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMarginCurrency(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AccountSymbolInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AccountSymbolInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AccountSymbolInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountSymbolInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getMinLots();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMaxLots();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getLotsStep();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getContractSize();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitMode();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTickValue();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTickSize();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMarginCurrency();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool enabled = 3;
 * @return {boolean}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional double min_lots = 4;
 * @return {number}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getMinLots = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.setMinLots = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double max_lots = 5;
 * @return {number}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getMaxLots = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.setMaxLots = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double lots_step = 6;
 * @return {number}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getLotsStep = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.setLotsStep = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional google.protobuf.DoubleValue contract_size = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getContractSize = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
*/
proto.accountmanager.AccountSymbolInfo.prototype.setContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.clearContractSize = function() {
  return this.setContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountSymbolInfo.prototype.hasContractSize = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue profit_mode = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getProfitMode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
*/
proto.accountmanager.AccountSymbolInfo.prototype.setProfitMode = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.clearProfitMode = function() {
  return this.setProfitMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountSymbolInfo.prototype.hasProfitMode = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.DoubleValue tick_value = 9;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getTickValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 9));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
*/
proto.accountmanager.AccountSymbolInfo.prototype.setTickValue = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.clearTickValue = function() {
  return this.setTickValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountSymbolInfo.prototype.hasTickValue = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.DoubleValue tick_size = 10;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getTickSize = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 10));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
*/
proto.accountmanager.AccountSymbolInfo.prototype.setTickSize = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.clearTickSize = function() {
  return this.setTickSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountSymbolInfo.prototype.hasTickSize = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue margin_currency = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getMarginCurrency = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
*/
proto.accountmanager.AccountSymbolInfo.prototype.setMarginCurrency = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.clearMarginCurrency = function() {
  return this.setMarginCurrency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountSymbolInfo.prototype.hasMarginCurrency = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue description = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AccountSymbolInfo.prototype.getDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
*/
proto.accountmanager.AccountSymbolInfo.prototype.setDescription = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AccountSymbolInfo} returns this
 */
proto.accountmanager.AccountSymbolInfo.prototype.clearDescription = function() {
  return this.setDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AccountSymbolInfo.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 12) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntSyncSymbolsReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntSyncSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntSyncSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntSyncSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntSyncSymbolsReq}
 */
proto.accountmanager.IntSyncSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntSyncSymbolsReq;
  return proto.accountmanager.IntSyncSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntSyncSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntSyncSymbolsReq}
 */
proto.accountmanager.IntSyncSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntSyncSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntSyncSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntSyncSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntSyncSymbolsReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntSyncSymbolsReq} returns this
 */
proto.accountmanager.IntSyncSymbolsReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntSyncSymbolsReq} returns this
 */
proto.accountmanager.IntSyncSymbolsReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntSyncSymbolsReq} returns this
 */
proto.accountmanager.IntSyncSymbolsReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntSyncSymbolsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntSyncSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntSyncSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntSyncSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
failedList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntSyncSymbolsReply}
 */
proto.accountmanager.IntSyncSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntSyncSymbolsReply;
  return proto.accountmanager.IntSyncSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntSyncSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntSyncSymbolsReply}
 */
proto.accountmanager.IntSyncSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFailed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntSyncSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntSyncSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntSyncSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string failed = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntSyncSymbolsReply.prototype.getFailedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntSyncSymbolsReply} returns this
 */
proto.accountmanager.IntSyncSymbolsReply.prototype.setFailedList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntSyncSymbolsReply} returns this
 */
proto.accountmanager.IntSyncSymbolsReply.prototype.addFailed = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntSyncSymbolsReply} returns this
 */
proto.accountmanager.IntSyncSymbolsReply.prototype.clearFailedList = function() {
  return this.setFailedList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntSyncProxyConnectionsReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntSyncProxyConnectionsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntSyncProxyConnectionsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntSyncProxyConnectionsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncProxyConnectionsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntSyncProxyConnectionsReq}
 */
proto.accountmanager.IntSyncProxyConnectionsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntSyncProxyConnectionsReq;
  return proto.accountmanager.IntSyncProxyConnectionsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntSyncProxyConnectionsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntSyncProxyConnectionsReq}
 */
proto.accountmanager.IntSyncProxyConnectionsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntSyncProxyConnectionsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntSyncProxyConnectionsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntSyncProxyConnectionsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncProxyConnectionsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntSyncProxyConnectionsReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntSyncProxyConnectionsReq} returns this
 */
proto.accountmanager.IntSyncProxyConnectionsReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntSyncProxyConnectionsReq} returns this
 */
proto.accountmanager.IntSyncProxyConnectionsReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntSyncProxyConnectionsReq} returns this
 */
proto.accountmanager.IntSyncProxyConnectionsReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntSyncProxyConnectionsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntSyncProxyConnectionsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntSyncProxyConnectionsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncProxyConnectionsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntSyncProxyConnectionsReply}
 */
proto.accountmanager.IntSyncProxyConnectionsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntSyncProxyConnectionsReply;
  return proto.accountmanager.IntSyncProxyConnectionsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntSyncProxyConnectionsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntSyncProxyConnectionsReply}
 */
proto.accountmanager.IntSyncProxyConnectionsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntSyncProxyConnectionsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntSyncProxyConnectionsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntSyncProxyConnectionsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncProxyConnectionsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntGetAccountCurrenciesReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetAccountCurrenciesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetAccountCurrenciesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetAccountCurrenciesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountCurrenciesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetAccountCurrenciesReq}
 */
proto.accountmanager.IntGetAccountCurrenciesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetAccountCurrenciesReq;
  return proto.accountmanager.IntGetAccountCurrenciesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetAccountCurrenciesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetAccountCurrenciesReq}
 */
proto.accountmanager.IntGetAccountCurrenciesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetAccountCurrenciesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetAccountCurrenciesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetAccountCurrenciesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountCurrenciesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntGetAccountCurrenciesReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntGetAccountCurrenciesReq} returns this
 */
proto.accountmanager.IntGetAccountCurrenciesReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntGetAccountCurrenciesReq} returns this
 */
proto.accountmanager.IntGetAccountCurrenciesReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntGetAccountCurrenciesReq} returns this
 */
proto.accountmanager.IntGetAccountCurrenciesReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntGetAccountCurrenciesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetAccountCurrenciesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetAccountCurrenciesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetAccountCurrenciesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountCurrenciesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountCurrenciesList: jspb.Message.toObjectList(msg.getAccountCurrenciesList(),
    proto.accountmanager.AccountCurrency.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetAccountCurrenciesReply}
 */
proto.accountmanager.IntGetAccountCurrenciesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetAccountCurrenciesReply;
  return proto.accountmanager.IntGetAccountCurrenciesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetAccountCurrenciesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetAccountCurrenciesReply}
 */
proto.accountmanager.IntGetAccountCurrenciesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.AccountCurrency;
      reader.readMessage(value,proto.accountmanager.AccountCurrency.deserializeBinaryFromReader);
      msg.addAccountCurrencies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetAccountCurrenciesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetAccountCurrenciesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetAccountCurrenciesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountCurrenciesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountCurrenciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.AccountCurrency.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountCurrency account_currencies = 1;
 * @return {!Array<!proto.accountmanager.AccountCurrency>}
 */
proto.accountmanager.IntGetAccountCurrenciesReply.prototype.getAccountCurrenciesList = function() {
  return /** @type{!Array<!proto.accountmanager.AccountCurrency>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.AccountCurrency, 1));
};


/**
 * @param {!Array<!proto.accountmanager.AccountCurrency>} value
 * @return {!proto.accountmanager.IntGetAccountCurrenciesReply} returns this
*/
proto.accountmanager.IntGetAccountCurrenciesReply.prototype.setAccountCurrenciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.AccountCurrency=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AccountCurrency}
 */
proto.accountmanager.IntGetAccountCurrenciesReply.prototype.addAccountCurrencies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.AccountCurrency, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntGetAccountCurrenciesReply} returns this
 */
proto.accountmanager.IntGetAccountCurrenciesReply.prototype.clearAccountCurrenciesList = function() {
  return this.setAccountCurrenciesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AccountCurrency.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AccountCurrency.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AccountCurrency} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountCurrency.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
currency: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AccountCurrency}
 */
proto.accountmanager.AccountCurrency.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AccountCurrency;
  return proto.accountmanager.AccountCurrency.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AccountCurrency} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AccountCurrency}
 */
proto.accountmanager.AccountCurrency.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AccountCurrency.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AccountCurrency.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AccountCurrency} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountCurrency.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AccountCurrency.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountCurrency} returns this
 */
proto.accountmanager.AccountCurrency.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.accountmanager.AccountCurrency.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountCurrency} returns this
 */
proto.accountmanager.AccountCurrency.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntSyncCurrencyReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntSyncCurrencyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntSyncCurrencyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntSyncCurrencyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncCurrencyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntSyncCurrencyReq}
 */
proto.accountmanager.IntSyncCurrencyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntSyncCurrencyReq;
  return proto.accountmanager.IntSyncCurrencyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntSyncCurrencyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntSyncCurrencyReq}
 */
proto.accountmanager.IntSyncCurrencyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntSyncCurrencyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntSyncCurrencyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntSyncCurrencyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncCurrencyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntSyncCurrencyReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntSyncCurrencyReq} returns this
 */
proto.accountmanager.IntSyncCurrencyReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntSyncCurrencyReq} returns this
 */
proto.accountmanager.IntSyncCurrencyReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntSyncCurrencyReq} returns this
 */
proto.accountmanager.IntSyncCurrencyReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntSyncCurrencyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntSyncCurrencyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntSyncCurrencyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncCurrencyReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntSyncCurrencyReply}
 */
proto.accountmanager.IntSyncCurrencyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntSyncCurrencyReply;
  return proto.accountmanager.IntSyncCurrencyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntSyncCurrencyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntSyncCurrencyReply}
 */
proto.accountmanager.IntSyncCurrencyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntSyncCurrencyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntSyncCurrencyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntSyncCurrencyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSyncCurrencyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntCheckAllSymbolMappedReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntCheckAllSymbolMappedReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
existingMappingsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntCheckAllSymbolMappedReq}
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntCheckAllSymbolMappedReq;
  return proto.accountmanager.IntCheckAllSymbolMappedReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntCheckAllSymbolMappedReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntCheckAllSymbolMappedReq}
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addExistingMappings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntCheckAllSymbolMappedReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntCheckAllSymbolMappedReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExistingMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntCheckAllSymbolMappedReq} returns this
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntCheckAllSymbolMappedReq} returns this
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string existing_mappings = 3;
 * @return {!Array<string>}
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.prototype.getExistingMappingsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntCheckAllSymbolMappedReq} returns this
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.prototype.setExistingMappingsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntCheckAllSymbolMappedReq} returns this
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.prototype.addExistingMappings = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntCheckAllSymbolMappedReq} returns this
 */
proto.accountmanager.IntCheckAllSymbolMappedReq.prototype.clearExistingMappingsList = function() {
  return this.setExistingMappingsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntCheckAllSymbolMappedReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntCheckAllSymbolMappedReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntCheckAllSymbolMappedReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntCheckAllSymbolMappedReply.toObject = function(includeInstance, msg) {
  var f, obj = {
allMapped: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntCheckAllSymbolMappedReply}
 */
proto.accountmanager.IntCheckAllSymbolMappedReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntCheckAllSymbolMappedReply;
  return proto.accountmanager.IntCheckAllSymbolMappedReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntCheckAllSymbolMappedReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntCheckAllSymbolMappedReply}
 */
proto.accountmanager.IntCheckAllSymbolMappedReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllMapped(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntCheckAllSymbolMappedReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntCheckAllSymbolMappedReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntCheckAllSymbolMappedReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntCheckAllSymbolMappedReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllMapped();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool all_mapped = 1;
 * @return {boolean}
 */
proto.accountmanager.IntCheckAllSymbolMappedReply.prototype.getAllMapped = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.IntCheckAllSymbolMappedReply} returns this
 */
proto.accountmanager.IntCheckAllSymbolMappedReply.prototype.setAllMapped = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntEnableAccountsReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntEnableAccountsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntEnableAccountsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntEnableAccountsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntEnableAccountsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntEnableAccountsReq}
 */
proto.accountmanager.IntEnableAccountsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntEnableAccountsReq;
  return proto.accountmanager.IntEnableAccountsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntEnableAccountsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntEnableAccountsReq}
 */
proto.accountmanager.IntEnableAccountsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntEnableAccountsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntEnableAccountsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntEnableAccountsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntEnableAccountsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntEnableAccountsReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntEnableAccountsReq} returns this
 */
proto.accountmanager.IntEnableAccountsReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntEnableAccountsReq} returns this
 */
proto.accountmanager.IntEnableAccountsReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntEnableAccountsReq} returns this
 */
proto.accountmanager.IntEnableAccountsReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntEnableAccountsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntEnableAccountsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntEnableAccountsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntEnableAccountsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntEnableAccountsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
failedList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntEnableAccountsReply}
 */
proto.accountmanager.IntEnableAccountsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntEnableAccountsReply;
  return proto.accountmanager.IntEnableAccountsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntEnableAccountsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntEnableAccountsReply}
 */
proto.accountmanager.IntEnableAccountsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFailed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntEnableAccountsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntEnableAccountsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntEnableAccountsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntEnableAccountsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string failed = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntEnableAccountsReply.prototype.getFailedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntEnableAccountsReply} returns this
 */
proto.accountmanager.IntEnableAccountsReply.prototype.setFailedList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntEnableAccountsReply} returns this
 */
proto.accountmanager.IntEnableAccountsReply.prototype.addFailed = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntEnableAccountsReply} returns this
 */
proto.accountmanager.IntEnableAccountsReply.prototype.clearFailedList = function() {
  return this.setFailedList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntUserActiveAccountsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntUserActiveAccountsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntUserActiveAccountsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUserActiveAccountsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntUserActiveAccountsReq}
 */
proto.accountmanager.IntUserActiveAccountsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntUserActiveAccountsReq;
  return proto.accountmanager.IntUserActiveAccountsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntUserActiveAccountsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntUserActiveAccountsReq}
 */
proto.accountmanager.IntUserActiveAccountsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntUserActiveAccountsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntUserActiveAccountsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntUserActiveAccountsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUserActiveAccountsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.IntUserActiveAccountsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntUserActiveAccountsReq} returns this
 */
proto.accountmanager.IntUserActiveAccountsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntUserActiveAccountsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntUserActiveAccountsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntUserActiveAccountsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntUserActiveAccountsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUserActiveAccountsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntUserActiveAccountsReply}
 */
proto.accountmanager.IntUserActiveAccountsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntUserActiveAccountsReply;
  return proto.accountmanager.IntUserActiveAccountsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntUserActiveAccountsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntUserActiveAccountsReply}
 */
proto.accountmanager.IntUserActiveAccountsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccountIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntUserActiveAccountsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntUserActiveAccountsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntUserActiveAccountsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUserActiveAccountsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string account_ids = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntUserActiveAccountsReply.prototype.getAccountIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntUserActiveAccountsReply} returns this
 */
proto.accountmanager.IntUserActiveAccountsReply.prototype.setAccountIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntUserActiveAccountsReply} returns this
 */
proto.accountmanager.IntUserActiveAccountsReply.prototype.addAccountIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntUserActiveAccountsReply} returns this
 */
proto.accountmanager.IntUserActiveAccountsReply.prototype.clearAccountIdsList = function() {
  return this.setAccountIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntGetAccountDetailsReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetAccountDetailsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetAccountDetailsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetAccountDetailsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountDetailsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetAccountDetailsReq}
 */
proto.accountmanager.IntGetAccountDetailsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetAccountDetailsReq;
  return proto.accountmanager.IntGetAccountDetailsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetAccountDetailsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetAccountDetailsReq}
 */
proto.accountmanager.IntGetAccountDetailsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetAccountDetailsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetAccountDetailsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetAccountDetailsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountDetailsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntGetAccountDetailsReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntGetAccountDetailsReq} returns this
 */
proto.accountmanager.IntGetAccountDetailsReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntGetAccountDetailsReq} returns this
 */
proto.accountmanager.IntGetAccountDetailsReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntGetAccountDetailsReq} returns this
 */
proto.accountmanager.IntGetAccountDetailsReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntGetAccountDetailsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntGetAccountDetailsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntGetAccountDetailsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntGetAccountDetailsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountDetailsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.AccountDetails.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntGetAccountDetailsReply}
 */
proto.accountmanager.IntGetAccountDetailsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntGetAccountDetailsReply;
  return proto.accountmanager.IntGetAccountDetailsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntGetAccountDetailsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntGetAccountDetailsReply}
 */
proto.accountmanager.IntGetAccountDetailsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.AccountDetails;
      reader.readMessage(value,proto.accountmanager.AccountDetails.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntGetAccountDetailsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntGetAccountDetailsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntGetAccountDetailsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntGetAccountDetailsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.AccountDetails.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountDetails accounts = 1;
 * @return {!Array<!proto.accountmanager.AccountDetails>}
 */
proto.accountmanager.IntGetAccountDetailsReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.AccountDetails>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.AccountDetails, 1));
};


/**
 * @param {!Array<!proto.accountmanager.AccountDetails>} value
 * @return {!proto.accountmanager.IntGetAccountDetailsReply} returns this
*/
proto.accountmanager.IntGetAccountDetailsReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.AccountDetails=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AccountDetails}
 */
proto.accountmanager.IntGetAccountDetailsReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.AccountDetails, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntGetAccountDetailsReply} returns this
 */
proto.accountmanager.IntGetAccountDetailsReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AccountDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AccountDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AccountDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
currency: jspb.Message.getFieldWithDefault(msg, 2, ""),
platform: jspb.Message.getFieldWithDefault(msg, 3, ""),
serverTimeZone: jspb.Message.getFieldWithDefault(msg, 4, 0),
serverId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AccountDetails}
 */
proto.accountmanager.AccountDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AccountDetails;
  return proto.accountmanager.AccountDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AccountDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AccountDetails}
 */
proto.accountmanager.AccountDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServerTimeZone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AccountDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AccountDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AccountDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getServerTimeZone();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AccountDetails.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountDetails} returns this
 */
proto.accountmanager.AccountDetails.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.accountmanager.AccountDetails.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountDetails} returns this
 */
proto.accountmanager.AccountDetails.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string platform = 3;
 * @return {string}
 */
proto.accountmanager.AccountDetails.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountDetails} returns this
 */
proto.accountmanager.AccountDetails.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 server_time_zone = 4;
 * @return {number}
 */
proto.accountmanager.AccountDetails.prototype.getServerTimeZone = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountDetails} returns this
 */
proto.accountmanager.AccountDetails.prototype.setServerTimeZone = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string server_id = 5;
 * @return {string}
 */
proto.accountmanager.AccountDetails.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountDetails} returns this
 */
proto.accountmanager.AccountDetails.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.SymbolStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.SymbolStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.SymbolStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveAccount: jspb.Message.getFieldWithDefault(msg, 3, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.SymbolStatsReq}
 */
proto.accountmanager.SymbolStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.SymbolStatsReq;
  return proto.accountmanager.SymbolStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.SymbolStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.SymbolStatsReq}
 */
proto.accountmanager.SymbolStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveAccount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.SymbolStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.SymbolStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.SymbolStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveAccount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.SymbolStatsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SymbolStatsReq} returns this
 */
proto.accountmanager.SymbolStatsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.accountmanager.SymbolStatsReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SymbolStatsReq} returns this
 */
proto.accountmanager.SymbolStatsReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_account = 3;
 * @return {string}
 */
proto.accountmanager.SymbolStatsReq.prototype.getSlaveAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SymbolStatsReq} returns this
 */
proto.accountmanager.SymbolStatsReq.prototype.setSlaveAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string slave_id = 4;
 * @return {string}
 */
proto.accountmanager.SymbolStatsReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SymbolStatsReq} returns this
 */
proto.accountmanager.SymbolStatsReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.SymbolStatsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.SymbolStatsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.SymbolStatsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolStatsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
masterSymbolCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
slaveSymbolCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
unmappedCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
mappedCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.SymbolStatsReply}
 */
proto.accountmanager.SymbolStatsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.SymbolStatsReply;
  return proto.accountmanager.SymbolStatsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.SymbolStatsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.SymbolStatsReply}
 */
proto.accountmanager.SymbolStatsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMasterSymbolCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSlaveSymbolCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnmappedCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMappedCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.SymbolStatsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.SymbolStatsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.SymbolStatsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolStatsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMasterSymbolCount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSlaveSymbolCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUnmappedCount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMappedCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int64 master_symbol_count = 1;
 * @return {number}
 */
proto.accountmanager.SymbolStatsReply.prototype.getMasterSymbolCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.SymbolStatsReply} returns this
 */
proto.accountmanager.SymbolStatsReply.prototype.setMasterSymbolCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 slave_symbol_count = 2;
 * @return {number}
 */
proto.accountmanager.SymbolStatsReply.prototype.getSlaveSymbolCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.SymbolStatsReply} returns this
 */
proto.accountmanager.SymbolStatsReply.prototype.setSlaveSymbolCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 unmapped_count = 3;
 * @return {number}
 */
proto.accountmanager.SymbolStatsReply.prototype.getUnmappedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.SymbolStatsReply} returns this
 */
proto.accountmanager.SymbolStatsReply.prototype.setUnmappedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 mapped_count = 4;
 * @return {number}
 */
proto.accountmanager.SymbolStatsReply.prototype.getMappedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.SymbolStatsReply} returns this
 */
proto.accountmanager.SymbolStatsReply.prototype.setMappedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UnmappedSymbolListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UnmappedSymbolListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UnmappedSymbolListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 3, ""),
group: jspb.Message.getFieldWithDefault(msg, 4, ""),
query: jspb.Message.getFieldWithDefault(msg, 5, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 6, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UnmappedSymbolListReq}
 */
proto.accountmanager.UnmappedSymbolListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UnmappedSymbolListReq;
  return proto.accountmanager.UnmappedSymbolListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UnmappedSymbolListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UnmappedSymbolListReq}
 */
proto.accountmanager.UnmappedSymbolListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroup(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UnmappedSymbolListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UnmappedSymbolListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UnmappedSymbolListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGroup();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UnmappedSymbolListReq} returns this
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UnmappedSymbolListReq} returns this
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_id = 3;
 * @return {string}
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UnmappedSymbolListReq} returns this
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string group = 4;
 * @return {string}
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.getGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UnmappedSymbolListReq} returns this
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.setGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string query = 5;
 * @return {string}
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UnmappedSymbolListReq} returns this
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string pagination_cursor = 6;
 * @return {string}
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UnmappedSymbolListReq} returns this
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint32 page_size = 7;
 * @return {number}
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.UnmappedSymbolListReq} returns this
 */
proto.accountmanager.UnmappedSymbolListReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.UnmappedSymbolListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UnmappedSymbolListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UnmappedSymbolListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UnmappedSymbolListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UnmappedSymbolListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
symbolsList: jspb.Message.toObjectList(msg.getSymbolsList(),
    proto.accountmanager.UnmappedSymbol.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UnmappedSymbolListReply}
 */
proto.accountmanager.UnmappedSymbolListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UnmappedSymbolListReply;
  return proto.accountmanager.UnmappedSymbolListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UnmappedSymbolListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UnmappedSymbolListReply}
 */
proto.accountmanager.UnmappedSymbolListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.UnmappedSymbol;
      reader.readMessage(value,proto.accountmanager.UnmappedSymbol.deserializeBinaryFromReader);
      msg.addSymbols(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UnmappedSymbolListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UnmappedSymbolListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UnmappedSymbolListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UnmappedSymbolListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.UnmappedSymbol.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated UnmappedSymbol symbols = 1;
 * @return {!Array<!proto.accountmanager.UnmappedSymbol>}
 */
proto.accountmanager.UnmappedSymbolListReply.prototype.getSymbolsList = function() {
  return /** @type{!Array<!proto.accountmanager.UnmappedSymbol>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.UnmappedSymbol, 1));
};


/**
 * @param {!Array<!proto.accountmanager.UnmappedSymbol>} value
 * @return {!proto.accountmanager.UnmappedSymbolListReply} returns this
*/
proto.accountmanager.UnmappedSymbolListReply.prototype.setSymbolsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.UnmappedSymbol=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.UnmappedSymbol}
 */
proto.accountmanager.UnmappedSymbolListReply.prototype.addSymbols = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.UnmappedSymbol, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.UnmappedSymbolListReply} returns this
 */
proto.accountmanager.UnmappedSymbolListReply.prototype.clearSymbolsList = function() {
  return this.setSymbolsList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.accountmanager.UnmappedSymbolListReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UnmappedSymbolListReply} returns this
 */
proto.accountmanager.UnmappedSymbolListReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.UnmappedSymbolListReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.UnmappedSymbolListReply} returns this
 */
proto.accountmanager.UnmappedSymbolListReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.accountmanager.UnmappedSymbolListReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.UnmappedSymbolListReply} returns this
 */
proto.accountmanager.UnmappedSymbolListReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UnmappedSymbol.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UnmappedSymbol.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UnmappedSymbol} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UnmappedSymbol.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: (f = msg.getDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UnmappedSymbol}
 */
proto.accountmanager.UnmappedSymbol.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UnmappedSymbol;
  return proto.accountmanager.UnmappedSymbol.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UnmappedSymbol} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UnmappedSymbol}
 */
proto.accountmanager.UnmappedSymbol.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UnmappedSymbol.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UnmappedSymbol.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UnmappedSymbol} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UnmappedSymbol.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.accountmanager.UnmappedSymbol.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.UnmappedSymbol} returns this
 */
proto.accountmanager.UnmappedSymbol.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.accountmanager.UnmappedSymbol.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UnmappedSymbol} returns this
 */
proto.accountmanager.UnmappedSymbol.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue description = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.UnmappedSymbol.prototype.getDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.UnmappedSymbol} returns this
*/
proto.accountmanager.UnmappedSymbol.prototype.setDescription = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UnmappedSymbol} returns this
 */
proto.accountmanager.UnmappedSymbol.prototype.clearDescription = function() {
  return this.setDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UnmappedSymbol.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AutoMapSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AutoMapSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AutoMapSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveAccount: jspb.Message.getFieldWithDefault(msg, 3, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 4, ""),
pattern: jspb.Message.getFieldWithDefault(msg, 5, ""),
overwriteExisting: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AutoMapSymbolsReq}
 */
proto.accountmanager.AutoMapSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AutoMapSymbolsReq;
  return proto.accountmanager.AutoMapSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AutoMapSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AutoMapSymbolsReq}
 */
proto.accountmanager.AutoMapSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveAccount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPattern(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverwriteExisting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AutoMapSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AutoMapSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AutoMapSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveAccount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPattern();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOverwriteExisting();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AutoMapSymbolsReq} returns this
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AutoMapSymbolsReq} returns this
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_account = 3;
 * @return {string}
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.getSlaveAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AutoMapSymbolsReq} returns this
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.setSlaveAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string slave_id = 4;
 * @return {string}
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AutoMapSymbolsReq} returns this
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string pattern = 5;
 * @return {string}
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.getPattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AutoMapSymbolsReq} returns this
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.setPattern = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool overwrite_existing = 6;
 * @return {boolean}
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.getOverwriteExisting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AutoMapSymbolsReq} returns this
 */
proto.accountmanager.AutoMapSymbolsReq.prototype.setOverwriteExisting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AutoMapSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AutoMapSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AutoMapSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AutoMapSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AutoMapSymbolsReply}
 */
proto.accountmanager.AutoMapSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AutoMapSymbolsReply;
  return proto.accountmanager.AutoMapSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AutoMapSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AutoMapSymbolsReply}
 */
proto.accountmanager.AutoMapSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AutoMapSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AutoMapSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AutoMapSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AutoMapSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.MappedSymbolListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.MappedSymbolListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.MappedSymbolListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MappedSymbolListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 3, ""),
group: jspb.Message.getFieldWithDefault(msg, 4, ""),
query: jspb.Message.getFieldWithDefault(msg, 5, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 6, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.MappedSymbolListReq}
 */
proto.accountmanager.MappedSymbolListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.MappedSymbolListReq;
  return proto.accountmanager.MappedSymbolListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.MappedSymbolListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.MappedSymbolListReq}
 */
proto.accountmanager.MappedSymbolListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroup(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.MappedSymbolListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.MappedSymbolListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.MappedSymbolListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MappedSymbolListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGroup();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.MappedSymbolListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MappedSymbolListReq} returns this
 */
proto.accountmanager.MappedSymbolListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.accountmanager.MappedSymbolListReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MappedSymbolListReq} returns this
 */
proto.accountmanager.MappedSymbolListReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_id = 3;
 * @return {string}
 */
proto.accountmanager.MappedSymbolListReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MappedSymbolListReq} returns this
 */
proto.accountmanager.MappedSymbolListReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string group = 4;
 * @return {string}
 */
proto.accountmanager.MappedSymbolListReq.prototype.getGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MappedSymbolListReq} returns this
 */
proto.accountmanager.MappedSymbolListReq.prototype.setGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string query = 5;
 * @return {string}
 */
proto.accountmanager.MappedSymbolListReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MappedSymbolListReq} returns this
 */
proto.accountmanager.MappedSymbolListReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string pagination_cursor = 6;
 * @return {string}
 */
proto.accountmanager.MappedSymbolListReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MappedSymbolListReq} returns this
 */
proto.accountmanager.MappedSymbolListReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint32 page_size = 7;
 * @return {number}
 */
proto.accountmanager.MappedSymbolListReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.MappedSymbolListReq} returns this
 */
proto.accountmanager.MappedSymbolListReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.MappedSymbolListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.MappedSymbolListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.MappedSymbolListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.MappedSymbolListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MappedSymbolListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
symbolsList: jspb.Message.toObjectList(msg.getSymbolsList(),
    proto.accountmanager.MappedSymbol.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.MappedSymbolListReply}
 */
proto.accountmanager.MappedSymbolListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.MappedSymbolListReply;
  return proto.accountmanager.MappedSymbolListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.MappedSymbolListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.MappedSymbolListReply}
 */
proto.accountmanager.MappedSymbolListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.MappedSymbol;
      reader.readMessage(value,proto.accountmanager.MappedSymbol.deserializeBinaryFromReader);
      msg.addSymbols(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.MappedSymbolListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.MappedSymbolListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.MappedSymbolListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MappedSymbolListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.MappedSymbol.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated MappedSymbol symbols = 1;
 * @return {!Array<!proto.accountmanager.MappedSymbol>}
 */
proto.accountmanager.MappedSymbolListReply.prototype.getSymbolsList = function() {
  return /** @type{!Array<!proto.accountmanager.MappedSymbol>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.MappedSymbol, 1));
};


/**
 * @param {!Array<!proto.accountmanager.MappedSymbol>} value
 * @return {!proto.accountmanager.MappedSymbolListReply} returns this
*/
proto.accountmanager.MappedSymbolListReply.prototype.setSymbolsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.MappedSymbol=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.MappedSymbol}
 */
proto.accountmanager.MappedSymbolListReply.prototype.addSymbols = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.MappedSymbol, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.MappedSymbolListReply} returns this
 */
proto.accountmanager.MappedSymbolListReply.prototype.clearSymbolsList = function() {
  return this.setSymbolsList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.accountmanager.MappedSymbolListReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MappedSymbolListReply} returns this
 */
proto.accountmanager.MappedSymbolListReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.MappedSymbolListReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.MappedSymbolListReply} returns this
 */
proto.accountmanager.MappedSymbolListReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.accountmanager.MappedSymbolListReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.MappedSymbolListReply} returns this
 */
proto.accountmanager.MappedSymbolListReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.MappedSymbol.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.MappedSymbol.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.MappedSymbol} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MappedSymbol.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
master: jspb.Message.getFieldWithDefault(msg, 3, ""),
mappingId: jspb.Message.getFieldWithDefault(msg, 4, 0),
description: (f = msg.getDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.MappedSymbol}
 */
proto.accountmanager.MappedSymbol.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.MappedSymbol;
  return proto.accountmanager.MappedSymbol.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.MappedSymbol} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.MappedSymbol}
 */
proto.accountmanager.MappedSymbol.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaster(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMappingId(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.MappedSymbol.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.MappedSymbol.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.MappedSymbol} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.MappedSymbol.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMaster();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMappingId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.accountmanager.MappedSymbol.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.MappedSymbol} returns this
 */
proto.accountmanager.MappedSymbol.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.accountmanager.MappedSymbol.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MappedSymbol} returns this
 */
proto.accountmanager.MappedSymbol.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string master = 3;
 * @return {string}
 */
proto.accountmanager.MappedSymbol.prototype.getMaster = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.MappedSymbol} returns this
 */
proto.accountmanager.MappedSymbol.prototype.setMaster = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 mapping_id = 4;
 * @return {number}
 */
proto.accountmanager.MappedSymbol.prototype.getMappingId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.MappedSymbol} returns this
 */
proto.accountmanager.MappedSymbol.prototype.setMappingId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue description = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.MappedSymbol.prototype.getDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.MappedSymbol} returns this
*/
proto.accountmanager.MappedSymbol.prototype.setDescription = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.MappedSymbol} returns this
 */
proto.accountmanager.MappedSymbol.prototype.clearDescription = function() {
  return this.setDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.MappedSymbol.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GroupListReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GroupListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GroupListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GroupListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GroupListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GroupListReq}
 */
proto.accountmanager.GroupListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GroupListReq;
  return proto.accountmanager.GroupListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GroupListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GroupListReq}
 */
proto.accountmanager.GroupListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GroupListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GroupListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GroupListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GroupListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GroupListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GroupListReq} returns this
 */
proto.accountmanager.GroupListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string accounts = 2;
 * @return {!Array<string>}
 */
proto.accountmanager.GroupListReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.GroupListReq} returns this
 */
proto.accountmanager.GroupListReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.GroupListReq} returns this
 */
proto.accountmanager.GroupListReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GroupListReq} returns this
 */
proto.accountmanager.GroupListReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GroupListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GroupListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GroupListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GroupListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GroupListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
groupsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GroupListReply}
 */
proto.accountmanager.GroupListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GroupListReply;
  return proto.accountmanager.GroupListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GroupListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GroupListReply}
 */
proto.accountmanager.GroupListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GroupListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GroupListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GroupListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GroupListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string groups = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.GroupListReply.prototype.getGroupsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.GroupListReply} returns this
 */
proto.accountmanager.GroupListReply.prototype.setGroupsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.GroupListReply} returns this
 */
proto.accountmanager.GroupListReply.prototype.addGroups = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GroupListReply} returns this
 */
proto.accountmanager.GroupListReply.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntUpdateSymbolInfoReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntUpdateSymbolInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntUpdateSymbolInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntUpdateSymbolInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUpdateSymbolInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntUpdateSymbolInfoReq}
 */
proto.accountmanager.IntUpdateSymbolInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntUpdateSymbolInfoReq;
  return proto.accountmanager.IntUpdateSymbolInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntUpdateSymbolInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntUpdateSymbolInfoReq}
 */
proto.accountmanager.IntUpdateSymbolInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntUpdateSymbolInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntUpdateSymbolInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntUpdateSymbolInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUpdateSymbolInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntUpdateSymbolInfoReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntUpdateSymbolInfoReq} returns this
 */
proto.accountmanager.IntUpdateSymbolInfoReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntUpdateSymbolInfoReq} returns this
 */
proto.accountmanager.IntUpdateSymbolInfoReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntUpdateSymbolInfoReq} returns this
 */
proto.accountmanager.IntUpdateSymbolInfoReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntUpdateSymbolInfoReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntUpdateSymbolInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntUpdateSymbolInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntUpdateSymbolInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUpdateSymbolInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
failedList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntUpdateSymbolInfoReply}
 */
proto.accountmanager.IntUpdateSymbolInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntUpdateSymbolInfoReply;
  return proto.accountmanager.IntUpdateSymbolInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntUpdateSymbolInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntUpdateSymbolInfoReply}
 */
proto.accountmanager.IntUpdateSymbolInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFailed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntUpdateSymbolInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntUpdateSymbolInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntUpdateSymbolInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntUpdateSymbolInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string failed = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntUpdateSymbolInfoReply.prototype.getFailedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntUpdateSymbolInfoReply} returns this
 */
proto.accountmanager.IntUpdateSymbolInfoReply.prototype.setFailedList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntUpdateSymbolInfoReply} returns this
 */
proto.accountmanager.IntUpdateSymbolInfoReply.prototype.addFailed = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntUpdateSymbolInfoReply} returns this
 */
proto.accountmanager.IntUpdateSymbolInfoReply.prototype.clearFailedList = function() {
  return this.setFailedList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddSymbolOverrideReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddSymbolOverrideReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddSymbolOverrideReq.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 2, ""),
lotsStep: (f = msg.getLotsStep()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
contractSize: (f = msg.getContractSize()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tickValue: (f = msg.getTickValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tickSize: (f = msg.getTickSize()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
profitMode: (f = msg.getProfitMode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
tradeMode: (f = msg.getTradeMode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddSymbolOverrideReq;
  return proto.accountmanager.AdminAddSymbolOverrideReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddSymbolOverrideReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotsStep(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setContractSize(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTickValue(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTickSize(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfitMode(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTradeMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddSymbolOverrideReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddSymbolOverrideReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddSymbolOverrideReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLotsStep();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getContractSize();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTickValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTickSize();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitMode();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTradeMode();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string server_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.DoubleValue lots_step = 3;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.getLotsStep = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 3));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.setLotsStep = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.clearLotsStep = function() {
  return this.setLotsStep(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.hasLotsStep = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.DoubleValue contract_size = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.getContractSize = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.setContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.clearContractSize = function() {
  return this.setContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.hasContractSize = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue tick_value = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.getTickValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.setTickValue = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.clearTickValue = function() {
  return this.setTickValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.hasTickValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue tick_size = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.getTickSize = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.setTickSize = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.clearTickSize = function() {
  return this.setTickSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.hasTickSize = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue profit_mode = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.getProfitMode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.setProfitMode = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.clearProfitMode = function() {
  return this.setProfitMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.hasProfitMode = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue trade_mode = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.getTradeMode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.setTradeMode = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.clearTradeMode = function() {
  return this.setTradeMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminAddSymbolOverrideReq.prototype.hasTradeMode = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddSymbolOverrideReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddSymbolOverrideReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddSymbolOverrideReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddSymbolOverrideReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReply}
 */
proto.accountmanager.AdminAddSymbolOverrideReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddSymbolOverrideReply;
  return proto.accountmanager.AdminAddSymbolOverrideReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddSymbolOverrideReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddSymbolOverrideReply}
 */
proto.accountmanager.AdminAddSymbolOverrideReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddSymbolOverrideReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddSymbolOverrideReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddSymbolOverrideReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddSymbolOverrideReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminListSymbolOverridesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminListSymbolOverridesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminListSymbolOverridesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListSymbolOverridesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
query: jspb.Message.getFieldWithDefault(msg, 1, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 2, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 3, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminListSymbolOverridesReq}
 */
proto.accountmanager.AdminListSymbolOverridesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminListSymbolOverridesReq;
  return proto.accountmanager.AdminListSymbolOverridesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminListSymbolOverridesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminListSymbolOverridesReq}
 */
proto.accountmanager.AdminListSymbolOverridesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminListSymbolOverridesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminListSymbolOverridesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminListSymbolOverridesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListSymbolOverridesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.accountmanager.AdminListSymbolOverridesReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListSymbolOverridesReq} returns this
 */
proto.accountmanager.AdminListSymbolOverridesReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string server_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminListSymbolOverridesReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListSymbolOverridesReq} returns this
 */
proto.accountmanager.AdminListSymbolOverridesReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string pagination_cursor = 3;
 * @return {string}
 */
proto.accountmanager.AdminListSymbolOverridesReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListSymbolOverridesReq} returns this
 */
proto.accountmanager.AdminListSymbolOverridesReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 page_size = 4;
 * @return {number}
 */
proto.accountmanager.AdminListSymbolOverridesReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListSymbolOverridesReq} returns this
 */
proto.accountmanager.AdminListSymbolOverridesReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminListSymbolOverridesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminListSymbolOverridesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminListSymbolOverridesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminListSymbolOverridesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListSymbolOverridesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
symbolOverridesList: jspb.Message.toObjectList(msg.getSymbolOverridesList(),
    proto.accountmanager.SymbolOverride.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminListSymbolOverridesReply}
 */
proto.accountmanager.AdminListSymbolOverridesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminListSymbolOverridesReply;
  return proto.accountmanager.AdminListSymbolOverridesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminListSymbolOverridesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminListSymbolOverridesReply}
 */
proto.accountmanager.AdminListSymbolOverridesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.SymbolOverride;
      reader.readMessage(value,proto.accountmanager.SymbolOverride.deserializeBinaryFromReader);
      msg.addSymbolOverrides(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminListSymbolOverridesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminListSymbolOverridesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminListSymbolOverridesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListSymbolOverridesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolOverridesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.SymbolOverride.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated SymbolOverride symbol_overrides = 1;
 * @return {!Array<!proto.accountmanager.SymbolOverride>}
 */
proto.accountmanager.AdminListSymbolOverridesReply.prototype.getSymbolOverridesList = function() {
  return /** @type{!Array<!proto.accountmanager.SymbolOverride>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.SymbolOverride, 1));
};


/**
 * @param {!Array<!proto.accountmanager.SymbolOverride>} value
 * @return {!proto.accountmanager.AdminListSymbolOverridesReply} returns this
*/
proto.accountmanager.AdminListSymbolOverridesReply.prototype.setSymbolOverridesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.SymbolOverride=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.SymbolOverride}
 */
proto.accountmanager.AdminListSymbolOverridesReply.prototype.addSymbolOverrides = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.SymbolOverride, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminListSymbolOverridesReply} returns this
 */
proto.accountmanager.AdminListSymbolOverridesReply.prototype.clearSymbolOverridesList = function() {
  return this.setSymbolOverridesList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AdminListSymbolOverridesReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListSymbolOverridesReply} returns this
 */
proto.accountmanager.AdminListSymbolOverridesReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminListSymbolOverridesReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListSymbolOverridesReply} returns this
 */
proto.accountmanager.AdminListSymbolOverridesReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.accountmanager.AdminListSymbolOverridesReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListSymbolOverridesReply} returns this
 */
proto.accountmanager.AdminListSymbolOverridesReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.SymbolOverride.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.SymbolOverride.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.SymbolOverride} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolOverride.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 3, ""),
minLots: (f = msg.getMinLots()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLots: (f = msg.getMaxLots()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotsStep: (f = msg.getLotsStep()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
contractSize: (f = msg.getContractSize()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tickValue: (f = msg.getTickValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tickSize: (f = msg.getTickSize()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
profitMode: (f = msg.getProfitMode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
tradeMode: (f = msg.getTradeMode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.SymbolOverride}
 */
proto.accountmanager.SymbolOverride.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.SymbolOverride;
  return proto.accountmanager.SymbolOverride.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.SymbolOverride} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.SymbolOverride}
 */
proto.accountmanager.SymbolOverride.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLots(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLots(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotsStep(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setContractSize(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTickValue(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTickSize(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfitMode(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTradeMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.SymbolOverride.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.SymbolOverride.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.SymbolOverride} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolOverride.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMinLots();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLots();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotsStep();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getContractSize();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTickValue();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTickSize();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitMode();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTradeMode();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.accountmanager.SymbolOverride.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.SymbolOverride} returns this
 */
proto.accountmanager.SymbolOverride.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.accountmanager.SymbolOverride.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SymbolOverride} returns this
 */
proto.accountmanager.SymbolOverride.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string server_id = 3;
 * @return {string}
 */
proto.accountmanager.SymbolOverride.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SymbolOverride} returns this
 */
proto.accountmanager.SymbolOverride.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.DoubleValue min_lots = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolOverride.prototype.getMinLots = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolOverride} returns this
*/
proto.accountmanager.SymbolOverride.prototype.setMinLots = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolOverride} returns this
 */
proto.accountmanager.SymbolOverride.prototype.clearMinLots = function() {
  return this.setMinLots(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolOverride.prototype.hasMinLots = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lots = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolOverride.prototype.getMaxLots = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolOverride} returns this
*/
proto.accountmanager.SymbolOverride.prototype.setMaxLots = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolOverride} returns this
 */
proto.accountmanager.SymbolOverride.prototype.clearMaxLots = function() {
  return this.setMaxLots(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolOverride.prototype.hasMaxLots = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue lots_step = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolOverride.prototype.getLotsStep = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolOverride} returns this
*/
proto.accountmanager.SymbolOverride.prototype.setLotsStep = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolOverride} returns this
 */
proto.accountmanager.SymbolOverride.prototype.clearLotsStep = function() {
  return this.setLotsStep(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolOverride.prototype.hasLotsStep = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.DoubleValue contract_size = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolOverride.prototype.getContractSize = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolOverride} returns this
*/
proto.accountmanager.SymbolOverride.prototype.setContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolOverride} returns this
 */
proto.accountmanager.SymbolOverride.prototype.clearContractSize = function() {
  return this.setContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolOverride.prototype.hasContractSize = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.DoubleValue tick_value = 8;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolOverride.prototype.getTickValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 8));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolOverride} returns this
*/
proto.accountmanager.SymbolOverride.prototype.setTickValue = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolOverride} returns this
 */
proto.accountmanager.SymbolOverride.prototype.clearTickValue = function() {
  return this.setTickValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolOverride.prototype.hasTickValue = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.DoubleValue tick_size = 9;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolOverride.prototype.getTickSize = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 9));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolOverride} returns this
*/
proto.accountmanager.SymbolOverride.prototype.setTickSize = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolOverride} returns this
 */
proto.accountmanager.SymbolOverride.prototype.clearTickSize = function() {
  return this.setTickSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolOverride.prototype.hasTickSize = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue profit_mode = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.SymbolOverride.prototype.getProfitMode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.SymbolOverride} returns this
*/
proto.accountmanager.SymbolOverride.prototype.setProfitMode = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolOverride} returns this
 */
proto.accountmanager.SymbolOverride.prototype.clearProfitMode = function() {
  return this.setProfitMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolOverride.prototype.hasProfitMode = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue trade_mode = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.SymbolOverride.prototype.getTradeMode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.SymbolOverride} returns this
*/
proto.accountmanager.SymbolOverride.prototype.setTradeMode = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolOverride} returns this
 */
proto.accountmanager.SymbolOverride.prototype.clearTradeMode = function() {
  return this.setTradeMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolOverride.prototype.hasTradeMode = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteSymbolOverrideReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteSymbolOverrideReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteSymbolOverrideReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolOverrideReq.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteSymbolOverrideReq}
 */
proto.accountmanager.AdminDeleteSymbolOverrideReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteSymbolOverrideReq;
  return proto.accountmanager.AdminDeleteSymbolOverrideReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteSymbolOverrideReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteSymbolOverrideReq}
 */
proto.accountmanager.AdminDeleteSymbolOverrideReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteSymbolOverrideReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteSymbolOverrideReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteSymbolOverrideReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolOverrideReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.accountmanager.AdminDeleteSymbolOverrideReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminDeleteSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminDeleteSymbolOverrideReq.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteSymbolOverrideReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteSymbolOverrideReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteSymbolOverrideReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolOverrideReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteSymbolOverrideReply}
 */
proto.accountmanager.AdminDeleteSymbolOverrideReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteSymbolOverrideReply;
  return proto.accountmanager.AdminDeleteSymbolOverrideReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteSymbolOverrideReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteSymbolOverrideReply}
 */
proto.accountmanager.AdminDeleteSymbolOverrideReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteSymbolOverrideReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteSymbolOverrideReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteSymbolOverrideReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolOverrideReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUpdateSymbolOverrideReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUpdateSymbolOverrideReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
lotsStep: (f = msg.getLotsStep()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
contractSize: (f = msg.getContractSize()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tickValue: (f = msg.getTickValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tickSize: (f = msg.getTickSize()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
profitMode: (f = msg.getProfitMode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
tradeMode: (f = msg.getTradeMode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUpdateSymbolOverrideReq;
  return proto.accountmanager.AdminUpdateSymbolOverrideReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUpdateSymbolOverrideReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotsStep(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setContractSize(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTickValue(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTickSize(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfitMode(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTradeMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUpdateSymbolOverrideReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUpdateSymbolOverrideReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getLotsStep();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getContractSize();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTickValue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTickSize();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitMode();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTradeMode();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.DoubleValue lots_step = 2;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.getLotsStep = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 2));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.setLotsStep = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.clearLotsStep = function() {
  return this.setLotsStep(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.hasLotsStep = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.DoubleValue contract_size = 3;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.getContractSize = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 3));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.setContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.clearContractSize = function() {
  return this.setContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.hasContractSize = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.DoubleValue tick_value = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.getTickValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.setTickValue = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.clearTickValue = function() {
  return this.setTickValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.hasTickValue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue tick_size = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.getTickSize = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.setTickSize = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.clearTickSize = function() {
  return this.setTickSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.hasTickSize = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue profit_mode = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.getProfitMode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.setProfitMode = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.clearProfitMode = function() {
  return this.setProfitMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.hasProfitMode = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue trade_mode = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.getTradeMode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
*/
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.setTradeMode = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReq} returns this
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.clearTradeMode = function() {
  return this.setTradeMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReq.prototype.hasTradeMode = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUpdateSymbolOverrideReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUpdateSymbolOverrideReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateSymbolOverrideReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReply}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUpdateSymbolOverrideReply;
  return proto.accountmanager.AdminUpdateSymbolOverrideReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUpdateSymbolOverrideReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUpdateSymbolOverrideReply}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUpdateSymbolOverrideReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUpdateSymbolOverrideReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUpdateSymbolOverrideReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateSymbolOverrideReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminCompareSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminCompareSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminCompareSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCompareSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveAccount: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminCompareSymbolsReq}
 */
proto.accountmanager.AdminCompareSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminCompareSymbolsReq;
  return proto.accountmanager.AdminCompareSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminCompareSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminCompareSymbolsReq}
 */
proto.accountmanager.AdminCompareSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminCompareSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminCompareSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminCompareSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCompareSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveAccount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminCompareSymbolsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminCompareSymbolsReq} returns this
 */
proto.accountmanager.AdminCompareSymbolsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.accountmanager.AdminCompareSymbolsReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminCompareSymbolsReq} returns this
 */
proto.accountmanager.AdminCompareSymbolsReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_account = 3;
 * @return {string}
 */
proto.accountmanager.AdminCompareSymbolsReq.prototype.getSlaveAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminCompareSymbolsReq} returns this
 */
proto.accountmanager.AdminCompareSymbolsReq.prototype.setSlaveAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminCompareSymbolsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminCompareSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminCompareSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminCompareSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCompareSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
suggestionsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminCompareSymbolsReply}
 */
proto.accountmanager.AdminCompareSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminCompareSymbolsReply;
  return proto.accountmanager.AdminCompareSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminCompareSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminCompareSymbolsReply}
 */
proto.accountmanager.AdminCompareSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addSuggestions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminCompareSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminCompareSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminCompareSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminCompareSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuggestionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string suggestions = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.AdminCompareSymbolsReply.prototype.getSuggestionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.AdminCompareSymbolsReply} returns this
 */
proto.accountmanager.AdminCompareSymbolsReply.prototype.setSuggestionsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AdminCompareSymbolsReply} returns this
 */
proto.accountmanager.AdminCompareSymbolsReply.prototype.addSuggestions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminCompareSymbolsReply} returns this
 */
proto.accountmanager.AdminCompareSymbolsReply.prototype.clearSuggestionsList = function() {
  return this.setSuggestionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminSymbolStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminSymbolStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminSymbolStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSymbolStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveAccount: jspb.Message.getFieldWithDefault(msg, 3, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminSymbolStatsReq}
 */
proto.accountmanager.AdminSymbolStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminSymbolStatsReq;
  return proto.accountmanager.AdminSymbolStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminSymbolStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminSymbolStatsReq}
 */
proto.accountmanager.AdminSymbolStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveAccount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminSymbolStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminSymbolStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminSymbolStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSymbolStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveAccount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminSymbolStatsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminSymbolStatsReq} returns this
 */
proto.accountmanager.AdminSymbolStatsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.accountmanager.AdminSymbolStatsReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminSymbolStatsReq} returns this
 */
proto.accountmanager.AdminSymbolStatsReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_account = 3;
 * @return {string}
 */
proto.accountmanager.AdminSymbolStatsReq.prototype.getSlaveAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminSymbolStatsReq} returns this
 */
proto.accountmanager.AdminSymbolStatsReq.prototype.setSlaveAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string slave_id = 4;
 * @return {string}
 */
proto.accountmanager.AdminSymbolStatsReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminSymbolStatsReq} returns this
 */
proto.accountmanager.AdminSymbolStatsReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminSymbolStatsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminSymbolStatsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminSymbolStatsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSymbolStatsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
masterSymbolCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
slaveSymbolCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
unmappedCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
mappedCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminSymbolStatsReply}
 */
proto.accountmanager.AdminSymbolStatsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminSymbolStatsReply;
  return proto.accountmanager.AdminSymbolStatsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminSymbolStatsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminSymbolStatsReply}
 */
proto.accountmanager.AdminSymbolStatsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMasterSymbolCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSlaveSymbolCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnmappedCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMappedCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminSymbolStatsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminSymbolStatsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminSymbolStatsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSymbolStatsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMasterSymbolCount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSlaveSymbolCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUnmappedCount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMappedCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int64 master_symbol_count = 1;
 * @return {number}
 */
proto.accountmanager.AdminSymbolStatsReply.prototype.getMasterSymbolCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminSymbolStatsReply} returns this
 */
proto.accountmanager.AdminSymbolStatsReply.prototype.setMasterSymbolCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 slave_symbol_count = 2;
 * @return {number}
 */
proto.accountmanager.AdminSymbolStatsReply.prototype.getSlaveSymbolCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminSymbolStatsReply} returns this
 */
proto.accountmanager.AdminSymbolStatsReply.prototype.setSlaveSymbolCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 unmapped_count = 3;
 * @return {number}
 */
proto.accountmanager.AdminSymbolStatsReply.prototype.getUnmappedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminSymbolStatsReply} returns this
 */
proto.accountmanager.AdminSymbolStatsReply.prototype.setUnmappedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 mapped_count = 4;
 * @return {number}
 */
proto.accountmanager.AdminSymbolStatsReply.prototype.getMappedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminSymbolStatsReply} returns this
 */
proto.accountmanager.AdminSymbolStatsReply.prototype.setMappedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUnmappedSymbolListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUnmappedSymbolListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUnmappedSymbolListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 3, ""),
group: jspb.Message.getFieldWithDefault(msg, 4, ""),
query: jspb.Message.getFieldWithDefault(msg, 5, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 6, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReq}
 */
proto.accountmanager.AdminUnmappedSymbolListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUnmappedSymbolListReq;
  return proto.accountmanager.AdminUnmappedSymbolListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUnmappedSymbolListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReq}
 */
proto.accountmanager.AdminUnmappedSymbolListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroup(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUnmappedSymbolListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUnmappedSymbolListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUnmappedSymbolListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGroup();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReq} returns this
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReq} returns this
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_id = 3;
 * @return {string}
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReq} returns this
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string group = 4;
 * @return {string}
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.getGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReq} returns this
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.setGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string query = 5;
 * @return {string}
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReq} returns this
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string pagination_cursor = 6;
 * @return {string}
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReq} returns this
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint32 page_size = 7;
 * @return {number}
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReq} returns this
 */
proto.accountmanager.AdminUnmappedSymbolListReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminUnmappedSymbolListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUnmappedSymbolListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUnmappedSymbolListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUnmappedSymbolListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
symbolsList: jspb.Message.toObjectList(msg.getSymbolsList(),
    proto.accountmanager.UnmappedSymbol.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReply}
 */
proto.accountmanager.AdminUnmappedSymbolListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUnmappedSymbolListReply;
  return proto.accountmanager.AdminUnmappedSymbolListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUnmappedSymbolListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReply}
 */
proto.accountmanager.AdminUnmappedSymbolListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.UnmappedSymbol;
      reader.readMessage(value,proto.accountmanager.UnmappedSymbol.deserializeBinaryFromReader);
      msg.addSymbols(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUnmappedSymbolListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUnmappedSymbolListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUnmappedSymbolListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.UnmappedSymbol.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated UnmappedSymbol symbols = 1;
 * @return {!Array<!proto.accountmanager.UnmappedSymbol>}
 */
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.getSymbolsList = function() {
  return /** @type{!Array<!proto.accountmanager.UnmappedSymbol>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.UnmappedSymbol, 1));
};


/**
 * @param {!Array<!proto.accountmanager.UnmappedSymbol>} value
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReply} returns this
*/
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.setSymbolsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.UnmappedSymbol=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.UnmappedSymbol}
 */
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.addSymbols = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.UnmappedSymbol, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReply} returns this
 */
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.clearSymbolsList = function() {
  return this.setSymbolsList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReply} returns this
 */
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReply} returns this
 */
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminUnmappedSymbolListReply} returns this
 */
proto.accountmanager.AdminUnmappedSymbolListReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAutoMapSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAutoMapSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAutoMapSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveAccount: jspb.Message.getFieldWithDefault(msg, 3, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 4, ""),
pattern: jspb.Message.getFieldWithDefault(msg, 5, ""),
overwriteExisting: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAutoMapSymbolsReq}
 */
proto.accountmanager.AdminAutoMapSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAutoMapSymbolsReq;
  return proto.accountmanager.AdminAutoMapSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAutoMapSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAutoMapSymbolsReq}
 */
proto.accountmanager.AdminAutoMapSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveAccount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPattern(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverwriteExisting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAutoMapSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAutoMapSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAutoMapSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveAccount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPattern();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOverwriteExisting();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAutoMapSymbolsReq} returns this
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAutoMapSymbolsReq} returns this
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_account = 3;
 * @return {string}
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.getSlaveAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAutoMapSymbolsReq} returns this
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.setSlaveAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string slave_id = 4;
 * @return {string}
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAutoMapSymbolsReq} returns this
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string pattern = 5;
 * @return {string}
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.getPattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAutoMapSymbolsReq} returns this
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.setPattern = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool overwrite_existing = 6;
 * @return {boolean}
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.getOverwriteExisting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AdminAutoMapSymbolsReq} returns this
 */
proto.accountmanager.AdminAutoMapSymbolsReq.prototype.setOverwriteExisting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAutoMapSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAutoMapSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAutoMapSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAutoMapSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAutoMapSymbolsReply}
 */
proto.accountmanager.AdminAutoMapSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAutoMapSymbolsReply;
  return proto.accountmanager.AdminAutoMapSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAutoMapSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAutoMapSymbolsReply}
 */
proto.accountmanager.AdminAutoMapSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAutoMapSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAutoMapSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAutoMapSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAutoMapSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminMappedSymbolListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminMappedSymbolListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminMappedSymbolListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 3, ""),
group: jspb.Message.getFieldWithDefault(msg, 4, ""),
query: jspb.Message.getFieldWithDefault(msg, 5, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 6, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminMappedSymbolListReq}
 */
proto.accountmanager.AdminMappedSymbolListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminMappedSymbolListReq;
  return proto.accountmanager.AdminMappedSymbolListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminMappedSymbolListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminMappedSymbolListReq}
 */
proto.accountmanager.AdminMappedSymbolListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroup(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminMappedSymbolListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminMappedSymbolListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminMappedSymbolListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGroup();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminMappedSymbolListReq} returns this
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminMappedSymbolListReq} returns this
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_id = 3;
 * @return {string}
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminMappedSymbolListReq} returns this
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string group = 4;
 * @return {string}
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.getGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminMappedSymbolListReq} returns this
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.setGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string query = 5;
 * @return {string}
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminMappedSymbolListReq} returns this
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string pagination_cursor = 6;
 * @return {string}
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminMappedSymbolListReq} returns this
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint32 page_size = 7;
 * @return {number}
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminMappedSymbolListReq} returns this
 */
proto.accountmanager.AdminMappedSymbolListReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminMappedSymbolListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminMappedSymbolListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminMappedSymbolListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminMappedSymbolListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminMappedSymbolListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
symbolsList: jspb.Message.toObjectList(msg.getSymbolsList(),
    proto.accountmanager.MappedSymbol.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminMappedSymbolListReply}
 */
proto.accountmanager.AdminMappedSymbolListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminMappedSymbolListReply;
  return proto.accountmanager.AdminMappedSymbolListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminMappedSymbolListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminMappedSymbolListReply}
 */
proto.accountmanager.AdminMappedSymbolListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.MappedSymbol;
      reader.readMessage(value,proto.accountmanager.MappedSymbol.deserializeBinaryFromReader);
      msg.addSymbols(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminMappedSymbolListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminMappedSymbolListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminMappedSymbolListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminMappedSymbolListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.MappedSymbol.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated MappedSymbol symbols = 1;
 * @return {!Array<!proto.accountmanager.MappedSymbol>}
 */
proto.accountmanager.AdminMappedSymbolListReply.prototype.getSymbolsList = function() {
  return /** @type{!Array<!proto.accountmanager.MappedSymbol>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.MappedSymbol, 1));
};


/**
 * @param {!Array<!proto.accountmanager.MappedSymbol>} value
 * @return {!proto.accountmanager.AdminMappedSymbolListReply} returns this
*/
proto.accountmanager.AdminMappedSymbolListReply.prototype.setSymbolsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.MappedSymbol=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.MappedSymbol}
 */
proto.accountmanager.AdminMappedSymbolListReply.prototype.addSymbols = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.MappedSymbol, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminMappedSymbolListReply} returns this
 */
proto.accountmanager.AdminMappedSymbolListReply.prototype.clearSymbolsList = function() {
  return this.setSymbolsList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AdminMappedSymbolListReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminMappedSymbolListReply} returns this
 */
proto.accountmanager.AdminMappedSymbolListReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminMappedSymbolListReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminMappedSymbolListReply} returns this
 */
proto.accountmanager.AdminMappedSymbolListReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.accountmanager.AdminMappedSymbolListReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminMappedSymbolListReply} returns this
 */
proto.accountmanager.AdminMappedSymbolListReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminGroupListReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGroupListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGroupListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGroupListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGroupListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGroupListReq}
 */
proto.accountmanager.AdminGroupListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGroupListReq;
  return proto.accountmanager.AdminGroupListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGroupListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGroupListReq}
 */
proto.accountmanager.AdminGroupListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGroupListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGroupListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGroupListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGroupListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminGroupListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGroupListReq} returns this
 */
proto.accountmanager.AdminGroupListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string accounts = 2;
 * @return {!Array<string>}
 */
proto.accountmanager.AdminGroupListReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.AdminGroupListReq} returns this
 */
proto.accountmanager.AdminGroupListReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AdminGroupListReq} returns this
 */
proto.accountmanager.AdminGroupListReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminGroupListReq} returns this
 */
proto.accountmanager.AdminGroupListReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminGroupListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGroupListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGroupListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGroupListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGroupListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
groupsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGroupListReply}
 */
proto.accountmanager.AdminGroupListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGroupListReply;
  return proto.accountmanager.AdminGroupListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGroupListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGroupListReply}
 */
proto.accountmanager.AdminGroupListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGroupListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGroupListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGroupListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGroupListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string groups = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.AdminGroupListReply.prototype.getGroupsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.AdminGroupListReply} returns this
 */
proto.accountmanager.AdminGroupListReply.prototype.setGroupsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AdminGroupListReply} returns this
 */
proto.accountmanager.AdminGroupListReply.prototype.addGroups = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminGroupListReply} returns this
 */
proto.accountmanager.AdminGroupListReply.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetUsersDedicatedEnvListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetUsersDedicatedEnvListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetUsersDedicatedEnvListReq}
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetUsersDedicatedEnvListReq;
  return proto.accountmanager.AdminGetUsersDedicatedEnvListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetUsersDedicatedEnvListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetUsersDedicatedEnvListReq}
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetUsersDedicatedEnvListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetUsersDedicatedEnvListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminGetUsersDedicatedEnvListReq} returns this
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetUsersDedicatedEnvListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetUsersDedicatedEnvListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
dedicatedEnvsList: jspb.Message.toObjectList(msg.getDedicatedEnvsList(),
    proto.accountmanager.DedicatedEnv.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetUsersDedicatedEnvListReply}
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetUsersDedicatedEnvListReply;
  return proto.accountmanager.AdminGetUsersDedicatedEnvListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetUsersDedicatedEnvListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetUsersDedicatedEnvListReply}
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.DedicatedEnv;
      reader.readMessage(value,proto.accountmanager.DedicatedEnv.deserializeBinaryFromReader);
      msg.addDedicatedEnvs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetUsersDedicatedEnvListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetUsersDedicatedEnvListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDedicatedEnvsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.DedicatedEnv.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DedicatedEnv dedicated_envs = 1;
 * @return {!Array<!proto.accountmanager.DedicatedEnv>}
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReply.prototype.getDedicatedEnvsList = function() {
  return /** @type{!Array<!proto.accountmanager.DedicatedEnv>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.DedicatedEnv, 1));
};


/**
 * @param {!Array<!proto.accountmanager.DedicatedEnv>} value
 * @return {!proto.accountmanager.AdminGetUsersDedicatedEnvListReply} returns this
*/
proto.accountmanager.AdminGetUsersDedicatedEnvListReply.prototype.setDedicatedEnvsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.DedicatedEnv=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.DedicatedEnv}
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReply.prototype.addDedicatedEnvs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.DedicatedEnv, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminGetUsersDedicatedEnvListReply} returns this
 */
proto.accountmanager.AdminGetUsersDedicatedEnvListReply.prototype.clearDedicatedEnvsList = function() {
  return this.setDedicatedEnvsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminChangeAccountEnvReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminChangeAccountEnvReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminChangeAccountEnvReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminChangeAccountEnvReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
dedicatedEnvId: (f = msg.getDedicatedEnvId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminChangeAccountEnvReq}
 */
proto.accountmanager.AdminChangeAccountEnvReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminChangeAccountEnvReq;
  return proto.accountmanager.AdminChangeAccountEnvReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminChangeAccountEnvReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminChangeAccountEnvReq}
 */
proto.accountmanager.AdminChangeAccountEnvReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDedicatedEnvId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminChangeAccountEnvReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminChangeAccountEnvReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminChangeAccountEnvReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminChangeAccountEnvReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDedicatedEnvId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminChangeAccountEnvReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminChangeAccountEnvReq} returns this
 */
proto.accountmanager.AdminChangeAccountEnvReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminChangeAccountEnvReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminChangeAccountEnvReq} returns this
 */
proto.accountmanager.AdminChangeAccountEnvReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue dedicated_env_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.AdminChangeAccountEnvReq.prototype.getDedicatedEnvId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.AdminChangeAccountEnvReq} returns this
*/
proto.accountmanager.AdminChangeAccountEnvReq.prototype.setDedicatedEnvId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminChangeAccountEnvReq} returns this
 */
proto.accountmanager.AdminChangeAccountEnvReq.prototype.clearDedicatedEnvId = function() {
  return this.setDedicatedEnvId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminChangeAccountEnvReq.prototype.hasDedicatedEnvId = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminChangeAccountEnvReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminChangeAccountEnvReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminChangeAccountEnvReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminChangeAccountEnvReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminChangeAccountEnvReply}
 */
proto.accountmanager.AdminChangeAccountEnvReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminChangeAccountEnvReply;
  return proto.accountmanager.AdminChangeAccountEnvReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminChangeAccountEnvReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminChangeAccountEnvReply}
 */
proto.accountmanager.AdminChangeAccountEnvReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminChangeAccountEnvReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminChangeAccountEnvReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminChangeAccountEnvReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminChangeAccountEnvReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminEnableAccountSymbolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminEnableAccountSymbolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminEnableAccountSymbolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAccountSymbolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbolId: jspb.Message.getFieldWithDefault(msg, 3, 0),
enable: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminEnableAccountSymbolReq}
 */
proto.accountmanager.AdminEnableAccountSymbolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminEnableAccountSymbolReq;
  return proto.accountmanager.AdminEnableAccountSymbolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminEnableAccountSymbolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminEnableAccountSymbolReq}
 */
proto.accountmanager.AdminEnableAccountSymbolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSymbolId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminEnableAccountSymbolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminEnableAccountSymbolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminEnableAccountSymbolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAccountSymbolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getEnable();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminEnableAccountSymbolReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminEnableAccountSymbolReq} returns this
 */
proto.accountmanager.AdminEnableAccountSymbolReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminEnableAccountSymbolReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminEnableAccountSymbolReq} returns this
 */
proto.accountmanager.AdminEnableAccountSymbolReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 symbol_id = 3;
 * @return {number}
 */
proto.accountmanager.AdminEnableAccountSymbolReq.prototype.getSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminEnableAccountSymbolReq} returns this
 */
proto.accountmanager.AdminEnableAccountSymbolReq.prototype.setSymbolId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool enable = 4;
 * @return {boolean}
 */
proto.accountmanager.AdminEnableAccountSymbolReq.prototype.getEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AdminEnableAccountSymbolReq} returns this
 */
proto.accountmanager.AdminEnableAccountSymbolReq.prototype.setEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminEnableAccountSymbolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminEnableAccountSymbolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminEnableAccountSymbolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAccountSymbolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminEnableAccountSymbolReply}
 */
proto.accountmanager.AdminEnableAccountSymbolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminEnableAccountSymbolReply;
  return proto.accountmanager.AdminEnableAccountSymbolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminEnableAccountSymbolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminEnableAccountSymbolReply}
 */
proto.accountmanager.AdminEnableAccountSymbolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminEnableAccountSymbolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminEnableAccountSymbolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminEnableAccountSymbolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAccountSymbolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminEnableAllAccountSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminEnableAllAccountSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
enable: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminEnableAllAccountSymbolsReq}
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminEnableAllAccountSymbolsReq;
  return proto.accountmanager.AdminEnableAllAccountSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminEnableAllAccountSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminEnableAllAccountSymbolsReq}
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminEnableAllAccountSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminEnableAllAccountSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnable();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminEnableAllAccountSymbolsReq} returns this
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminEnableAllAccountSymbolsReq} returns this
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool enable = 3;
 * @return {boolean}
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.prototype.getEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AdminEnableAllAccountSymbolsReq} returns this
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReq.prototype.setEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminEnableAllAccountSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminEnableAllAccountSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminEnableAllAccountSymbolsReply}
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminEnableAllAccountSymbolsReply;
  return proto.accountmanager.AdminEnableAllAccountSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminEnableAllAccountSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminEnableAllAccountSymbolsReply}
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminEnableAllAccountSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminEnableAllAccountSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminEnableAllAccountSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetAllowedCTraderAccountsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetAllowedCTraderAccountsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetAllowedCTraderAccountsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAllowedCTraderAccountsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
authId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetAllowedCTraderAccountsReq}
 */
proto.accountmanager.GetAllowedCTraderAccountsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetAllowedCTraderAccountsReq;
  return proto.accountmanager.GetAllowedCTraderAccountsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetAllowedCTraderAccountsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetAllowedCTraderAccountsReq}
 */
proto.accountmanager.GetAllowedCTraderAccountsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuthId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetAllowedCTraderAccountsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetAllowedCTraderAccountsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetAllowedCTraderAccountsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAllowedCTraderAccountsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GetAllowedCTraderAccountsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetAllowedCTraderAccountsReq} returns this
 */
proto.accountmanager.GetAllowedCTraderAccountsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 auth_id = 2;
 * @return {number}
 */
proto.accountmanager.GetAllowedCTraderAccountsReq.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.GetAllowedCTraderAccountsReq} returns this
 */
proto.accountmanager.GetAllowedCTraderAccountsReq.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.CTraderAccountInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.CTraderAccountInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.CTraderAccountInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CTraderAccountInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
accountNumber: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.CTraderAccountInfo}
 */
proto.accountmanager.CTraderAccountInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.CTraderAccountInfo;
  return proto.accountmanager.CTraderAccountInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.CTraderAccountInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.CTraderAccountInfo}
 */
proto.accountmanager.CTraderAccountInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.CTraderAccountInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.CTraderAccountInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.CTraderAccountInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CTraderAccountInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAccountNumber();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 account_id = 1;
 * @return {number}
 */
proto.accountmanager.CTraderAccountInfo.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.CTraderAccountInfo} returns this
 */
proto.accountmanager.CTraderAccountInfo.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 account_number = 2;
 * @return {number}
 */
proto.accountmanager.CTraderAccountInfo.prototype.getAccountNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.CTraderAccountInfo} returns this
 */
proto.accountmanager.CTraderAccountInfo.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GetAllowedCTraderAccountsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetAllowedCTraderAccountsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetAllowedCTraderAccountsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetAllowedCTraderAccountsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAllowedCTraderAccountsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
allowedAccountsList: jspb.Message.toObjectList(msg.getAllowedAccountsList(),
    proto.accountmanager.CTraderAccountInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetAllowedCTraderAccountsReply}
 */
proto.accountmanager.GetAllowedCTraderAccountsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetAllowedCTraderAccountsReply;
  return proto.accountmanager.GetAllowedCTraderAccountsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetAllowedCTraderAccountsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetAllowedCTraderAccountsReply}
 */
proto.accountmanager.GetAllowedCTraderAccountsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.CTraderAccountInfo;
      reader.readMessage(value,proto.accountmanager.CTraderAccountInfo.deserializeBinaryFromReader);
      msg.addAllowedAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetAllowedCTraderAccountsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetAllowedCTraderAccountsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetAllowedCTraderAccountsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetAllowedCTraderAccountsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllowedAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.CTraderAccountInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CTraderAccountInfo allowed_accounts = 1;
 * @return {!Array<!proto.accountmanager.CTraderAccountInfo>}
 */
proto.accountmanager.GetAllowedCTraderAccountsReply.prototype.getAllowedAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.CTraderAccountInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.CTraderAccountInfo, 1));
};


/**
 * @param {!Array<!proto.accountmanager.CTraderAccountInfo>} value
 * @return {!proto.accountmanager.GetAllowedCTraderAccountsReply} returns this
*/
proto.accountmanager.GetAllowedCTraderAccountsReply.prototype.setAllowedAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.CTraderAccountInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.CTraderAccountInfo}
 */
proto.accountmanager.GetAllowedCTraderAccountsReply.prototype.addAllowedAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.CTraderAccountInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GetAllowedCTraderAccountsReply} returns this
 */
proto.accountmanager.GetAllowedCTraderAccountsReply.prototype.clearAllowedAccountsList = function() {
  return this.setAllowedAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.SaveCTraderAuthInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.SaveCTraderAuthInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.SaveCTraderAuthInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SaveCTraderAuthInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
authorizationCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
redirectUrl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.SaveCTraderAuthInfoReq}
 */
proto.accountmanager.SaveCTraderAuthInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.SaveCTraderAuthInfoReq;
  return proto.accountmanager.SaveCTraderAuthInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.SaveCTraderAuthInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.SaveCTraderAuthInfoReq}
 */
proto.accountmanager.SaveCTraderAuthInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorizationCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.SaveCTraderAuthInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.SaveCTraderAuthInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.SaveCTraderAuthInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SaveCTraderAuthInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthorizationCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRedirectUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.SaveCTraderAuthInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SaveCTraderAuthInfoReq} returns this
 */
proto.accountmanager.SaveCTraderAuthInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string authorization_code = 2;
 * @return {string}
 */
proto.accountmanager.SaveCTraderAuthInfoReq.prototype.getAuthorizationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SaveCTraderAuthInfoReq} returns this
 */
proto.accountmanager.SaveCTraderAuthInfoReq.prototype.setAuthorizationCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string redirect_url = 3;
 * @return {string}
 */
proto.accountmanager.SaveCTraderAuthInfoReq.prototype.getRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SaveCTraderAuthInfoReq} returns this
 */
proto.accountmanager.SaveCTraderAuthInfoReq.prototype.setRedirectUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.SaveCTraderAuthInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.SaveCTraderAuthInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.SaveCTraderAuthInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SaveCTraderAuthInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
authId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.SaveCTraderAuthInfoReply}
 */
proto.accountmanager.SaveCTraderAuthInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.SaveCTraderAuthInfoReply;
  return proto.accountmanager.SaveCTraderAuthInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.SaveCTraderAuthInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.SaveCTraderAuthInfoReply}
 */
proto.accountmanager.SaveCTraderAuthInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuthId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.SaveCTraderAuthInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.SaveCTraderAuthInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.SaveCTraderAuthInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SaveCTraderAuthInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 auth_id = 1;
 * @return {number}
 */
proto.accountmanager.SaveCTraderAuthInfoReply.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.SaveCTraderAuthInfoReply} returns this
 */
proto.accountmanager.SaveCTraderAuthInfoReply.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UpdateCTraderAuthInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UpdateCTraderAuthInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
authId: jspb.Message.getFieldWithDefault(msg, 2, 0),
nickname: (f = msg.getNickname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UpdateCTraderAuthInfoReq}
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UpdateCTraderAuthInfoReq;
  return proto.accountmanager.UpdateCTraderAuthInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UpdateCTraderAuthInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UpdateCTraderAuthInfoReq}
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuthId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setNickname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UpdateCTraderAuthInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UpdateCTraderAuthInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNickname();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.UpdateCTraderAuthInfoReq} returns this
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 auth_id = 2;
 * @return {number}
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.UpdateCTraderAuthInfoReq} returns this
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue nickname = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.prototype.getNickname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.UpdateCTraderAuthInfoReq} returns this
*/
proto.accountmanager.UpdateCTraderAuthInfoReq.prototype.setNickname = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.UpdateCTraderAuthInfoReq} returns this
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.prototype.clearNickname = function() {
  return this.setNickname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.UpdateCTraderAuthInfoReq.prototype.hasNickname = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.UpdateCTraderAuthInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.UpdateCTraderAuthInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.UpdateCTraderAuthInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateCTraderAuthInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.UpdateCTraderAuthInfoReply}
 */
proto.accountmanager.UpdateCTraderAuthInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.UpdateCTraderAuthInfoReply;
  return proto.accountmanager.UpdateCTraderAuthInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.UpdateCTraderAuthInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.UpdateCTraderAuthInfoReply}
 */
proto.accountmanager.UpdateCTraderAuthInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.UpdateCTraderAuthInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.UpdateCTraderAuthInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.UpdateCTraderAuthInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.UpdateCTraderAuthInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.DeleteCTraderAuthInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.DeleteCTraderAuthInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.DeleteCTraderAuthInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteCTraderAuthInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
authId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.DeleteCTraderAuthInfoReq}
 */
proto.accountmanager.DeleteCTraderAuthInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.DeleteCTraderAuthInfoReq;
  return proto.accountmanager.DeleteCTraderAuthInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.DeleteCTraderAuthInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.DeleteCTraderAuthInfoReq}
 */
proto.accountmanager.DeleteCTraderAuthInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuthId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.DeleteCTraderAuthInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.DeleteCTraderAuthInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.DeleteCTraderAuthInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteCTraderAuthInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.DeleteCTraderAuthInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DeleteCTraderAuthInfoReq} returns this
 */
proto.accountmanager.DeleteCTraderAuthInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 auth_id = 2;
 * @return {number}
 */
proto.accountmanager.DeleteCTraderAuthInfoReq.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.DeleteCTraderAuthInfoReq} returns this
 */
proto.accountmanager.DeleteCTraderAuthInfoReq.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.DeleteCTraderAuthInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.DeleteCTraderAuthInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.DeleteCTraderAuthInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteCTraderAuthInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.DeleteCTraderAuthInfoReply}
 */
proto.accountmanager.DeleteCTraderAuthInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.DeleteCTraderAuthInfoReply;
  return proto.accountmanager.DeleteCTraderAuthInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.DeleteCTraderAuthInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.DeleteCTraderAuthInfoReply}
 */
proto.accountmanager.DeleteCTraderAuthInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.DeleteCTraderAuthInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.DeleteCTraderAuthInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.DeleteCTraderAuthInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteCTraderAuthInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetCTraderAuthenticatedProfileListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetCTraderAuthenticatedProfileListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetCTraderAuthenticatedProfileListReq}
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetCTraderAuthenticatedProfileListReq;
  return proto.accountmanager.GetCTraderAuthenticatedProfileListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetCTraderAuthenticatedProfileListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetCTraderAuthenticatedProfileListReq}
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetCTraderAuthenticatedProfileListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetCTraderAuthenticatedProfileListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.GetCTraderAuthenticatedProfileListReq} returns this
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.GetCTraderAuthenticatedProfileListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.GetCTraderAuthenticatedProfileListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
profilesList: jspb.Message.toObjectList(msg.getProfilesList(),
    proto.accountmanager.CTraderProfile.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.GetCTraderAuthenticatedProfileListReply}
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.GetCTraderAuthenticatedProfileListReply;
  return proto.accountmanager.GetCTraderAuthenticatedProfileListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.GetCTraderAuthenticatedProfileListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.GetCTraderAuthenticatedProfileListReply}
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.CTraderProfile;
      reader.readMessage(value,proto.accountmanager.CTraderProfile.deserializeBinaryFromReader);
      msg.addProfiles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.GetCTraderAuthenticatedProfileListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.GetCTraderAuthenticatedProfileListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.CTraderProfile.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CTraderProfile profiles = 1;
 * @return {!Array<!proto.accountmanager.CTraderProfile>}
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReply.prototype.getProfilesList = function() {
  return /** @type{!Array<!proto.accountmanager.CTraderProfile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.CTraderProfile, 1));
};


/**
 * @param {!Array<!proto.accountmanager.CTraderProfile>} value
 * @return {!proto.accountmanager.GetCTraderAuthenticatedProfileListReply} returns this
*/
proto.accountmanager.GetCTraderAuthenticatedProfileListReply.prototype.setProfilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.CTraderProfile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.CTraderProfile}
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReply.prototype.addProfiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.CTraderProfile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.GetCTraderAuthenticatedProfileListReply} returns this
 */
proto.accountmanager.GetCTraderAuthenticatedProfileListReply.prototype.clearProfilesList = function() {
  return this.setProfilesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.CTraderProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.CTraderProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.CTraderProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CTraderProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
authId: jspb.Message.getFieldWithDefault(msg, 1, 0),
profileId: jspb.Message.getFieldWithDefault(msg, 2, 0),
nickname: (f = msg.getNickname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.CTraderProfile}
 */
proto.accountmanager.CTraderProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.CTraderProfile;
  return proto.accountmanager.CTraderProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.CTraderProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.CTraderProfile}
 */
proto.accountmanager.CTraderProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuthId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProfileId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setNickname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.CTraderProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.CTraderProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.CTraderProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.CTraderProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getProfileId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNickname();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 auth_id = 1;
 * @return {number}
 */
proto.accountmanager.CTraderProfile.prototype.getAuthId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.CTraderProfile} returns this
 */
proto.accountmanager.CTraderProfile.prototype.setAuthId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 profile_id = 2;
 * @return {number}
 */
proto.accountmanager.CTraderProfile.prototype.getProfileId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.CTraderProfile} returns this
 */
proto.accountmanager.CTraderProfile.prototype.setProfileId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue nickname = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.accountmanager.CTraderProfile.prototype.getNickname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.accountmanager.CTraderProfile} returns this
*/
proto.accountmanager.CTraderProfile.prototype.setNickname = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.CTraderProfile} returns this
 */
proto.accountmanager.CTraderProfile.prototype.clearNickname = function() {
  return this.setNickname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.CTraderProfile.prototype.hasNickname = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AccountReconnect.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AccountReconnect.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AccountReconnect} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountReconnect.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
notifyOnConnect: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
retryCount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AccountReconnect}
 */
proto.accountmanager.AccountReconnect.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AccountReconnect;
  return proto.accountmanager.AccountReconnect.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AccountReconnect} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AccountReconnect}
 */
proto.accountmanager.AccountReconnect.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNotifyOnConnect(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRetryCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AccountReconnect.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AccountReconnect.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AccountReconnect} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AccountReconnect.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNotifyOnConnect();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getRetryCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AccountReconnect.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AccountReconnect} returns this
 */
proto.accountmanager.AccountReconnect.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool notify_on_connect = 2;
 * @return {boolean}
 */
proto.accountmanager.AccountReconnect.prototype.getNotifyOnConnect = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.AccountReconnect} returns this
 */
proto.accountmanager.AccountReconnect.prototype.setNotifyOnConnect = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int32 retry_count = 3;
 * @return {number}
 */
proto.accountmanager.AccountReconnect.prototype.getRetryCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AccountReconnect} returns this
 */
proto.accountmanager.AccountReconnect.prototype.setRetryCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddPoolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddPoolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddPoolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddPoolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddPoolReq}
 */
proto.accountmanager.AdminAddPoolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddPoolReq;
  return proto.accountmanager.AdminAddPoolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddPoolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddPoolReq}
 */
proto.accountmanager.AdminAddPoolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddPoolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddPoolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddPoolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddPoolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.accountmanager.AdminAddPoolReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddPoolReq} returns this
 */
proto.accountmanager.AdminAddPoolReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddPoolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddPoolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddPoolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddPoolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddPoolReply}
 */
proto.accountmanager.AdminAddPoolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddPoolReply;
  return proto.accountmanager.AdminAddPoolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddPoolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddPoolReply}
 */
proto.accountmanager.AdminAddPoolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddPoolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddPoolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddPoolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddPoolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUpdatePoolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUpdatePoolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUpdatePoolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdatePoolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUpdatePoolReq}
 */
proto.accountmanager.AdminUpdatePoolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUpdatePoolReq;
  return proto.accountmanager.AdminUpdatePoolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUpdatePoolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUpdatePoolReq}
 */
proto.accountmanager.AdminUpdatePoolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUpdatePoolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUpdatePoolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUpdatePoolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdatePoolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.accountmanager.AdminUpdatePoolReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminUpdatePoolReq} returns this
 */
proto.accountmanager.AdminUpdatePoolReq.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.accountmanager.AdminUpdatePoolReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminUpdatePoolReq} returns this
 */
proto.accountmanager.AdminUpdatePoolReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUpdatePoolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUpdatePoolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUpdatePoolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdatePoolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUpdatePoolReply}
 */
proto.accountmanager.AdminUpdatePoolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUpdatePoolReply;
  return proto.accountmanager.AdminUpdatePoolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUpdatePoolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUpdatePoolReply}
 */
proto.accountmanager.AdminUpdatePoolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUpdatePoolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUpdatePoolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUpdatePoolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdatePoolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeletePoolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeletePoolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeletePoolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeletePoolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeletePoolReq}
 */
proto.accountmanager.AdminDeletePoolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeletePoolReq;
  return proto.accountmanager.AdminDeletePoolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeletePoolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeletePoolReq}
 */
proto.accountmanager.AdminDeletePoolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeletePoolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeletePoolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeletePoolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeletePoolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.accountmanager.AdminDeletePoolReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminDeletePoolReq} returns this
 */
proto.accountmanager.AdminDeletePoolReq.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeletePoolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeletePoolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeletePoolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeletePoolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeletePoolReply}
 */
proto.accountmanager.AdminDeletePoolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeletePoolReply;
  return proto.accountmanager.AdminDeletePoolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeletePoolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeletePoolReply}
 */
proto.accountmanager.AdminDeletePoolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeletePoolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeletePoolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeletePoolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeletePoolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminListPoolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminListPoolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminListPoolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListPoolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
query: jspb.Message.getFieldWithDefault(msg, 1, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminListPoolsReq}
 */
proto.accountmanager.AdminListPoolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminListPoolsReq;
  return proto.accountmanager.AdminListPoolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminListPoolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminListPoolsReq}
 */
proto.accountmanager.AdminListPoolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminListPoolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminListPoolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminListPoolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListPoolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.accountmanager.AdminListPoolsReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListPoolsReq} returns this
 */
proto.accountmanager.AdminListPoolsReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pagination_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AdminListPoolsReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListPoolsReq} returns this
 */
proto.accountmanager.AdminListPoolsReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminListPoolsReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListPoolsReq} returns this
 */
proto.accountmanager.AdminListPoolsReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminListPoolsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminListPoolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminListPoolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminListPoolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListPoolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
poolsList: jspb.Message.toObjectList(msg.getPoolsList(),
    proto.accountmanager.Pool.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminListPoolsReply}
 */
proto.accountmanager.AdminListPoolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminListPoolsReply;
  return proto.accountmanager.AdminListPoolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminListPoolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminListPoolsReply}
 */
proto.accountmanager.AdminListPoolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.Pool;
      reader.readMessage(value,proto.accountmanager.Pool.deserializeBinaryFromReader);
      msg.addPools(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminListPoolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminListPoolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminListPoolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminListPoolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPoolsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.Pool.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated Pool pools = 1;
 * @return {!Array<!proto.accountmanager.Pool>}
 */
proto.accountmanager.AdminListPoolsReply.prototype.getPoolsList = function() {
  return /** @type{!Array<!proto.accountmanager.Pool>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.Pool, 1));
};


/**
 * @param {!Array<!proto.accountmanager.Pool>} value
 * @return {!proto.accountmanager.AdminListPoolsReply} returns this
*/
proto.accountmanager.AdminListPoolsReply.prototype.setPoolsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.Pool=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.Pool}
 */
proto.accountmanager.AdminListPoolsReply.prototype.addPools = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.Pool, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminListPoolsReply} returns this
 */
proto.accountmanager.AdminListPoolsReply.prototype.clearPoolsList = function() {
  return this.setPoolsList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.accountmanager.AdminListPoolsReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminListPoolsReply} returns this
 */
proto.accountmanager.AdminListPoolsReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.accountmanager.AdminListPoolsReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListPoolsReply} returns this
 */
proto.accountmanager.AdminListPoolsReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.accountmanager.AdminListPoolsReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminListPoolsReply} returns this
 */
proto.accountmanager.AdminListPoolsReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddSymbolPoolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddSymbolPoolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddSymbolPoolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddSymbolPoolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
poolId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddSymbolPoolReq}
 */
proto.accountmanager.AdminAddSymbolPoolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddSymbolPoolReq;
  return proto.accountmanager.AdminAddSymbolPoolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddSymbolPoolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddSymbolPoolReq}
 */
proto.accountmanager.AdminAddSymbolPoolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPoolId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddSymbolPoolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddSymbolPoolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddSymbolPoolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddSymbolPoolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPoolId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.accountmanager.AdminAddSymbolPoolReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminAddSymbolPoolReq} returns this
 */
proto.accountmanager.AdminAddSymbolPoolReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 pool_id = 2;
 * @return {number}
 */
proto.accountmanager.AdminAddSymbolPoolReq.prototype.getPoolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminAddSymbolPoolReq} returns this
 */
proto.accountmanager.AdminAddSymbolPoolReq.prototype.setPoolId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminAddSymbolPoolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminAddSymbolPoolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminAddSymbolPoolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddSymbolPoolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminAddSymbolPoolReply}
 */
proto.accountmanager.AdminAddSymbolPoolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminAddSymbolPoolReply;
  return proto.accountmanager.AdminAddSymbolPoolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminAddSymbolPoolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminAddSymbolPoolReply}
 */
proto.accountmanager.AdminAddSymbolPoolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminAddSymbolPoolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminAddSymbolPoolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminAddSymbolPoolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminAddSymbolPoolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUpdateSymbolPoolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUpdateSymbolPoolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUpdateSymbolPoolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateSymbolPoolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUpdateSymbolPoolReq}
 */
proto.accountmanager.AdminUpdateSymbolPoolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUpdateSymbolPoolReq;
  return proto.accountmanager.AdminUpdateSymbolPoolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUpdateSymbolPoolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUpdateSymbolPoolReq}
 */
proto.accountmanager.AdminUpdateSymbolPoolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUpdateSymbolPoolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUpdateSymbolPoolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUpdateSymbolPoolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateSymbolPoolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.accountmanager.AdminUpdateSymbolPoolReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminUpdateSymbolPoolReq} returns this
 */
proto.accountmanager.AdminUpdateSymbolPoolReq.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.accountmanager.AdminUpdateSymbolPoolReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminUpdateSymbolPoolReq} returns this
 */
proto.accountmanager.AdminUpdateSymbolPoolReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminUpdateSymbolPoolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminUpdateSymbolPoolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminUpdateSymbolPoolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateSymbolPoolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminUpdateSymbolPoolReply}
 */
proto.accountmanager.AdminUpdateSymbolPoolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminUpdateSymbolPoolReply;
  return proto.accountmanager.AdminUpdateSymbolPoolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminUpdateSymbolPoolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminUpdateSymbolPoolReply}
 */
proto.accountmanager.AdminUpdateSymbolPoolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminUpdateSymbolPoolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminUpdateSymbolPoolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminUpdateSymbolPoolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminUpdateSymbolPoolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteSymbolPoolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteSymbolPoolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteSymbolPoolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolPoolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteSymbolPoolReq}
 */
proto.accountmanager.AdminDeleteSymbolPoolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteSymbolPoolReq;
  return proto.accountmanager.AdminDeleteSymbolPoolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteSymbolPoolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteSymbolPoolReq}
 */
proto.accountmanager.AdminDeleteSymbolPoolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteSymbolPoolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteSymbolPoolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteSymbolPoolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolPoolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.accountmanager.AdminDeleteSymbolPoolReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.AdminDeleteSymbolPoolReq} returns this
 */
proto.accountmanager.AdminDeleteSymbolPoolReq.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteSymbolPoolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteSymbolPoolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteSymbolPoolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolPoolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteSymbolPoolReply}
 */
proto.accountmanager.AdminDeleteSymbolPoolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteSymbolPoolReply;
  return proto.accountmanager.AdminDeleteSymbolPoolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteSymbolPoolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteSymbolPoolReply}
 */
proto.accountmanager.AdminDeleteSymbolPoolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteSymbolPoolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteSymbolPoolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteSymbolPoolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolPoolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.Pool.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.Pool.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.Pool.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.Pool} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.Pool.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbolsList: jspb.Message.toObjectList(msg.getSymbolsList(),
    proto.accountmanager.SymbolPool.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.Pool}
 */
proto.accountmanager.Pool.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.Pool;
  return proto.accountmanager.Pool.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.Pool} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.Pool}
 */
proto.accountmanager.Pool.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.accountmanager.SymbolPool;
      reader.readMessage(value,proto.accountmanager.SymbolPool.deserializeBinaryFromReader);
      msg.addSymbols(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.Pool.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.Pool.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.Pool} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.Pool.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.accountmanager.SymbolPool.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.accountmanager.Pool.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.Pool} returns this
 */
proto.accountmanager.Pool.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.accountmanager.Pool.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.Pool} returns this
 */
proto.accountmanager.Pool.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated SymbolPool symbols = 3;
 * @return {!Array<!proto.accountmanager.SymbolPool>}
 */
proto.accountmanager.Pool.prototype.getSymbolsList = function() {
  return /** @type{!Array<!proto.accountmanager.SymbolPool>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.SymbolPool, 3));
};


/**
 * @param {!Array<!proto.accountmanager.SymbolPool>} value
 * @return {!proto.accountmanager.Pool} returns this
*/
proto.accountmanager.Pool.prototype.setSymbolsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.accountmanager.SymbolPool=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.SymbolPool}
 */
proto.accountmanager.Pool.prototype.addSymbols = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.accountmanager.SymbolPool, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.Pool} returns this
 */
proto.accountmanager.Pool.prototype.clearSymbolsList = function() {
  return this.setSymbolsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.SymbolPool.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.SymbolPool.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.SymbolPool} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolPool.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.SymbolPool}
 */
proto.accountmanager.SymbolPool.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.SymbolPool;
  return proto.accountmanager.SymbolPool.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.SymbolPool} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.SymbolPool}
 */
proto.accountmanager.SymbolPool.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.SymbolPool.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.SymbolPool.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.SymbolPool} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolPool.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.accountmanager.SymbolPool.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountmanager.SymbolPool} returns this
 */
proto.accountmanager.SymbolPool.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.accountmanager.SymbolPool.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SymbolPool} returns this
 */
proto.accountmanager.SymbolPool.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntInternalAccountsInfoReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntInternalAccountsInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntInternalAccountsInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntInternalAccountsInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntInternalAccountsInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntInternalAccountsInfoReq}
 */
proto.accountmanager.IntInternalAccountsInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntInternalAccountsInfoReq;
  return proto.accountmanager.IntInternalAccountsInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntInternalAccountsInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntInternalAccountsInfoReq}
 */
proto.accountmanager.IntInternalAccountsInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntInternalAccountsInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntInternalAccountsInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntInternalAccountsInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntInternalAccountsInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.IntInternalAccountsInfoReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.IntInternalAccountsInfoReq} returns this
 */
proto.accountmanager.IntInternalAccountsInfoReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.IntInternalAccountsInfoReq} returns this
 */
proto.accountmanager.IntInternalAccountsInfoReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntInternalAccountsInfoReq} returns this
 */
proto.accountmanager.IntInternalAccountsInfoReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.IntInternalAccountsInfoReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntInternalAccountsInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntInternalAccountsInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntInternalAccountsInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntInternalAccountsInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.accountmanager.InternalAccountDetails.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntInternalAccountsInfoReply}
 */
proto.accountmanager.IntInternalAccountsInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntInternalAccountsInfoReply;
  return proto.accountmanager.IntInternalAccountsInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntInternalAccountsInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntInternalAccountsInfoReply}
 */
proto.accountmanager.IntInternalAccountsInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountmanager.InternalAccountDetails;
      reader.readMessage(value,proto.accountmanager.InternalAccountDetails.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntInternalAccountsInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntInternalAccountsInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntInternalAccountsInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntInternalAccountsInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountmanager.InternalAccountDetails.serializeBinaryToWriter
    );
  }
};


/**
 * repeated InternalAccountDetails accounts = 1;
 * @return {!Array<!proto.accountmanager.InternalAccountDetails>}
 */
proto.accountmanager.IntInternalAccountsInfoReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.accountmanager.InternalAccountDetails>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountmanager.InternalAccountDetails, 1));
};


/**
 * @param {!Array<!proto.accountmanager.InternalAccountDetails>} value
 * @return {!proto.accountmanager.IntInternalAccountsInfoReply} returns this
*/
proto.accountmanager.IntInternalAccountsInfoReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountmanager.InternalAccountDetails=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.InternalAccountDetails}
 */
proto.accountmanager.IntInternalAccountsInfoReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountmanager.InternalAccountDetails, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.IntInternalAccountsInfoReply} returns this
 */
proto.accountmanager.IntInternalAccountsInfoReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.InternalAccountDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.InternalAccountDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.InternalAccountDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.InternalAccountDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
nickname: jspb.Message.getFieldWithDefault(msg, 3, ""),
platform: jspb.Message.getFieldWithDefault(msg, 4, ""),
readableAccountNumber: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.InternalAccountDetails}
 */
proto.accountmanager.InternalAccountDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.InternalAccountDetails;
  return proto.accountmanager.InternalAccountDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.InternalAccountDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.InternalAccountDetails}
 */
proto.accountmanager.InternalAccountDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setReadableAccountNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.InternalAccountDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.InternalAccountDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.InternalAccountDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.InternalAccountDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getReadableAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.InternalAccountDetails.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.InternalAccountDetails} returns this
 */
proto.accountmanager.InternalAccountDetails.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_number = 2;
 * @return {string}
 */
proto.accountmanager.InternalAccountDetails.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.InternalAccountDetails} returns this
 */
proto.accountmanager.InternalAccountDetails.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string nickname = 3;
 * @return {string}
 */
proto.accountmanager.InternalAccountDetails.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.InternalAccountDetails} returns this
 */
proto.accountmanager.InternalAccountDetails.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string platform = 4;
 * @return {string}
 */
proto.accountmanager.InternalAccountDetails.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.InternalAccountDetails} returns this
 */
proto.accountmanager.InternalAccountDetails.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string readable_account_number = 5;
 * @return {string}
 */
proto.accountmanager.InternalAccountDetails.prototype.getReadableAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.InternalAccountDetails} returns this
 */
proto.accountmanager.InternalAccountDetails.prototype.setReadableAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.TimelyReset.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.TimelyReset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.TimelyReset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TimelyReset.toObject = function(includeInstance, msg) {
  var f, obj = {
resetClockTime: (f = msg.getResetClockTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
drawdownResetPercent: (f = msg.getDrawdownResetPercent()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
profitResetPercent: (f = msg.getProfitResetPercent()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.TimelyReset}
 */
proto.accountmanager.TimelyReset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.TimelyReset;
  return proto.accountmanager.TimelyReset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.TimelyReset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.TimelyReset}
 */
proto.accountmanager.TimelyReset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setResetClockTime(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setDrawdownResetPercent(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setProfitResetPercent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.TimelyReset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.TimelyReset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.TimelyReset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.TimelyReset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResetClockTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getDrawdownResetPercent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitResetPercent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int64Value reset_clock_time = 1;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.accountmanager.TimelyReset.prototype.getResetClockTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.accountmanager.TimelyReset} returns this
*/
proto.accountmanager.TimelyReset.prototype.setResetClockTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.TimelyReset} returns this
 */
proto.accountmanager.TimelyReset.prototype.clearResetClockTime = function() {
  return this.setResetClockTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.TimelyReset.prototype.hasResetClockTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.DoubleValue drawdown_reset_percent = 2;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.TimelyReset.prototype.getDrawdownResetPercent = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 2));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.TimelyReset} returns this
*/
proto.accountmanager.TimelyReset.prototype.setDrawdownResetPercent = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.TimelyReset} returns this
 */
proto.accountmanager.TimelyReset.prototype.clearDrawdownResetPercent = function() {
  return this.setDrawdownResetPercent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.TimelyReset.prototype.hasDrawdownResetPercent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.DoubleValue profit_reset_percent = 3;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.TimelyReset.prototype.getProfitResetPercent = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 3));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.TimelyReset} returns this
*/
proto.accountmanager.TimelyReset.prototype.setProfitResetPercent = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.TimelyReset} returns this
 */
proto.accountmanager.TimelyReset.prototype.clearProfitResetPercent = function() {
  return this.setProfitResetPercent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.TimelyReset.prototype.hasProfitResetPercent = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetClusterListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetClusterListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetClusterListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetClusterListReq.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetClusterListReq}
 */
proto.accountmanager.AdminGetClusterListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetClusterListReq;
  return proto.accountmanager.AdminGetClusterListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetClusterListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetClusterListReq}
 */
proto.accountmanager.AdminGetClusterListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetClusterListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetClusterListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetClusterListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetClusterListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminGetClusterListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminGetClusterListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminGetClusterListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminGetClusterListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetClusterListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
clustersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminGetClusterListReply}
 */
proto.accountmanager.AdminGetClusterListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminGetClusterListReply;
  return proto.accountmanager.AdminGetClusterListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminGetClusterListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminGetClusterListReply}
 */
proto.accountmanager.AdminGetClusterListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addClusters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminGetClusterListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminGetClusterListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminGetClusterListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminGetClusterListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClustersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string clusters = 1;
 * @return {!Array<string>}
 */
proto.accountmanager.AdminGetClusterListReply.prototype.getClustersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.AdminGetClusterListReply} returns this
 */
proto.accountmanager.AdminGetClusterListReply.prototype.setClustersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AdminGetClusterListReply} returns this
 */
proto.accountmanager.AdminGetClusterListReply.prototype.addClusters = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminGetClusterListReply} returns this
 */
proto.accountmanager.AdminGetClusterListReply.prototype.clearClustersList = function() {
  return this.setClustersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminSwitchConnectionClusterReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminSwitchConnectionClusterReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminSwitchConnectionClusterReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSwitchConnectionClusterReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
cluster: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminSwitchConnectionClusterReq}
 */
proto.accountmanager.AdminSwitchConnectionClusterReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminSwitchConnectionClusterReq;
  return proto.accountmanager.AdminSwitchConnectionClusterReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminSwitchConnectionClusterReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminSwitchConnectionClusterReq}
 */
proto.accountmanager.AdminSwitchConnectionClusterReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCluster(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminSwitchConnectionClusterReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminSwitchConnectionClusterReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminSwitchConnectionClusterReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSwitchConnectionClusterReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCluster();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminSwitchConnectionClusterReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminSwitchConnectionClusterReq} returns this
 */
proto.accountmanager.AdminSwitchConnectionClusterReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cluster = 2;
 * @return {string}
 */
proto.accountmanager.AdminSwitchConnectionClusterReq.prototype.getCluster = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminSwitchConnectionClusterReq} returns this
 */
proto.accountmanager.AdminSwitchConnectionClusterReq.prototype.setCluster = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminSwitchConnectionClusterReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminSwitchConnectionClusterReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminSwitchConnectionClusterReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSwitchConnectionClusterReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminSwitchConnectionClusterReply}
 */
proto.accountmanager.AdminSwitchConnectionClusterReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminSwitchConnectionClusterReply;
  return proto.accountmanager.AdminSwitchConnectionClusterReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminSwitchConnectionClusterReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminSwitchConnectionClusterReply}
 */
proto.accountmanager.AdminSwitchConnectionClusterReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminSwitchConnectionClusterReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminSwitchConnectionClusterReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminSwitchConnectionClusterReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSwitchConnectionClusterReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.OpenTradeWarningReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.OpenTradeWarningReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.OpenTradeWarningReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.OpenTradeWarningReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.OpenTradeWarningReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
isConfig: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.OpenTradeWarningReq}
 */
proto.accountmanager.OpenTradeWarningReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.OpenTradeWarningReq;
  return proto.accountmanager.OpenTradeWarningReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.OpenTradeWarningReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.OpenTradeWarningReq}
 */
proto.accountmanager.OpenTradeWarningReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSlaveIds(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.OpenTradeWarningReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.OpenTradeWarningReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.OpenTradeWarningReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.OpenTradeWarningReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getIsConfig();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.OpenTradeWarningReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.OpenTradeWarningReq} returns this
 */
proto.accountmanager.OpenTradeWarningReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.OpenTradeWarningReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.OpenTradeWarningReq} returns this
 */
proto.accountmanager.OpenTradeWarningReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string slave_ids = 3;
 * @return {!Array<string>}
 */
proto.accountmanager.OpenTradeWarningReq.prototype.getSlaveIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountmanager.OpenTradeWarningReq} returns this
 */
proto.accountmanager.OpenTradeWarningReq.prototype.setSlaveIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.OpenTradeWarningReq} returns this
 */
proto.accountmanager.OpenTradeWarningReq.prototype.addSlaveIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.OpenTradeWarningReq} returns this
 */
proto.accountmanager.OpenTradeWarningReq.prototype.clearSlaveIdsList = function() {
  return this.setSlaveIdsList([]);
};


/**
 * optional bool is_config = 4;
 * @return {boolean}
 */
proto.accountmanager.OpenTradeWarningReq.prototype.getIsConfig = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.OpenTradeWarningReq} returns this
 */
proto.accountmanager.OpenTradeWarningReq.prototype.setIsConfig = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.OpenTradeWarningReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.OpenTradeWarningReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.OpenTradeWarningReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.OpenTradeWarningReply.toObject = function(includeInstance, msg) {
  var f, obj = {
allow: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
warning: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.OpenTradeWarningReply}
 */
proto.accountmanager.OpenTradeWarningReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.OpenTradeWarningReply;
  return proto.accountmanager.OpenTradeWarningReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.OpenTradeWarningReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.OpenTradeWarningReply}
 */
proto.accountmanager.OpenTradeWarningReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllow(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWarning(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.OpenTradeWarningReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.OpenTradeWarningReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.OpenTradeWarningReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.OpenTradeWarningReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllow();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getWarning();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool allow = 1;
 * @return {boolean}
 */
proto.accountmanager.OpenTradeWarningReply.prototype.getAllow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.OpenTradeWarningReply} returns this
 */
proto.accountmanager.OpenTradeWarningReply.prototype.setAllow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string warning = 2;
 * @return {string}
 */
proto.accountmanager.OpenTradeWarningReply.prototype.getWarning = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.OpenTradeWarningReply} returns this
 */
proto.accountmanager.OpenTradeWarningReply.prototype.setWarning = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.SymbolLotOverrideReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.SymbolLotOverrideReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.SymbolLotOverrideReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolLotOverrideReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbolIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
minLots: (f = msg.getMinLots()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLots: (f = msg.getMaxLots()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.SymbolLotOverrideReq}
 */
proto.accountmanager.SymbolLotOverrideReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.SymbolLotOverrideReq;
  return proto.accountmanager.SymbolLotOverrideReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.SymbolLotOverrideReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.SymbolLotOverrideReq}
 */
proto.accountmanager.SymbolLotOverrideReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSymbolIds(values[i]);
      }
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLots(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLots(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.SymbolLotOverrideReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.SymbolLotOverrideReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolLotOverrideReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolIdsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      3,
      f
    );
  }
  f = message.getMinLots();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLots();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SymbolLotOverrideReq} returns this
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.SymbolLotOverrideReq} returns this
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated uint32 symbol_ids = 3;
 * @return {!Array<number>}
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.getSymbolIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.accountmanager.SymbolLotOverrideReq} returns this
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.setSymbolIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.SymbolLotOverrideReq} returns this
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.addSymbolIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.SymbolLotOverrideReq} returns this
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.clearSymbolIdsList = function() {
  return this.setSymbolIdsList([]);
};


/**
 * optional google.protobuf.DoubleValue min_lots = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.getMinLots = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolLotOverrideReq} returns this
*/
proto.accountmanager.SymbolLotOverrideReq.prototype.setMinLots = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolLotOverrideReq} returns this
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.clearMinLots = function() {
  return this.setMinLots(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.hasMinLots = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lots = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.getMaxLots = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.SymbolLotOverrideReq} returns this
*/
proto.accountmanager.SymbolLotOverrideReq.prototype.setMaxLots = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.SymbolLotOverrideReq} returns this
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.clearMaxLots = function() {
  return this.setMaxLots(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.SymbolLotOverrideReq.prototype.hasMaxLots = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.SymbolLotOverrideReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.SymbolLotOverrideReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.SymbolLotOverrideReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolLotOverrideReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.SymbolLotOverrideReply}
 */
proto.accountmanager.SymbolLotOverrideReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.SymbolLotOverrideReply;
  return proto.accountmanager.SymbolLotOverrideReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.SymbolLotOverrideReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.SymbolLotOverrideReply}
 */
proto.accountmanager.SymbolLotOverrideReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.SymbolLotOverrideReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.SymbolLotOverrideReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.SymbolLotOverrideReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.SymbolLotOverrideReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminSymbolLotOverrideReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminSymbolLotOverrideReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminSymbolLotOverrideReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSymbolLotOverrideReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbolIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
minLots: (f = msg.getMinLots()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLots: (f = msg.getMaxLots()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReq}
 */
proto.accountmanager.AdminSymbolLotOverrideReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminSymbolLotOverrideReq;
  return proto.accountmanager.AdminSymbolLotOverrideReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminSymbolLotOverrideReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReq}
 */
proto.accountmanager.AdminSymbolLotOverrideReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSymbolIds(values[i]);
      }
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLots(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLots(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminSymbolLotOverrideReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminSymbolLotOverrideReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSymbolLotOverrideReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolIdsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      3,
      f
    );
  }
  f = message.getMinLots();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLots();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated uint32 symbol_ids = 3;
 * @return {!Array<number>}
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.getSymbolIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.setSymbolIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.addSymbolIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.clearSymbolIdsList = function() {
  return this.setSymbolIdsList([]);
};


/**
 * optional google.protobuf.DoubleValue min_lots = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.getMinLots = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReq} returns this
*/
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.setMinLots = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.clearMinLots = function() {
  return this.setMinLots(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.hasMinLots = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lots = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.getMaxLots = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReq} returns this
*/
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.setMaxLots = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.clearMaxLots = function() {
  return this.setMaxLots(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.AdminSymbolLotOverrideReq.prototype.hasMaxLots = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminSymbolLotOverrideReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminSymbolLotOverrideReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminSymbolLotOverrideReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSymbolLotOverrideReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReply}
 */
proto.accountmanager.AdminSymbolLotOverrideReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminSymbolLotOverrideReply;
  return proto.accountmanager.AdminSymbolLotOverrideReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminSymbolLotOverrideReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminSymbolLotOverrideReply}
 */
proto.accountmanager.AdminSymbolLotOverrideReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminSymbolLotOverrideReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminSymbolLotOverrideReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminSymbolLotOverrideReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminSymbolLotOverrideReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.DeleteSymbolLotOverrideReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.DeleteSymbolLotOverrideReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbolIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.DeleteSymbolLotOverrideReq}
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.DeleteSymbolLotOverrideReq;
  return proto.accountmanager.DeleteSymbolLotOverrideReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.DeleteSymbolLotOverrideReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.DeleteSymbolLotOverrideReq}
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSymbolIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.DeleteSymbolLotOverrideReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.DeleteSymbolLotOverrideReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolIdsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DeleteSymbolLotOverrideReq} returns this
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.DeleteSymbolLotOverrideReq} returns this
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated uint32 symbol_ids = 3;
 * @return {!Array<number>}
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.prototype.getSymbolIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.accountmanager.DeleteSymbolLotOverrideReq} returns this
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.prototype.setSymbolIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.DeleteSymbolLotOverrideReq} returns this
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.prototype.addSymbolIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.DeleteSymbolLotOverrideReq} returns this
 */
proto.accountmanager.DeleteSymbolLotOverrideReq.prototype.clearSymbolIdsList = function() {
  return this.setSymbolIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.DeleteSymbolLotOverrideReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.DeleteSymbolLotOverrideReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.DeleteSymbolLotOverrideReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteSymbolLotOverrideReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.DeleteSymbolLotOverrideReply}
 */
proto.accountmanager.DeleteSymbolLotOverrideReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.DeleteSymbolLotOverrideReply;
  return proto.accountmanager.DeleteSymbolLotOverrideReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.DeleteSymbolLotOverrideReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.DeleteSymbolLotOverrideReply}
 */
proto.accountmanager.DeleteSymbolLotOverrideReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.DeleteSymbolLotOverrideReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.DeleteSymbolLotOverrideReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.DeleteSymbolLotOverrideReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.DeleteSymbolLotOverrideReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteSymbolLotOverrideReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteSymbolLotOverrideReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbolIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteSymbolLotOverrideReq}
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteSymbolLotOverrideReq;
  return proto.accountmanager.AdminDeleteSymbolLotOverrideReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteSymbolLotOverrideReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteSymbolLotOverrideReq}
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSymbolIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteSymbolLotOverrideReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteSymbolLotOverrideReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolIdsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminDeleteSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.AdminDeleteSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated uint32 symbol_ids = 3;
 * @return {!Array<number>}
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.prototype.getSymbolIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.accountmanager.AdminDeleteSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.prototype.setSymbolIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.accountmanager.AdminDeleteSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.prototype.addSymbolIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountmanager.AdminDeleteSymbolLotOverrideReq} returns this
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReq.prototype.clearSymbolIdsList = function() {
  return this.setSymbolIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.AdminDeleteSymbolLotOverrideReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.AdminDeleteSymbolLotOverrideReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.AdminDeleteSymbolLotOverrideReply}
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.AdminDeleteSymbolLotOverrideReply;
  return proto.accountmanager.AdminDeleteSymbolLotOverrideReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.AdminDeleteSymbolLotOverrideReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.AdminDeleteSymbolLotOverrideReply}
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.AdminDeleteSymbolLotOverrideReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.AdminDeleteSymbolLotOverrideReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.AdminDeleteSymbolLotOverrideReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntSymbolExistsInAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntSymbolExistsInAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntSymbolExistsInAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSymbolExistsInAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
symbolName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntSymbolExistsInAccountReq}
 */
proto.accountmanager.IntSymbolExistsInAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntSymbolExistsInAccountReq;
  return proto.accountmanager.IntSymbolExistsInAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntSymbolExistsInAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntSymbolExistsInAccountReq}
 */
proto.accountmanager.IntSymbolExistsInAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntSymbolExistsInAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntSymbolExistsInAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntSymbolExistsInAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSymbolExistsInAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbolName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.accountmanager.IntSymbolExistsInAccountReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntSymbolExistsInAccountReq} returns this
 */
proto.accountmanager.IntSymbolExistsInAccountReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol_name = 2;
 * @return {string}
 */
proto.accountmanager.IntSymbolExistsInAccountReq.prototype.getSymbolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.IntSymbolExistsInAccountReq} returns this
 */
proto.accountmanager.IntSymbolExistsInAccountReq.prototype.setSymbolName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.IntSymbolExistsInAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.IntSymbolExistsInAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.IntSymbolExistsInAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSymbolExistsInAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.IntSymbolExistsInAccountReply}
 */
proto.accountmanager.IntSymbolExistsInAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.IntSymbolExistsInAccountReply;
  return proto.accountmanager.IntSymbolExistsInAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.IntSymbolExistsInAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.IntSymbolExistsInAccountReply}
 */
proto.accountmanager.IntSymbolExistsInAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.IntSymbolExistsInAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.IntSymbolExistsInAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.IntSymbolExistsInAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.IntSymbolExistsInAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.accountmanager.IntSymbolExistsInAccountReply.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountmanager.IntSymbolExistsInAccountReply} returns this
 */
proto.accountmanager.IntSymbolExistsInAccountReply.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.ActivateAnalyzerReq.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.ActivateAnalyzerReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.ActivateAnalyzerReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ActivateAnalyzerReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
activate: (f = msg.getActivate()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.ActivateAnalyzerReq}
 */
proto.accountmanager.ActivateAnalyzerReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.ActivateAnalyzerReq;
  return proto.accountmanager.ActivateAnalyzerReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.ActivateAnalyzerReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.ActivateAnalyzerReq}
 */
proto.accountmanager.ActivateAnalyzerReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setActivate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.ActivateAnalyzerReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.ActivateAnalyzerReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.ActivateAnalyzerReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ActivateAnalyzerReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActivate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.accountmanager.ActivateAnalyzerReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ActivateAnalyzerReq} returns this
 */
proto.accountmanager.ActivateAnalyzerReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.accountmanager.ActivateAnalyzerReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountmanager.ActivateAnalyzerReq} returns this
 */
proto.accountmanager.ActivateAnalyzerReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.BoolValue activate = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.accountmanager.ActivateAnalyzerReq.prototype.getActivate = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.accountmanager.ActivateAnalyzerReq} returns this
*/
proto.accountmanager.ActivateAnalyzerReq.prototype.setActivate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountmanager.ActivateAnalyzerReq} returns this
 */
proto.accountmanager.ActivateAnalyzerReq.prototype.clearActivate = function() {
  return this.setActivate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountmanager.ActivateAnalyzerReq.prototype.hasActivate = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountmanager.ActivateAnalyzerReply.prototype.toObject = function(opt_includeInstance) {
  return proto.accountmanager.ActivateAnalyzerReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountmanager.ActivateAnalyzerReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ActivateAnalyzerReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountmanager.ActivateAnalyzerReply}
 */
proto.accountmanager.ActivateAnalyzerReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountmanager.ActivateAnalyzerReply;
  return proto.accountmanager.ActivateAnalyzerReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountmanager.ActivateAnalyzerReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountmanager.ActivateAnalyzerReply}
 */
proto.accountmanager.ActivateAnalyzerReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountmanager.ActivateAnalyzerReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountmanager.ActivateAnalyzerReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountmanager.ActivateAnalyzerReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountmanager.ActivateAnalyzerReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.accountmanager.ConnectionType = {
  DEFAULT: 0,
  BACKUP: 1
};

goog.object.extend(exports, proto.accountmanager);
